// ========================================
// CONSTANTS & BASE DATA
// ========================================

export const BASE_ITEMS = {
  weapons: {
    // Simple Melee
    club: { weight: 2, size: [1, 2], baseValue: 0.1, icon: '🏏', damage: '1d4', damageType: 'bludgeoning', properties: ['Light'] },
    // [PASS-D APR 30 2026]: Flipped thrown weapons to stackable: false. User
    // direction (binding answer #3): weapons + armor default false; user
    // can flip per-item via EditItemDialog's Stackable toggle. The new
    // throwing_dagger entry below is the purpose-built stackable thrown
    // weapon (binding answer #2).
    dagger: { weight: 1, size: [1, 2], baseValue: 2, icon: '🗡️', damage: '1d4', damageType: 'piercing', stackable: false, properties: ['Finesse', 'Light', 'Thrown (20/60)'] },
    greatclub: { weight: 10, size: [2, 3], baseValue: 0.2, icon: '🏏', damage: '1d8', damageType: 'bludgeoning', properties: ['Two-handed'] },
    handaxe: { weight: 2, size: [1, 2], baseValue: 5, icon: '🪓', damage: '1d6', damageType: 'slashing', stackable: false, properties: ['Light', 'Thrown (20/60)'] },
    javelin: { weight: 2, size: [1, 4], baseValue: 0.5, icon: '🎯', damage: '1d6', damageType: 'piercing', stackable: false, properties: ['Thrown (30/120)'] }, // [FIX NOV 24, 2025]: 1×4 - 5-6 foot throwing spear (same as quarterstaff/spear)
    light_hammer: { weight: 2, size: [1, 2], baseValue: 2, icon: '🔨', damage: '1d4', damageType: 'bludgeoning', stackable: false, properties: ['Light', 'Thrown (20/60)'] },
    // [PASS-D APR 30 2026]: Throwing dagger — distinct purpose-built thrown
    // weapon. Binding answer #2: "A 'dagger' is a melee weapon that happens
    // to also be thrown; a 'throwing dagger' is a distinct piece of gear
    // optimized for throwing." Defaults stackable: true (purpose is the
    // throw deck). Same statline as the dagger; players who want a
    // single-throw bundle should pick this entry over the standard dagger.
    throwing_dagger: { weight: 1, size: [1, 2], baseValue: 2, icon: '🗡️', damage: '1d4', damageType: 'piercing', stackable: true, maxStack: 20, properties: ['Finesse', 'Light', 'Thrown (20/60)'] },
    mace: { weight: 4, size: [1, 2], baseValue: 5, icon: '🏏', damage: '1d6', damageType: 'bludgeoning', properties: [] },
    quarterstaff: { weight: 4, size: [1, 4], baseValue: 0.2, icon: '🏏', damage: '1d6', damageType: 'bludgeoning', properties: ['Versatile (1d8)'] },
    sickle: { weight: 2, size: [1, 2], baseValue: 1, icon: '⚔️', damage: '1d4', damageType: 'slashing', properties: ['Light'] },
    spear: { weight: 3, size: [1, 4], baseValue: 1, icon: '🎯', damage: '1d6', damageType: 'piercing', properties: ['Thrown (20/60)', 'Versatile (1d8)'] },
    // Simple Ranged
    crossbow_light: { weight: 5, size: [2, 2], baseValue: 25, icon: '🏹', damage: '1d8', damageType: 'piercing', properties: ['Ammunition (80/320)', 'Loading', 'Two-handed'], ammoType: 'crossbow_bolts' },
    // [PASS-D APR 30 2026]: Flipped dart to stackable: false (was true). Per
    // binding answer #1, "10 darts" produces 10 separate grid items.
    dart: { weight: 0.25, size: [1, 1], baseValue: 0.05, icon: '🎯', damage: '1d4', damageType: 'piercing', stackable: false, properties: ['Finesse', 'Thrown (20/60)'] },
    shortbow: { weight: 2, size: [1, 3], baseValue: 25, icon: '🏹', damage: '1d6', damageType: 'piercing', properties: ['Ammunition (80/320)', 'Two-handed'], ammoType: 'arrows' },
    sling: { weight: 0, size: [1, 1], baseValue: 0.1, icon: '🏹', damage: '1d4', damageType: 'bludgeoning', properties: ['Ammunition (30/120)'], ammoType: 'sling_bullets' },
    // Martial Melee
    battleaxe: { weight: 4, size: [1, 3], baseValue: 10, icon: '🪓', damage: '1d8', damageType: 'slashing', properties: ['Versatile (1d10)'] },
    flail: { weight: 2, size: [1, 2], baseValue: 10, icon: '⚔️', damage: '1d8', damageType: 'bludgeoning', properties: [] },
    glaive: { weight: 6, size: [1, 5], baseValue: 20, icon: '⚔️', damage: '1d10', damageType: 'slashing', properties: ['Heavy', 'Reach', 'Two-handed'] },
    greataxe: { weight: 7, size: [2, 4], baseValue: 30, icon: '🪓', damage: '1d12', damageType: 'slashing', properties: ['Heavy', 'Two-handed'] },
    greatsword: { weight: 6, size: [2, 4], baseValue: 50, icon: '⚔️', damage: '2d6', damageType: 'slashing', properties: ['Heavy', 'Two-handed'] },
    halberd: { weight: 6, size: [1, 5], baseValue: 20, icon: '⚔️', damage: '1d10', damageType: 'slashing', properties: ['Heavy', 'Reach', 'Two-handed'] },
    lance: { weight: 6, size: [1, 5], baseValue: 10, icon: '🎯', damage: '1d12', damageType: 'piercing', properties: ['Reach', 'Special'] },
    longsword: { weight: 3, size: [1, 4], baseValue: 15, icon: '⚔️', damage: '1d8', damageType: 'slashing', properties: ['Versatile (1d10)'] },
    maul: { weight: 10, size: [2, 3], baseValue: 10, icon: '🔨', damage: '2d6', damageType: 'bludgeoning', properties: ['Heavy', 'Two-handed'] },
    morningstar: { weight: 4, size: [1, 2], baseValue: 15, icon: '⚔️', damage: '1d8', damageType: 'piercing', properties: [] },
    pike: { weight: 18, size: [1, 5], baseValue: 5, icon: '🎯', damage: '1d10', damageType: 'piercing', properties: ['Heavy', 'Reach', 'Two-handed'] },
    rapier: { weight: 2, size: [1, 3], baseValue: 25, icon: '⚔️', damage: '1d8', damageType: 'piercing', properties: ['Finesse'] },
    scimitar: { weight: 3, size: [1, 3], baseValue: 25, icon: '⚔️', damage: '1d6', damageType: 'slashing', properties: ['Finesse', 'Light'] },
    shortsword: { weight: 2, size: [1, 3], baseValue: 10, icon: '⚔️', damage: '1d6', damageType: 'piercing', properties: ['Finesse', 'Light'] },
    trident: { weight: 4, size: [1, 4], baseValue: 5, icon: '🔱', damage: '1d6', damageType: 'piercing', properties: ['Thrown (20/60)', 'Versatile (1d8)'] },
    war_pick: { weight: 2, size: [1, 2], baseValue: 5, icon: '⛏️', damage: '1d8', damageType: 'piercing', properties: [] },
    warhammer: { weight: 2, size: [1, 2], baseValue: 15, icon: '🔨', damage: '1d8', damageType: 'bludgeoning', properties: ['Versatile (1d10)'] },
    whip: { weight: 3, size: [2, 2], baseValue: 2, icon: '🪢', damage: '1d4', damageType: 'slashing', properties: ['Finesse', 'Reach'] },
    // Martial Ranged
    blowgun: { weight: 1, size: [1, 2], baseValue: 10, icon: '🏹', damage: '1', damageType: 'piercing', properties: ['Ammunition (25/100)', 'Loading'], ammoType: 'blowgun_needles' },
    crossbow_hand: { weight: 3, size: [1, 1], baseValue: 75, icon: '🏹', damage: '1d6', damageType: 'piercing', properties: ['Ammunition (30/120)', 'Light', 'Loading'], ammoType: 'crossbow_bolts' },
    crossbow_heavy: { weight: 18, size: [2, 3], baseValue: 50, icon: '🏹', damage: '1d10', damageType: 'piercing', properties: ['Ammunition (100/400)', 'Heavy', 'Loading', 'Two-handed'], ammoType: 'crossbow_bolts' },
    longbow: { weight: 2, size: [1, 4], baseValue: 50, icon: '🏹', damage: '1d8', damageType: 'piercing', properties: ['Ammunition (150/600)', 'Heavy', 'Two-handed'], ammoType: 'arrows' },
    net: { weight: 3, size: [2, 2], baseValue: 1, icon: '🕸️', damage: '-', damageType: 'special', properties: ['Special', 'Thrown (5/15)'] },
    // [REMOVED APR 30 2026]: 9 redundant *_plus_N weapon rows
    // (longsword_plus_1/2/3, shortsword_plus_1, dagger_plus_1,
    // battleaxe_plus_1, warhammer_plus_1, shortbow_plus_1, longbow_plus_1)
    // were deleted because the new template resolver layer (see
    // src/services/templateResolvers.js — weapon_plus_n) generates them
    // dynamically from any base SRD weapon plus the magicalBonus property.
    // Tables F+G+H reference `template: 'weapon_plus_n', n: 1|2|3`, which
    // resolves to a random eligible weapon at roll-time. Pre-fix, only
    // these 9 hand-curated rows existed; post-fix, all ~30 SRD weapons
    // are equally weighted in the template pool.
    //
    // Special Named Weapons
    flame_tongue: {
      name: 'Flame Tongue',
      weight: 3, size: [1, 4], baseValue: 5000, icon: '🔥',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      rarity: 'rare',
      requiresAttunement: true,
      // [SPEC C TASK 11 — 2026-05-17]: Migrated from inert `feature` breadcrumb
      //   to structured triggeredEffect on on_hit. RAW DMG p.170: "extra 2d6
      //   fire damage" while ablaze. NOT gated by an ablaze-state check in v1
      //   — Flame Tongue's command-word ignite flow is deferred to v1.x with
      //   a `condition.when:'flame_tongue_active'` filter once the toggle UI
      //   ships (currently always-on once equipped, matches the inert-flag
      //   behavior). Light-emission (40ft bright / 40ft dim) is a passive
      //   description-only effect not modeled mechanically.
      effects: [
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_hit',
            payload: [
              { type: 'damageBonus', operation: 'add_dice', value: '2d6', damageType: 'fire' },
            ],
            sourceLabel: 'Flame Tongue',
        } },
      ],
      description: 'Flame Tongue Longsword (rare). Requires attunement. Bonus action to speak the command word: blade ignites and sheds bright light 40 ft / dim light 40 ft beyond. While ablaze, the weapon deals an extra 2d6 fire damage on hit. Bonus action to extinguish or expires after 1 minute. DMG p.170.'
    },
    frost_brand: {
      name: 'Frost Brand',
      weight: 3, size: [1, 4], baseValue: 2700, icon: '❄️',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      rarity: 'very rare',
      requiresAttunement: true,
      // [SPEC C TASK 11 — 2026-05-17]: Migrated the on-hit damage rider from
      //   inert `feature` breadcrumb to structured triggeredEffect. The fire-
      //   resistance grant stays as a plain `resistance` effect (always-on
      //   passive while attuned — not a trigger). RAW DMG p.171: "+1d6 cold
      //   damage on hit." Cold-weather light + fire-extinguish reaction are
      //   description-only (not modeled mechanically in v1).
      effects: [
        { type: 'resistance', value: 'fire', operation: 'grant' },
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_hit',
            payload: [
              { type: 'damageBonus', operation: 'add_dice', value: '1d6', damageType: 'cold' },
            ],
            sourceLabel: 'Frost Brand',
        } },
      ],
      description: 'Frost Brand (very rare). Requires attunement. Deals an extra 1d6 cold damage on hit. While attuned, you have resistance to fire damage. Sheds bright light 10 ft / dim light 10 ft beyond when the temperature is 0°F or colder. If a magical fire effect would extinguish a non-magical flame near you, you can absorb it as a reaction (no additional benefit). DMG p.171.'
    },
    vicious_weapon: {
      name: 'Vicious Weapon',
      weight: 3, size: [1, 4], baseValue: 350, icon: '💀',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      rarity: 'rare',
      // [SPEC C TASK 8 — 2026-05-17]: Migrated from inert `feature` breadcrumb
      //   to structured triggeredEffect on on_crit. RAW DMG p.209: "extra 7
      //   damage of the weapon's type" on a melee crit. Payload is a flat
      //   damageBonus +7 (the helper folds into customDamageBonus on the
      //   crit branch; not doubled by the crit dice math — additive on top
      //   of the already-doubled base). NOT onceThenConsume — Vicious is a
      //   permanent property of the weapon, not a charged effect.
      effects: [
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_crit',
            payload: [
              { type: 'damageBonus', operation: 'add', value: 7 },
            ],
            sourceLabel: 'Vicious Weapon',
        } },
      ],
      description: 'Vicious Weapon (rare). No attunement. When you score a critical hit on a melee attack with this weapon, the target takes an extra 7 damage of the weapon\'s type. DMG p.209.'
    },
    silvered_longsword: {
      name: 'Silvered Longsword',
      weight: 3, size: [1, 4], baseValue: 115, icon: '🌙',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      silvered: true,
      description: 'Silvered longsword (not magical). Bypasses damage resistance/immunity of creatures vulnerable to silver (lycanthropes, devils, etc.). Cost is base weapon price + 100gp for silvering. PHB p.148.'
    }
  },
  armor: {
    // Light Armor
    padded: { weight: 8, size: [2, 2], baseValue: 5, icon: '🛡️', ac: 11, maxDexMod: null, minStr: 0, stealthDisadvantage: true, armorType: 'light' },
    leather: { weight: 10, size: [2, 2], baseValue: 10, icon: '🛡️', ac: 11, maxDexMod: null, minStr: 0, stealthDisadvantage: false, armorType: 'light' },
    studded_leather: { weight: 13, size: [2, 2], baseValue: 45, icon: '🛡️', ac: 12, maxDexMod: null, minStr: 0, stealthDisadvantage: false, armorType: 'light' },
    // Medium Armor
    hide: { weight: 12, size: [2, 2], baseValue: 10, icon: '🛡️', ac: 12, maxDexMod: 2, minStr: 0, stealthDisadvantage: false, armorType: 'medium' },
    chain_shirt: { weight: 20, size: [2, 2], baseValue: 50, icon: '🛡️', ac: 13, maxDexMod: 2, minStr: 0, stealthDisadvantage: false, armorType: 'medium' },
    scale_mail: { weight: 45, size: [2, 3], baseValue: 50, icon: '🛡️', ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true, armorType: 'medium' },
    breastplate: { weight: 20, size: [2, 2], baseValue: 400, icon: '🛡️', ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: false, armorType: 'medium' },
    half_plate: { weight: 40, size: [2, 3], baseValue: 750, icon: '🛡️', ac: 15, maxDexMod: 2, minStr: 0, stealthDisadvantage: true, armorType: 'medium' },
    // Heavy Armor
    ring_mail: { weight: 40, size: [2, 3], baseValue: 30, icon: '🛡️', ac: 14, maxDexMod: 0, minStr: 0, stealthDisadvantage: true, armorType: 'heavy' },
    chain_mail: { weight: 55, size: [2, 3], baseValue: 75, icon: '🛡️', ac: 16, maxDexMod: 0, minStr: 13, stealthDisadvantage: true, armorType: 'heavy' },
    splint: { weight: 60, size: [3, 3], baseValue: 200, icon: '🛡️', ac: 17, maxDexMod: 0, minStr: 15, stealthDisadvantage: true, armorType: 'heavy' },
    plate: { weight: 65, size: [3, 3], baseValue: 1500, icon: '🛡️', ac: 18, maxDexMod: 0, minStr: 15, stealthDisadvantage: true, armorType: 'heavy' },
    // Shields
    // [FIX APR 2026 Task 47 — AC double-count]: Removed `effects` arrays from
    // shields + magical armor. effectCalculator._calculateBaseAC already adds
    // +2 for any shield (line 637) and +magicalBonus (line 642) directly; having
    // an effects array ALSO contributing via effectRegistry query was
    // double-counting. A plain shield granted +4 AC instead of +2; +1 shield
    // granted +4 instead of +3; +2 shield granted +6 instead of +4; and every
    // +N armor granted +2N instead of +N. The magicalBonus path is canonical.
    shield: {
      weight: 6, size: [2, 2], baseValue: 10, icon: '🛡️',
      acBonus: 2, armorType: 'shield', stealthDisadvantage: false
    },
    // [FIX NOV 25, 2025]: Alias for Druid starting equipment "Wooden shield"
    wooden_shield: {
      weight: 6, size: [2, 2], baseValue: 10, icon: '🛡️',
      acBonus: 2, armorType: 'shield', stealthDisadvantage: false,
      description: 'Wooden shield (functionally identical to regular shield)'
    },
    // [REMOVED APR 30 2026]: 7 redundant *_plus_N armor rows
    // (leather_plus_1, studded_leather_plus_1, chain_shirt_plus_1,
    // scale_mail_plus_1, chain_mail_plus_1, splint_plus_1, plate_plus_1)
    // and 2 redundant shield_plus_N rows (shield_plus_1, shield_plus_2)
    // were deleted because the new template resolver layer (see
    // src/services/templateResolvers.js — armor_plus_n / shield_plus_n)
    // generates them dynamically from any base SRD armor or shield plus
    // the magicalBonus property. Tables F+G+H+I reference templates
    // directly. Pre-fix, only these 9 hand-curated rows existed; post-fix,
    // all SRD armors and both shield variants are equally weighted in the
    // template pool.
    //
    // Special Armor
    mithral_chain_shirt: { weight: 10, size: [2, 2], baseValue: 820, icon: '🌟', ac: 13, maxDexMod: 2, minStr: 0, stealthDisadvantage: false, armorType: 'medium', description: 'Mithral Chain Shirt - no stealth penalty or STR requirement' },
    adamantine_splint: { weight: 60, size: [3, 3], baseValue: 3200, icon: '💎', ac: 17, maxDexMod: 0, minStr: 15, stealthDisadvantage: true, armorType: 'heavy', description: 'Adamantine Splint - crits become normal hits' },
    // Dragon Scale Mail — 10 color variants (Spec 2 / 2026-05-15, DMG p.165)
    // Each variant grants +1 AC, resistance to its dragon color's damage type,
    // and advantage on saves vs. Frightful Presence + breath weapons of dragons.
    dragon_scale_mail_black: {
      name: 'Dragon Scale Mail (Black)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'acid', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of black dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to acid damage. Action (1/dawn): focus on the armor to sense the nearest black dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_blue: {
      name: 'Dragon Scale Mail (Blue)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'lightning', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of blue dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to lightning damage. Action (1/dawn): focus on the armor to sense the nearest blue dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_brass: {
      name: 'Dragon Scale Mail (Brass)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'fire', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of brass dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to fire damage. Action (1/dawn): focus on the armor to sense the nearest brass dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_bronze: {
      name: 'Dragon Scale Mail (Bronze)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'lightning', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of bronze dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to lightning damage. Action (1/dawn): focus on the armor to sense the nearest bronze dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_copper: {
      name: 'Dragon Scale Mail (Copper)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'acid', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of copper dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to acid damage. Action (1/dawn): focus on the armor to sense the nearest copper dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_gold: {
      name: 'Dragon Scale Mail (Gold)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'fire', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of gold dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to fire damage. Action (1/dawn): focus on the armor to sense the nearest gold dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_green: {
      name: 'Dragon Scale Mail (Green)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'poison', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of green dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to poison damage. Action (1/dawn): focus on the armor to sense the nearest green dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_red: {
      name: 'Dragon Scale Mail (Red)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'fire', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of red dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to fire damage. Action (1/dawn): focus on the armor to sense the nearest red dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_silver: {
      name: 'Dragon Scale Mail (Silver)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'cold', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of silver dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to cold damage. Action (1/dawn): focus on the armor to sense the nearest silver dragon within 30 miles. DMG p.165.'
    },
    dragon_scale_mail_white: {
      name: 'Dragon Scale Mail (White)',
      weight: 45, size: [2, 3], baseValue: 4000, icon: '🐉',
      ac: 14, maxDexMod: 2, minStr: 0, stealthDisadvantage: true,
      armorType: 'medium',
      rarity: 'very rare',
      requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'resistance', value: 'cold', operation: 'grant' },
        { type: 'advantage', target: 'save:dragon_frightful_presence', operation: 'advantage' },
        { type: 'advantage', target: 'save:dragon_breath_weapon', operation: 'advantage' }
      ],
      description: 'Made of white dragon scales. While wearing, you gain +1 AC, advantage on saves against the Frightful Presence and breath weapons of dragons, and resistance to cold damage. Action (1/dawn): focus on the armor to sense the nearest white dragon within 30 miles. DMG p.165.'
    }
  },
  items: {
    // Adventuring Gear
    abacus: { weight: 2, size: [1, 1], baseValue: 2, icon: '🧮' },
    ball_bearings: { weight: 2, size: [1, 1], baseValue: 1, icon: '⚫' },
    bedroll: { weight: 7, size: [2, 2], baseValue: 1, icon: '🛏️' }, // [FIX NOV 24, 2025]: 2×2 - rolled sleeping bag is compact, not tall
    bell: { weight: 0, size: [1, 1], baseValue: 1, icon: '🔔' },
    blanket: { weight: 3, size: [2, 2], baseValue: 0.5, icon: '🛏️' },
    block_tackle: { weight: 5, size: [2, 2], baseValue: 1, icon: '⚙️' },
    book: { weight: 5, size: [1, 2], baseValue: 25, icon: '📚' },
    bottle_glass: { weight: 2, size: [1, 1], baseValue: 2, icon: '🍾' },
    caltrops: { weight: 2, size: [1, 1], baseValue: 1, icon: '📍' },
    candle: { weight: 0, size: [1, 1], baseValue: 0.01, icon: '🕯️' },
    chain_10ft: { weight: 10, size: [2, 2], baseValue: 5, icon: '⛓️' },
    chalk: { weight: 0, size: [1, 1], baseValue: 0.01, icon: '✏️' },
    climbers_kit: { weight: 12, size: [2, 2], baseValue: 25, icon: '🧗' },
    clothes_common: { weight: 3, size: [2, 2], baseValue: 0.5, icon: '👕' },
    clothes_costume: { weight: 4, size: [2, 2], baseValue: 5, icon: '🎭' },
    clothes_fine: { weight: 6, size: [2, 2], baseValue: 15, icon: '👔' },
    clothes_travelers: { weight: 4, size: [2, 2], baseValue: 2, icon: '🧥' },
    // [REMOVED NOV 25, 2025]: component_pouch moved to spell_components category (has container properties there)

    // Spell Components
    // [FIX JAN 13, 2026]: Added providesFocus property for property-based detection (ARC-014)
    arcane_focus: { weight: 1, size: [1, 1], baseValue: 10, icon: '🔮', description: 'Crystal, orb, rod, staff, or wand - replaces non-costly material components', providesFocus: true, focusType: 'arcane' },
    holy_symbol: { weight: 1, size: [1, 1], baseValue: 5, icon: '✝️', description: 'Amulet or emblem - divine focus for clerics and paladins', providesFocus: true, focusType: 'divine' },
    druidic_focus: { weight: 0, size: [1, 1], baseValue: 5, icon: '🌿', description: 'Sprig of mistletoe, totem, wooden staff, or yew wand', providesFocus: true, focusType: 'druidic' },
    
    // Common Spell Components (Q12 2026-05-16: 12 cross-bucket dups removed —
    //   bat_guano, sulfur, iron_filings, silver_dust, incense, pearl_100gp,
    //   diamond_50gp/300/500/1000, ruby_dust_50gp, gold_dust_25gp now live
    //   only in spell_components bucket. The 4 remaining items below are
    //   `items`-only — they don't have a spell_components duplicate.)
    phosphorus: { weight: 0.01, size: [1, 1], baseValue: 0.1, icon: '✨', description: 'Component for light and fire spells' },
    charcoal: { weight: 0.5, size: [1, 1], baseValue: 0.01, icon: '⬛', description: 'Component for Find Familiar and other spells' },
    herbs: { weight: 0.1, size: [1, 1], baseValue: 0.5, icon: '🌿', description: 'Component for various nature spells' },

    // Valuable Spell Components
    jade_dust_10gp: { weight: 0.01, size: [1, 1], baseValue: 10, icon: '🟢', description: 'Jade dust worth 10gp - component for various spells' },
    crowbar: { weight: 5, size: [1, 2], baseValue: 2, icon: '🔧' },
    fishing_tackle: { weight: 4, size: [2, 2], baseValue: 1, icon: '🎣' },
    flask: { weight: 1, size: [1, 1], baseValue: 0.02, icon: '🍶' },
    grappling_hook: { weight: 4, size: [1, 2], baseValue: 2, icon: '🪝' },
    hammer: { weight: 3, size: [1, 2], baseValue: 1, icon: '🔨' },
    hammer_sledge: { weight: 10, size: [2, 3], baseValue: 2, icon: '🔨' },
    healers_kit: { weight: 3, size: [1, 2], baseValue: 5, icon: '🩹' },
    hourglass: { weight: 1, size: [1, 1], baseValue: 25, icon: '⏳' },
    hunting_trap: { weight: 25, size: [2, 2], baseValue: 5, icon: '🪤' },
    ink: { weight: 0, size: [1, 1], baseValue: 10, icon: '🖋️' },
    ink_pen: { weight: 0, size: [1, 1], baseValue: 0.02, icon: '✒️' },
    jug: { weight: 4, size: [2, 2], baseValue: 0.02, icon: '🏺' },
    ladder_10ft: { weight: 25, size: [1, 5], baseValue: 0.1, icon: '🪜' },
    lamp: { weight: 1, size: [1, 1], baseValue: 0.5, icon: '🏮' },
    lock: { weight: 1, size: [1, 1], baseValue: 10, icon: '🔒' },
    mess_kit: { weight: 1, size: [1, 1], baseValue: 0.2, icon: '🍽️' },
    oil_flask: { weight: 1, size: [1, 1], baseValue: 0.1, icon: '🛢️' },
    paper: { weight: 0, size: [1, 1], baseValue: 0.2, icon: '📄' },
    parchment: { weight: 0, size: [1, 1], baseValue: 0.1, icon: '📜' },
    perfume: { weight: 0, size: [1, 1], baseValue: 5, icon: '🍾' },
    pick_miners: { weight: 10, size: [1, 3], baseValue: 2, icon: '⛏️' },
    piton: { weight: 0.25, size: [1, 1], baseValue: 0.05, icon: '📍' },
    poison_basic: { weight: 0, size: [1, 1], baseValue: 100, icon: '☠️' },
    pole_10ft: { weight: 7, size: [1, 5], baseValue: 0.05, icon: '🏏' },
    pot_iron: { weight: 10, size: [2, 2], baseValue: 2, icon: '🍲' },
    ram_portable: { weight: 35, size: [2, 4], baseValue: 4, icon: '🏏' },
    // Q12 (2026-05-16): items.rations removed — canonical entry lives in food bucket
    robes: { weight: 4, size: [2, 2], baseValue: 1, icon: '🧙' },
    rope_hempen: { weight: 10, size: [2, 2], baseValue: 1, icon: '🪢' },
    rope_silk: { weight: 5, size: [2, 2], baseValue: 10, icon: '🪢' },
    scale_merchant: { weight: 3, size: [1, 2], baseValue: 5, icon: '⚖️' },
    sealing_wax: { weight: 0, size: [1, 1], baseValue: 0.5, icon: '🕯️' },
    shovel: { weight: 5, size: [1, 3], baseValue: 2, icon: '🪣' },
    // [EQUIPMENT FIX - NOV 23, 2025]: Removed duplicate signet_ring (kept jewelry.ring_signet with correct 50gp value)
    spellbook: { weight: 3, size: [1, 2], baseValue: 50, icon: '📖' },
    spikes_iron: { weight: 5, size: [1, 1], baseValue: 1, icon: '📍' },
    spyglass: { weight: 1, size: [1, 2], baseValue: 1000, icon: '🔭' },
    tent: { weight: 20, size: [3, 3], baseValue: 2, icon: '⛺' },
    tinderbox: { weight: 1, size: [1, 1], baseValue: 0.5, icon: '🔥' },
    torch: { weight: 1, size: [1, 2], baseValue: 0.01, icon: '🔦' },
    vial: { weight: 0, size: [1, 1], baseValue: 1, icon: '🧪' },
    waterskin: { weight: 5, size: [1, 2], baseValue: 0.2, icon: '💧' },
    whetstone: { weight: 1, size: [1, 1], baseValue: 0.01, icon: '🪨' },
    // Additional Adventuring Gear
    backpack_waterproof: { weight: 5, size: [3, 3], baseValue: 10, icon: '🎒', description: 'Waterproof explorer backpack' },
    rope_silk_50ft: { weight: 2.5, size: [2, 2], baseValue: 50, icon: '🪢', description: '50 feet of silk rope' },
    rope_hempen_50ft: { weight: 5, size: [2, 2], baseValue: 2.5, icon: '🪢', description: '50 feet of hemp rope' },
    grappling_hook_mithral: { weight: 2, size: [1, 2], baseValue: 102, icon: '🪝', description: 'Lightweight mithral grappling hook' },
    lantern_bullseye: { weight: 2, size: [1, 2], baseValue: 10, icon: '🔦', description: 'Bullseye lantern with focused beam' },
    lantern_hooded: { weight: 2, size: [1, 2], baseValue: 5, icon: '🔦', description: 'Hooded lantern for general lighting' },
    oil_lamp: { weight: 1, size: [1, 1], baseValue: 0.1, icon: '🪔', description: 'Simple oil lamp' },
    magnifying_glass: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🔍', description: 'High-quality magnifying glass' },
    manacles: { weight: 6, size: [1, 2], baseValue: 2, icon: '⛓️', description: 'Iron manacles with lock' },
    mirror_steel: { weight: 0.5, size: [1, 1], baseValue: 5, icon: '🪞', description: 'Steel mirror for signaling' },
    net_fishing: { weight: 3, size: [2, 2], baseValue: 1, icon: '🕸️', description: 'Large fishing net' },
    ink_bottle: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🖋️', description: 'Bottle of black ink' },
    parchment_sheet: { weight: 0.1, size: [1, 1], baseValue: 0.2, icon: '📜', description: 'Sheet of parchment' },
    quill_pen: { weight: 0.1, size: [1, 1], baseValue: 0.02, icon: '🪶', description: 'Writing quill' },
    spellbook_blank: { weight: 3, size: [1, 2], baseValue: 50, icon: '📓', description: 'Blank spellbook with 100 pages' },
    scroll_case: { weight: 1, size: [1, 2], baseValue: 1, icon: '📜', description: 'Leather scroll case' },
    signal_whistle: { weight: 0.1, size: [1, 1], baseValue: 0.05, icon: '📯', description: 'Silver signal whistle' },
    winter_blanket: { weight: 5, size: [2, 2], baseValue: 2, icon: '🧣', description: 'Thick winter blanket' }, // [FIX NOV 24, 2025]: 2×2 - rolled blanket is compact
    portable_ram: { weight: 35, size: [2, 4], baseValue: 4, icon: '🐏', description: 'Portable battering ram' },

    // [EQUIPMENT FIX - NOV 23, 2025]: Background-specific items for character creation
    // Acolyte background items
    prayer_book: { weight: 2, size: [1, 2], baseValue: 10, icon: '📖', description: 'Book of prayers and religious texts' },
    prayer_wheel: { weight: 1, size: [1, 1], baseValue: 5, icon: '☸️', description: 'Rotating cylinder inscribed with prayers' },
    vestments: { weight: 4, size: [2, 2], baseValue: 5, icon: '👗', description: 'Ceremonial religious garments' },
    // Sage, Urchin background items
    small_knife: { weight: 0.5, size: [1, 1], baseValue: 0.5, icon: '🔪', description: 'Small utility knife' },
    // Noble background items
    scroll_pedigree: { weight: 0, size: [1, 1], baseValue: 0, icon: '📜', description: 'Scroll of pedigree proving noble lineage' },
    // Soldier background items
    insignia: { weight: 0, size: [1, 1], baseValue: 5, icon: '🎖️', description: 'Insignia of rank from military service' },
    // Charlatan background items (con tools)
    weighted_dice: { weight: 0, size: [1, 1], baseValue: 10, icon: '🎲', description: 'Weighted dice for cheating at games' },
    marked_cards: { weight: 0, size: [1, 1], baseValue: 10, icon: '🃏', description: 'Marked playing cards for cheating' },
    // Sailor background items
    belaying_pin: { weight: 2, size: [1, 2], baseValue: 0.1, icon: '🏏', description: 'Wooden pin used for securing ropes (can be used as club)' },
    // Urchin, Sage background items
    map: { weight: 0, size: [1, 1], baseValue: 1, icon: '🗺️', description: 'Map of a city or region' }
  },
  ammunition: {
    // [FIX NOV 25, 2025]: Added singular aliases for normalizeItemName compatibility
    // [FIX JAN 2026]: Added stackable: true for proper stacking behavior
    // [PASS-D APR 30 2026]: Added maxStack: 20 (RAW: arrows/bolts/sling
    //   bullets ship 20 per bundle). InventoryContext.addItem splits
    //   overflow into a new stack so a Bag of Holding doesn't merge into
    //   a single 1000+ entry the UI can't manage.
    // Arrows (singular alias first for findInBaseItems priority)
    // [BATCH 4 — APR 2026]: ammoType field added so consumeAmmunition matches
    //   data-drivenly. InventoryItem propagates the field per Rule 9.
    arrow: { weight: 0.05, size: [1, 1], baseValue: 0.05, icon: '🏹', stackable: true, maxStack: 20, description: 'Bundle of 20 arrows', ammoType: 'arrows' },
    arrows: { weight: 0.05, size: [1, 1], baseValue: 0.05, icon: '🏹', stackable: true, maxStack: 20, description: 'Bundle of 20 arrows', ammoType: 'arrows' },
    arrows_silvered: { weight: 0.05, size: [1, 1], baseValue: 2.05, icon: '🏹', stackable: true, maxStack: 20, description: 'Bundle of 20 silvered arrows', ammoType: 'arrows' },
    // [SPEC C TASK 9 — 2026-05-17]: 5 inert magical-ammo fields migrated to
    //   structured triggeredEffect grants. Closes the Rule 25 soft-violation
    //   the 2026-05-16-evening breadcrumb documented. Stack tracking via
    //   consumeAmmunition stays unchanged — these `itemEffects` add the
    //   damage/poison/save riders on top. `magicalBonus` / `consumable` fields
    //   are retained as UI display badges (verified callers in EquipmentPanel
    //   read magicalBonus for attack-bonus display; consumable is a UX tag).
    arrow_plus_1: {
      name: '+1 Arrow', weight: 0.05, size: [1, 1], baseValue: 25, icon: '✨', stackable: true, maxStack: 20,
      description: '+1 magical arrow. Provides +1 to attack and damage rolls; becomes nonmagical after a hit or miss. DMG p.150.',
      magicalBonus: 1, ammoType: 'arrows',
      itemEffects: [
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_hit',
            condition: { ammoTypeMatch: 'arrows' },
            payload: [
              { type: 'damageBonus', operation: 'add', value: 1 },
              { type: 'weaponAttackBonus', operation: 'add', value: 1 },
            ],
            sourceLabel: '+1 Arrow',
        } },
      ],
    },
    arrow_slaying: {
      name: 'Arrow of Slaying', weight: 0.05, size: [1, 1], baseValue: 600, icon: '💀', stackable: true, maxStack: 20, consumable: true,
      description: 'Arrow of Slaying (very rare). Magic weapon targeted at a specific creature type (e.g., dragons, giants, undead — chosen when item is created). On hit against a target of the chosen type, the target makes a DC 17 CON save or take an extra 6d10 piercing damage (half on save). Destroyed after the attack, hit or miss. DMG p.151.',
      ammoType: 'arrows',
      slayingTargetType: 'dragon', // chosen at item-create-time; RAW supports any creature type
      itemEffects: [
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_hit',
            condition: { ammoTypeMatch: 'arrows', targetTypeMatch: 'dragon' },
            payload: [
              { type: 'damageBonus', operation: 'add_dice', value: '6d10', damageType: 'piercing',
                saveDC: 17, saveAbility: 'constitution', halfOnSave: true },
            ],
            // onceThenConsume: false intentionally — consumeAmmunition already
            // decrements the stack by 1 per attack regardless of hit/miss
            // (RAW: "destroyed after the attack, hit or miss"). Setting
            // onceThenConsume: true would double-decrement via
            // consumeTriggeredSource.
            sourceLabel: 'Arrow of Slaying (vs dragon)',
        } },
      ],
    },
    // Crossbow Bolts (singular aliases for "20 bolts" normalization)
    bolt: { weight: 0.075, size: [1, 1], baseValue: 0.05, icon: '🎯', stackable: true, maxStack: 20, description: 'Bundle of 20 crossbow bolts', ammoType: 'crossbow_bolts' },
    crossbow_bolt: { weight: 0.075, size: [1, 1], baseValue: 0.05, icon: '🎯', stackable: true, maxStack: 20, description: 'Bundle of 20 crossbow bolts', ammoType: 'crossbow_bolts' },
    crossbow_bolts: { weight: 0.075, size: [1, 1], baseValue: 0.05, icon: '🎯', stackable: true, maxStack: 20, description: 'Bundle of 20 crossbow bolts', ammoType: 'crossbow_bolts' },
    crossbow_bolts_silvered: { weight: 0.075, size: [1, 1], baseValue: 2.05, icon: '🎯', stackable: true, maxStack: 20, description: 'Bundle of 20 silvered bolts', ammoType: 'crossbow_bolts' },
    bolt_plus_1: {
      name: '+1 Crossbow Bolt', weight: 0.075, size: [1, 1], baseValue: 25, icon: '✨', stackable: true, maxStack: 20,
      description: '+1 magical crossbow bolt. Provides +1 to attack and damage rolls; becomes nonmagical after a hit or miss. DMG p.150.',
      magicalBonus: 1, ammoType: 'crossbow_bolts',
      itemEffects: [
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_hit',
            condition: { ammoTypeMatch: 'crossbow_bolts' },
            payload: [
              { type: 'damageBonus', operation: 'add', value: 1 },
              { type: 'weaponAttackBonus', operation: 'add', value: 1 },
            ],
            sourceLabel: '+1 Crossbow Bolt',
        } },
      ],
    },
    // Sling Bullets
    sling_bullet: { weight: 0.075, size: [1, 1], baseValue: 0.02, icon: '🪨', stackable: true, maxStack: 20, description: 'Bundle of 20 sling bullets', ammoType: 'sling_bullets' },
    sling_bullets: { weight: 0.075, size: [1, 1], baseValue: 0.02, icon: '🪨', stackable: true, maxStack: 20, description: 'Bundle of 20 sling bullets', ammoType: 'sling_bullets' },
    // Special Ammunition (different bundle sizes — 50 / 10)
    blowgun_needles: { weight: 0.02, size: [1, 1], baseValue: 0.02, icon: '📍', stackable: true, maxStack: 50, description: 'Bundle of 50 blowgun needles', ammoType: 'blowgun_needles' },
    blowgun_needles_poisoned: {
      weight: 0.02, size: [1, 1], baseValue: 50, icon: '☠️', stackable: true, maxStack: 10,
      description: 'Poisoned blowgun needles (10). Basic Poison coating: on hit, the target makes a DC 10 CON save or takes 1d4 poison damage. DMG p.258.',
      ammoType: 'blowgun_needles',
      itemEffects: [
        { type: 'triggeredEffect', operation: 'grant', value: {
            triggerId: 'on_hit',
            condition: { ammoTypeMatch: 'blowgun_needles' },
            payload: [
              { type: 'damageBonus', operation: 'add_dice', value: '1d4', damageType: 'poison',
                saveDC: 10, saveAbility: 'constitution', halfOnSave: false },
            ],
            sourceLabel: 'Poisoned Blowgun Needles',
        } },
      ],
    }
  },
  consumables: {
    // [FIX JAN 2026]: Added stackable: true for proper stacking behavior
    // [PASS-D APR 30 2026]: Per binding answer #4: "add maxStack: 99 to
    //   potions/scrolls". Default consumables to stackable: true with a
    //   ceiling of 99 — players can flip OFF per-instance via
    //   EditItemDialog if a particular scroll holds a unique spell they
    //   want kept separate.
    // Scrolls (stackable per Pass-D; user can flip OFF in EditItemDialog
    // to keep specific named scrolls discrete).
    spell_scroll_cantrip: { name: 'Spell Scroll (Cantrip)', rarity: 'common', weight: 0.1, size: [1, 1], baseValue: 50, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a cantrip spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 13 / spell attack +5 (per the scroll, regardless of caster). DMG p.200.' },
    spell_scroll_1st_level: { name: 'Spell Scroll (1st Level)', rarity: 'common', weight: 0.1, size: [1, 1], baseValue: 50, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 1st-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 13 / spell attack +5 (per the scroll). DMG p.200.' },
    spell_scroll_2nd_level: { name: 'Spell Scroll (2nd Level)', rarity: 'uncommon', weight: 0.1, size: [1, 1], baseValue: 250, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 2nd-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 13 / spell attack +5 (per the scroll). DMG p.200.' },
    spell_scroll_3rd_level: { name: 'Spell Scroll (3rd Level)', rarity: 'uncommon', weight: 0.1, size: [1, 1], baseValue: 250, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 3rd-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 15 / spell attack +7 (per the scroll). DMG p.200.' },
    spell_scroll_4th_level: { name: 'Spell Scroll (4th Level)', rarity: 'rare', weight: 0.1, size: [1, 1], baseValue: 2500, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 4th-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 15 / spell attack +7 (per the scroll). DMG p.200.' },
    // [APR 30 2026]: DMG p.139 spell scroll levels 5-9 — referenced by tables C/D/E.
    spell_scroll_5th_level: { name: 'Spell Scroll (5th Level)', rarity: 'rare', weight: 0.1, size: [1, 1], baseValue: 2500, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 5th-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 17 / spell attack +9 (per the scroll). DMG p.200.' },
    spell_scroll_6th_level: { name: 'Spell Scroll (6th Level)', rarity: 'very rare', weight: 0.1, size: [1, 1], baseValue: 25000, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 6th-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 17 / spell attack +9 (per the scroll). DMG p.200.' },
    spell_scroll_7th_level: { name: 'Spell Scroll (7th Level)', rarity: 'very rare', weight: 0.1, size: [1, 1], baseValue: 25000, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 7th-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 18 / spell attack +10 (per the scroll). DMG p.200.' },
    spell_scroll_8th_level: { name: 'Spell Scroll (8th Level)', rarity: 'very rare', weight: 0.1, size: [1, 1], baseValue: 25000, icon: '📜', stackable: true, maxStack: 99, description: 'Contains an 8th-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 18 / spell attack +10 (per the scroll). DMG p.200.' },
    spell_scroll_9th_level: { name: 'Spell Scroll (9th Level)', rarity: 'legendary', weight: 0.1, size: [1, 1], baseValue: 250000, icon: '📜', stackable: true, maxStack: 99, description: 'Contains a 9th-level spell. Action to read; spell is cast at its lowest level, then the scroll crumbles to dust. If the spell requires a save or attack roll, save DC 19 / spell attack +11 (per the scroll). DMG p.200.' },

    // Potions - Healing (stackable by type)
    // [FIX JAN 13, 2026]: Added effects arrays for property-based detection (ARC-014)
    // [PASS-D APR 30 2026]: Added maxStack: 99 to all consumables.
    potion_healing: {
      name: 'Potion of Healing', rarity: 'common',
      weight: 0.5, size: [1, 1], baseValue: 50, icon: '❤️', stackable: true, maxStack: 99,
      effects: [{ type: 'healing', operation: 'roll', value: '2d4+2' }],
      description: 'You regain 2d4 + 2 hit points when you drink this potion. PHB p.153 / DMG p.188.'
    },
    potion_greater_healing: {
      name: 'Potion of Greater Healing', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '💖', stackable: true, maxStack: 99,
      effects: [{ type: 'healing', operation: 'roll', value: '4d4+4' }],
      description: 'You regain 4d4 + 4 hit points when you drink this potion. DMG p.187.'
    },
    potion_superior_healing: {
      name: 'Potion of Superior Healing', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 450, icon: '💝', stackable: true, maxStack: 99,
      effects: [{ type: 'healing', operation: 'roll', value: '8d4+8' }],
      description: 'You regain 8d4 + 8 hit points when you drink this potion. DMG p.187.'
    },
    potion_supreme_healing: {
      name: 'Potion of Supreme Healing', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 1350, icon: '💗', stackable: true, maxStack: 99,
      effects: [{ type: 'healing', operation: 'roll', value: '10d4+20' }],
      description: 'You regain 10d4 + 20 hit points when you drink this potion. DMG p.188.'
    },
    // Potions - Enhancement (stackable by type)
    potion_fire_resistance: {
      name: 'Potion of Fire Resistance', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '🔥', stackable: true, maxStack: 99,
      effects: [{ type: 'resistance', value: 'fire', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, you gain resistance to fire damage for 1 hour. DMG p.188 (Potion of Resistance — fire variant).'
    },
    potion_climbing: {
      name: 'Potion of Climbing', rarity: 'common',
      weight: 0.5, size: [1, 1], baseValue: 75, icon: '🧗', stackable: true, maxStack: 99,
      effects: [{ type: 'feature', target: 'climbSpeed', operation: 'set', value: 'walk', duration: '1 hour' }],
      description: 'When you drink this potion, you gain a climbing speed equal to your walking speed for 1 hour. During this time, you have advantage on Strength (Athletics) checks made to climb. DMG p.187.'
    },
    potion_animal_friendship: {
      name: 'Potion of Animal Friendship', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 100, icon: '🦌', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Animal Friendship', operation: 'cast', dc: 13, saveAbility: 'wisdom', duration: '1 hour' }],
      description: 'When you drink this potion, you can cast the animal friendship spell (save DC 13) for 1 hour at will. DMG p.187.'
    },
    potion_growth: {
      name: 'Potion of Growth', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '📏', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Enlarge/Reduce', operation: 'cast', value: 'enlarge', duration: '1d4 hours' }],
      description: 'When you drink this potion, you gain the "enlarge" effect of the enlarge/reduce spell for 1d4 hours (no concentration required). DMG p.188.'
    },
    potion_water_breathing: {
      name: 'Potion of Water Breathing', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 100, icon: '🫧', stackable: true, maxStack: 99,
      effects: [{ type: 'feature', target: 'waterBreathing', operation: 'grant', duration: '1 hour' }],
      description: 'You can breathe underwater for 1 hour after drinking this potion. DMG p.188.'
    },
    potion_hill_giant_strength: {
      name: 'Potion of Hill Giant Strength', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 500, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 21, duration: '1 hour' }],
      description: 'When you drink this potion, your Strength score becomes 21 for 1 hour. The potion has no effect on you if your Strength is already 21 or higher. DMG p.188.'
    },
    potion_frost_giant_strength: {
      name: 'Potion of Frost Giant Strength', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 1500, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 23, duration: '1 hour' }],
      description: 'When you drink this potion, your Strength score becomes 23 for 1 hour. The potion has no effect on you if your Strength is already 23 or higher. DMG p.188.'
    },
    potion_stone_giant_strength: {
      name: 'Potion of Stone Giant Strength', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 1500, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 23, duration: '1 hour' }],
      description: 'When you drink this potion, your Strength score becomes 23 for 1 hour. The potion has no effect on you if your Strength is already 23 or higher. DMG p.188.'
    },
    potion_fire_giant_strength: {
      name: 'Potion of Fire Giant Strength', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 2500, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 25, duration: '1 hour' }],
      description: 'When you drink this potion, your Strength score becomes 25 for 1 hour. The potion has no effect on you if your Strength is already 25 or higher. DMG p.188.'
    },
    potion_cloud_giant_strength: {
      name: 'Potion of Cloud Giant Strength', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 5000, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 27, duration: '1 hour' }],
      description: 'When you drink this potion, your Strength score becomes 27 for 1 hour. The potion has no effect on you if your Strength is already 27 or higher. DMG p.188.'
    },
    potion_storm_giant_strength: {
      name: 'Potion of Storm Giant Strength', rarity: 'legendary',
      weight: 0.5, size: [1, 1], baseValue: 10000, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 29, duration: '1 hour' }],
      description: 'When you drink this potion, your Strength score becomes 29 for 1 hour. The potion has no effect on you if your Strength is already 29 or higher. DMG p.188.'
    },
    potion_resistance: {
      name: 'Potion of Resistance', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 100, icon: '🛡️', stackable: true, maxStack: 99,
      effects: [{ type: 'resistance', value: 'chosen', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, you gain resistance to one type of damage for 1 hour. The DM chooses the type or determines it randomly from the options below: acid, cold, fire, force, lightning, necrotic, poison, psychic, radiant, thunder. DMG p.188.'
    },
    potion_poison: {
      name: 'Potion of Poison', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 100, icon: '☠️', stackable: true, maxStack: 99,
      effects: [
        { type: 'damage', operation: 'roll', value: '3d6', damageType: 'poison' },
        { type: 'condition', target: 'poisoned', operation: 'grant', saveDC: 13, saveAbility: 'con', recurringDamage: '3d6', damageType: 'poison' }
      ],
      description: 'Looks/smells/tastes like a Potion of Healing but is poison. When drunk: take 3d6 poison damage, and DC 13 Constitution save or be poisoned. While poisoned this way, take 3d6 poison damage at the start of each of your turns; repeat the save at the end of each turn to end the effect. DMG p.188.'
    },
    potion_cold_resistance: {
      name: 'Potion of Cold Resistance', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '❄️', stackable: true, maxStack: 99,
      effects: [{ type: 'resistance', value: 'cold', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, you gain resistance to cold damage for 1 hour. DMG p.188 (Potion of Resistance — cold variant).'
    },
    potion_lightning_resistance: {
      name: 'Potion of Lightning Resistance', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '⚡', stackable: true, maxStack: 99,
      effects: [{ type: 'resistance', value: 'lightning', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, you gain resistance to lightning damage for 1 hour. DMG p.188 (Potion of Resistance — lightning variant).'
    },
    potion_poison_resistance: {
      name: 'Potion of Poison Resistance', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '☠️', stackable: true, maxStack: 99,
      effects: [{ type: 'resistance', value: 'poison', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, you gain resistance to poison damage for 1 hour. DMG p.188 (Potion of Resistance — poison variant).'
    },
    potion_acid_resistance: {
      name: 'Potion of Acid Resistance', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '🧪', stackable: true, maxStack: 99,
      effects: [{ type: 'resistance', value: 'acid', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, you gain resistance to acid damage for 1 hour. DMG p.188 (Potion of Resistance — acid variant).'
    },
    // Legacy alias — matches potion_hill_giant_strength (STR 21, Uncommon). Kept for
    // back-compat with App.jsx shop-loot tables that reference 'potion_giant_strength'.
    // New content should reference potion_hill_giant_strength directly.
    potion_giant_strength: {
      name: 'Potion of Giant Strength (Hill, legacy alias)', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 200, icon: '💪', stackable: true, maxStack: 99,
      effects: [{ type: 'ability', target: 'str', operation: 'set', value: 21, duration: '1 hour' }],
      description: 'Legacy alias for Potion of Hill Giant Strength. Your Strength score becomes 21 for 1 hour. The potion has no effect on you if your Strength is already 21 or higher. DMG p.188.'
    },
    potion_heroism: {
      name: 'Potion of Heroism', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 180, icon: '🦸', stackable: true, maxStack: 99,
      effects: [
        { type: 'tempHP', operation: 'set', value: 10, duration: '1 hour' },
        { type: 'spell', target: 'Bless', operation: 'grant', duration: '1 hour', noConcentration: true }
      ],
      description: 'For 1 hour after drinking, you gain 10 temporary hit points and are under the effect of the bless spell (no concentration required). DMG p.188.'
    },
    potion_invisibility: {
      name: 'Potion of Invisibility', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 180, icon: '👻', stackable: true, maxStack: 99,
      effects: [{ type: 'condition', target: 'invisible', operation: 'grant', duration: '1 hour' }],
      description: 'When you drink this potion, your body, along with everything you are wearing and carrying, becomes invisible for 1 hour. The effect ends early if you attack or cast a spell. DMG p.188.'
    },
    potion_flying: {
      name: 'Potion of Flying', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 500, icon: '🕊️', stackable: true, maxStack: 99,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'equal_to_walk_speed', duration: '1 hour' }],
      description: 'For 1 hour after drinking, you gain a flying speed equal to your walking speed and can hover. If airborne when the potion wears off, you fall unless you can stop the fall. DMG p.187.'
    },

    // [APR 30 2026]: DMG potions backfill — Tables A/B/C/D/E references.
    potion_fire_breath: {
      name: 'Potion of Fire Breath', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 150, icon: '🔥', stackable: true, maxStack: 99,
      effects: [{ type: 'breathWeapon', operation: 'roll', value: '4d6', damageType: 'fire', saveDC: 13, saveAbility: 'dex', duration: '1 hour', uses: 3 }],
      description: 'For 1 hour after drinking, you can use a bonus action to exhale fire at a target within 30 feet (4d6 fire, DEX save DC 13 for half). The effect ends after you exhale fire three times or after 1 hour. DMG p.187.'
    },
    potion_clairvoyance: {
      name: 'Potion of Clairvoyance', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 350, icon: '👁️', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Clairvoyance', operation: 'cast', duration: '10 minutes' }],
      description: 'When you drink this potion, you gain the effect of the clairvoyance spell. DMG p.187.'
    },
    potion_diminution: {
      name: 'Potion of Diminution', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 300, icon: '🤏', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Enlarge/Reduce', operation: 'cast', value: 'reduce', duration: '1d4 hours' }],
      description: 'When you drink this potion, you gain the "reduce" effect of the enlarge/reduce spell for 1d4 hours (no concentration required). DMG p.187.'
    },
    potion_gaseous_form: {
      name: 'Potion of Gaseous Form', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 350, icon: '💨', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Gaseous Form', operation: 'cast', duration: '1 hour' }],
      description: 'When you drink this potion, you gain the effect of the gaseous form spell for 1 hour (no concentration required) or until you end the effect as a bonus action. DMG p.188.'
    },
    potion_invulnerability: {
      name: 'Potion of Invulnerability', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 1000, icon: '🛡️', stackable: true, maxStack: 99,
      effects: [{ type: 'damageReduction', operation: 'all', duration: '1 minute' }],
      description: 'For 1 minute after drinking, you have resistance to all damage. DMG p.188.'
    },
    potion_mind_reading: {
      name: 'Potion of Mind Reading', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 350, icon: '🧠', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Detect Thoughts', operation: 'cast', dc: 13, saveAbility: 'intelligence', duration: '10 minutes' }],
      description: 'When you drink this potion, you gain the effect of the detect thoughts spell (save DC 13). DMG p.188.'
    },
    potion_speed: {
      name: 'Potion of Speed', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 5000, icon: '⚡', stackable: true, maxStack: 99,
      effects: [{ type: 'spell', target: 'Haste', operation: 'grant', duration: '1 minute', noConcentration: true }],
      description: 'When you drink this potion, you gain the effect of the haste spell for 1 minute (no concentration required). DMG p.188.'
    },
    potion_longevity: {
      name: 'Potion of Longevity', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 5000, icon: '⏳', stackable: true, maxStack: 99,
      description: 'When you drink this potion, your physical age is reduced by 1d6 + 6 years (minimum 13). Each time you subsequently drink a potion of longevity, there is a cumulative 10 percent chance that you instead age by 1d6 + 6 years. DMG p.188.'
    },
    potion_vitality: {
      name: 'Potion of Vitality', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 5000, icon: '💗', stackable: true, maxStack: 99,
      description: 'When you drink this potion, it removes any exhaustion you are suffering and cures any disease or poison affecting you. For the next 24 hours, you regain the maximum number of hit points for any Hit Die you spend. DMG p.188.'
    },
    elixir_of_health: {
      name: 'Elixir of Health', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 350, icon: '✨', stackable: true, maxStack: 99,
      description: 'When you drink this potion, it cures any disease afflicting you, and it removes the blinded, deafened, paralyzed, and poisoned conditions. DMG p.168.'
    },
    oil_of_etherealness: {
      name: 'Oil of Etherealness', rarity: 'rare',
      weight: 0.5, size: [1, 1], baseValue: 1900, icon: '🌫️', stackable: true, maxStack: 99,
      description: 'Beads of this cloudy gray oil form on the outside of its container and quickly evaporate. The oil can cover one Medium or smaller creature, along with the equipment it is wearing and carrying (one additional vial required for each size category above Medium). Applying the oil takes 10 minutes. For 1 hour after, the creature gains the effect of the etherealness spell. DMG p.183.'
    },
    oil_of_sharpness: {
      name: 'Oil of Sharpness', rarity: 'very rare',
      weight: 0.5, size: [1, 1], baseValue: 3200, icon: '⚔️', stackable: true, maxStack: 99,
      description: 'This clear, gelatinous oil sparkles with tiny, ultrathin silver shards. The oil can coat one slashing or piercing weapon or up to 5 pieces of slashing or piercing ammunition. Applying the oil takes 1 minute. For 1 hour, the coated item is magical and has a +3 bonus to attack and damage rolls. DMG p.184.'
    },
    oil_of_slipperiness: {
      name: 'Oil of Slipperiness', rarity: 'uncommon',
      weight: 0.5, size: [1, 1], baseValue: 480, icon: '🛢️', stackable: true, maxStack: 99,
      description: 'Applied to a creature or object (Medium or smaller; one extra vial per size above), the target is freed from being grappled, restrained, manacled, or otherwise restricted. The target also has effective freedom of movement for 8 hours. Alternatively, the contents can be poured on the ground to cover a 10-foot square as if a freedom of movement / grease spell — affected creatures must succeed on a DC 10 Dex save or fall prone. DMG p.184.'
    },

    // (Note: oil_slipperiness / oil_sharpness short-id stubs removed 2026-05-11 audit —
    //  canonical entries live above as oil_of_slipperiness / oil_of_sharpness with full RAW.
    //  Short-id stubs were shadowed and contributed only mismatched description text.)
    // Alchemical Items (stackable, maxStack: 99)
    alchemist_fire: { weight: 1, size: [1, 1], baseValue: 50, icon: '💥', stackable: true, maxStack: 99, description: 'Deals 1d4 fire damage on impact' },
    acid_vial: { weight: 1, size: [1, 1], baseValue: 25, icon: '🧪', stackable: true, maxStack: 99, description: 'Deals 2d6 acid damage' },
    antitoxin: { weight: 0.5, size: [1, 1], baseValue: 50, icon: '💊', stackable: true, maxStack: 99, description: 'Advantage on poison saves for 1 hour' },
    holy_water: { weight: 1, size: [1, 1], baseValue: 25, icon: '✨', stackable: true, maxStack: 99, description: 'Deals 2d6 radiant damage to undead/fiends' },
    perfume_vial: { weight: 0.1, size: [1, 1], baseValue: 5, icon: '🌸', stackable: true, maxStack: 99, description: 'Fine perfume in crystal vial' },
    soap: { weight: 0.1, size: [1, 1], baseValue: 0.02, icon: '🧼', stackable: true, maxStack: 99, description: 'Bar of scented soap' }
  },
  food: {
    // Food & Drink
    rations: { weight: 2, size: [1, 1], baseValue: 0.5, icon: '🍞', description: 'Trail rations for one day' },
    ale_mug: { weight: 1, size: [1, 1], baseValue: 0.04, icon: '🍺', description: 'Mug of ale' },
    wine_common: { weight: 1.5, size: [1, 2], baseValue: 0.2, icon: '🍷', description: 'Bottle of common wine' },
    wine_fine: { weight: 1.5, size: [1, 2], baseValue: 10, icon: '🍾', description: 'Bottle of fine wine' },
    bread_loaf: { weight: 2, size: [1, 1], baseValue: 0.02, icon: '🍞', description: 'Fresh loaf of bread' },
    cheese_wedge: { weight: 0.5, size: [1, 1], baseValue: 0.1, icon: '🧀', description: 'Wedge of hard cheese' },
    meat_preserved: { weight: 1, size: [1, 1], baseValue: 0.3, icon: '🥓', description: 'Preserved meat portions' }
  },
  jewelry: {
    // Rings
    ring_simple: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '💍', description: 'Simple gold ring', equipSlot: 'ring' },
    ring_signet: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '💍', description: 'Signet ring with family crest', equipSlot: 'ring' },
    // ring_protection moved to magic_items section below to avoid duplicate key
    ring_resistance: {
      name: 'Ring of Resistance',
      weight: 0.1, size: [1, 1], baseValue: 6000, icon: '🛡️',
      rarity: 'rare',
      description: 'Ring of Resistance (choose one damage type at attunement). DMG p.192.',
      equipSlot: 'ring',
      requiresAttunement: true,
      // [SUB-PLAN 1H-K — 2026-05-29]: Per-instance attunement-choice substrate landed.
      // RAW: damage type chosen at attunement from 14 resistance scopes.
      // The customChoices config drives a ReferencePicker (kind='damageResistanceType')
      // in EditItemDialog. On pick, resolveCustomChoiceEffects() materializes the chosen
      // type into item.effects[], which buildItemRegistrationsFromInventory (unchanged) picks up.
      // Prior [BREADCRUMB] is now fulfilled — the generic substrate is live.
      customChoices: {
        damageType: {
          kind: 'damageResistanceType',
          label: 'Resistance Type',
          emits: { type: 'resistance', operation: 'grant' }
        }
      },
      effects: []
    },
    // Necklaces & Amulets
    amulet_simple: { weight: 0.2, size: [1, 1], baseValue: 25, icon: '📿', description: 'Simple silver amulet', equipSlot: 'neck' },
    // [APR 30 2026]: amulet_health stub removed — canonical definition with
    // `effects: [{ type: 'ability', target: 'con', operation: 'set', value: 19 }]`
    // lives in BASE_ITEMS.magical_items (line ~1103). Pre-fix, the jewelry
    // stub shadowed the canonical entry because getItemDefinition() walks
    // categories in declaration order (jewelry hit before magical_items).
    // Removing the stub restores the canonical effect application.
    periapt_wisdom: {
      weight: 0.2, size: [1, 1], baseValue: 4000, icon: '🔮',
      description: 'Periapt of Wisdom (Wisdom score becomes 19 if lower)',
      equipSlot: 'neck',
      requiresAttunement: true,
      // [Phase 4b bucket 6 — APR 2026]: Wired effects array. Treat as the
      // canonical "Periapt-of-XYZ" pattern (parallel to amulet_health which sets
      // CON=19): wisdom set to 19 while attuned and worn. Note: the canonical
      // SRD periapts (Health, Proof Against Poison, Wound Closure) are different
      // items; this entry combines a homebrew-style stat-set common in 5e tables.
      effects: [
        { type: 'ability', target: 'wisdom', operation: 'set', value: 19 }
      ]
    },
    // [AUDIT 2026-05-11]: necklace_fireballs (no "of_") removed — orphan stub
    // never referenced by any consumer (App.jsx and magicItemTables.js both
    // use the canonical key `necklace_of_fireballs`). The canonical RAW
    // Necklace of Fireballs lives in BASE_ITEMS.magical_items at line ~1717.
    // Pre-removal this jewelry stub had `charges: 9` (RAW is 1d6+3 beads)
    // and a Fizban-style fixed-charge model; the magical_items entry is the
    // RAW-aligned source. Keeping both invited the same duplicate-shadowing
    // class of bug Apr 30 2026 fixed for amulet_health.
    // Earrings
    earring_silver: { weight: 0.1, size: [1, 1], baseValue: 15, icon: '💎', description: 'Silver earrings', equipSlot: 'earring' },
    earring_pearl: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '💎', description: 'Pearl earrings', equipSlot: 'earring' },
    earring_whisper: {
      weight: 0.1, size: [1, 1], baseValue: 500, icon: '👂',
      description: 'Earring of Whisper (cast Message cantrip at-will)',
      equipSlot: 'earring',
      requiresAttunement: true,
      // [Phase 4b bucket 6 — APR 2026]: Wired effects array. Grants Message at-will
      // (no slot expenditure) via the Bucket 1 atWillSpell effect type.
      effects: [
        { type: 'atWillSpell', operation: 'grant', value: 'Message' }
      ]
    },
    // Bracelets & Bracers
    bracelet_silver: { weight: 0.3, size: [1, 1], baseValue: 25, icon: '✨', description: 'Silver bracelet', equipSlot: 'wrist' },
    // Q12 (2026-05-16): jewelry.bracers_defense removed — canonical lives in
    //   magical_items bucket (line ~2413). The jewelry copy had stale
    //   weight (0.5 vs RAW 1) and a redundant `acBonus: 2` legacy field;
    //   getItemDefinition()'s bucket-order dedup was hitting the jewelry
    //   version first, so the stale weight was authoritative in production.
    bracers_archery: {
      name: 'Bracers of Archery',
      weight: 0.5, size: [1, 1], baseValue: 1500, icon: '🏹',
      rarity: 'uncommon',
      description: 'Uncommon. Requires attunement. Proficiency with the longbow and shortbow; +2 bonus to damage rolls on ranged attacks with those weapons. DMG p.156.',
      equipSlot: 'arms',
      requiresAttunement: true,
      // [Phase 4b bucket 6 — APR 2026]: Wired effects array. RAW DMG p.156:
      // While attuned and wearing, you have proficiency with longbow + shortbow,
      // and gain +2 damage on ranged-weapon attack damage rolls with those bows.
      effects: [
        { type: 'proficiency', operation: 'grant', value: 'weapon:longbow', proficiencyLevel: 1 },
        { type: 'proficiency', operation: 'grant', value: 'weapon:shortbow', proficiencyLevel: 1 },
        { type: 'feature', operation: 'grant', value: 'item_bracers_of_archery_plus_2_bow_damage' }
      ]
      // [BREADCRUMB] Combat-tracker reads the feature flag at hit-time to add
      // +2 damage when the equipped weapon is a longbow/shortbow. Generic
      // damageBonus add doesn't fit (would apply to ALL ranged attacks).
    }
  },
  tools: {
    // Artisan's Tools
    alchemist_supplies: { weight: 8, size: [2, 2], baseValue: 50, icon: '🧪' },
    brewer_supplies: { weight: 9, size: [2, 2], baseValue: 20, icon: '🍺' },
    calligrapher_supplies: { weight: 5, size: [2, 2], baseValue: 10, icon: '✒️' },
    carpenter_tools: { weight: 6, size: [2, 2], baseValue: 8, icon: '🔨' },
    cartographer_tools: { weight: 6, size: [2, 2], baseValue: 15, icon: '🗺️' },
    cobbler_tools: { weight: 5, size: [2, 2], baseValue: 5, icon: '👢' },
    cook_utensils: { weight: 8, size: [2, 2], baseValue: 1, icon: '🍳' },
    glassblower_tools: { weight: 5, size: [2, 2], baseValue: 30, icon: '🍾' },
    jeweler_tools: { weight: 2, size: [1, 2], baseValue: 25, icon: '💍' },
    leatherworker_tools: { weight: 5, size: [2, 2], baseValue: 5, icon: '🧤' },
    mason_tools: { weight: 8, size: [2, 2], baseValue: 10, icon: '🧱' },
    painter_supplies: { weight: 5, size: [2, 2], baseValue: 10, icon: '🎨' },
    potter_tools: { weight: 3, size: [2, 2], baseValue: 10, icon: '🏺' },
    smith_tools: { weight: 8, size: [2, 2], baseValue: 20, icon: '🔨' },
    tinker_tools: { weight: 10, size: [2, 2], baseValue: 50, icon: '⚙️' },
    weaver_tools: { weight: 5, size: [2, 2], baseValue: 1, icon: '🧵' },
    woodcarver_tools: { weight: 5, size: [2, 2], baseValue: 1, icon: '🪵' },
    // Gaming Sets
    dice_set: { weight: 0, size: [1, 1], baseValue: 0.1, icon: '🎲' },
    playing_card_set: { weight: 0, size: [1, 1], baseValue: 0.5, icon: '🃏' },
    // Musical Instruments
    bagpipes: { weight: 6, size: [2, 2], baseValue: 30, icon: '🎺' },
    drum: { weight: 3, size: [2, 2], baseValue: 6, icon: '🥁' },
    dulcimer: { weight: 10, size: [2, 3], baseValue: 25, icon: '🎵' },
    flute: { weight: 1, size: [1, 2], baseValue: 2, icon: '🎵' },
    lute: { weight: 2, size: [2, 2], baseValue: 35, icon: '🎸' },
    lyre: { weight: 2, size: [2, 2], baseValue: 30, icon: '🎵' },
    horn: { weight: 2, size: [1, 2], baseValue: 3, icon: '📯' },
    pan_flute: { weight: 2, size: [1, 2], baseValue: 12, icon: '🎵' },
    shawm: { weight: 1, size: [1, 2], baseValue: 2, icon: '🎺' },
    viol: { weight: 1, size: [2, 2], baseValue: 30, icon: '🎻' },
    // Other Tools
    disguise_kit: { weight: 3, size: [2, 2], baseValue: 25, icon: '🎭' },
    forgery_kit: { weight: 5, size: [2, 2], baseValue: 15, icon: '📜' },
    herbalism_kit: { weight: 3, size: [2, 2], baseValue: 5, icon: '🌿' },
    navigator_tools: { weight: 2, size: [1, 2], baseValue: 25, icon: '🧭' },
    poisoner_kit: { weight: 2, size: [2, 2], baseValue: 50, icon: '☠️' },
    thieves_tools: { weight: 1, size: [1, 1], baseValue: 25, icon: '🔓' }
  },
  art_objects: {
    // 25gp tier - Common Art Objects
    silver_ewer: { weight: 2, size: [1, 2], baseValue: 25, icon: '🏺', description: 'Ornate silver pitcher with engravings' },
    bone_dice_set: { weight: 0.1, size: [1, 1], baseValue: 25, icon: '🎲', description: 'Set of carved bone gaming dice' },
    small_mirror: { weight: 0.5, size: [1, 1], baseValue: 25, icon: '🪞', description: 'Small steel mirror in wooden frame' },
    // 50gp tier - Decorative Items
    silk_handkerchief: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🧣', description: 'Fine silk handkerchief with gold embroidery' },
    copper_chalice: { weight: 1, size: [1, 2], baseValue: 50, icon: '🏆', description: 'Ornate copper chalice with silver inlay' },
    // 100gp tier - Fine Art
    crystal_perfume_bottle: { weight: 1, size: [1, 1], baseValue: 100, icon: '🧴', description: 'Cut crystal bottle with gold stopper' },
    ivory_chess_set: { weight: 1, size: [2, 2], baseValue: 100, icon: '♛', description: 'Complete chess set carved from ivory' },
    // 250gp tier - Valuable Art
    gold_locket: { weight: 1, size: [1, 1], baseValue: 250, icon: '💰', description: 'Gold locket with painted miniature portrait' },
    silver_comb: { weight: 0.1, size: [1, 1], baseValue: 250, icon: '🪮', description: 'Silver comb decorated with moonstones' },
    brass_mug: { weight: 1, size: [1, 2], baseValue: 250, icon: '🍺', description: 'Brass mug with jade inlay' },
    // 750gp tier - Precious Art
    // [APR 30 2026]: baseValue updated 500→750 per DMG p.134 (the 750gp
    // art-object tier list explicitly includes "ceremonial electrum dagger
    // with a black pearl pommel"). Pre-update value was a hand-curated
    // approximation; saved characters reference by ID so this is safe.
    ceremonial_electrum_dagger: { weight: 1, size: [1, 3], baseValue: 750, icon: '🗡️', description: 'Electrum dagger with black pearl pommel' },
    silver_necklace: { weight: 0.1, size: [1, 1], baseValue: 500, icon: '📿', description: 'Silver necklace with pink pearls' },
    // 1000gp tier - Fine Treasure
    jeweled_gold_crown: { weight: 2, size: [2, 2], baseValue: 1000, icon: '👑', description: 'Gold crown set with rubies and sapphires' },
    jeweled_platinum_ring: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '💍', description: 'Platinum ring with flawless diamond' },
    // 2500gp tier - Royal Treasures  
    golden_orb: { weight: 3, size: [2, 2], baseValue: 2500, icon: '🔮', description: 'Solid gold orb engraved with arcane symbols' },
    platinum_bracelet: { weight: 0.5, size: [1, 1], baseValue: 2500, icon: '📿', description: 'Platinum bracelet with sapphire charms' },
    // 5000gp tier - Legendary Artifacts
    jeweled_scepter: { weight: 2, size: [1, 4], baseValue: 5000, icon: '🪄', description: 'Gold scepter topped with enormous diamond' },
    ancient_golden_chalice: { weight: 3, size: [2, 3], baseValue: 5000, icon: '🏆', description: 'Ancient golden chalice encrusted with gems' },
    // 7500gp tier - Priceless Relics
    golden_candelabra: { weight: 10, size: [2, 3], baseValue: 7500, icon: '🕯️', description: 'Ornate golden candelabra with five arms' },
    // [APR 30 2026]: baseValue updated 7500→2500. Per DMG p.134 the
    // jeweled anklet sits in the 2500gp tier; this entry was originally
    // mis-tiered. Saves reference by ID so the rebalance is safe.
    jeweled_anklet: { weight: 0.1, size: [1, 1], baseValue: 2500, icon: '💎', description: 'Platinum anklet with emerald and ruby charms' },

    // ========================================================================
    // [APR 30 2026]: DMG p.134 art-object table extension. The original
    // entries above were a hand-curated subset; the d100 art-tier tables
    // (art_25gp / art_250gp / art_750gp / art_2500gp / art_7500gp in
    // src/data/treasureRollTables.js) need ≥10 rows per tier. The entries
    // below add the canonical DMG names so each table resolves 100% to
    // BASE_ITEMS via getItemDefinition(). Pre-existing IDs (silver_ewer,
    // bone_dice_set, gold_locket, silver_comb, brass_mug, ceremonial_electrum_dagger,
    // platinum_bracelet, jeweled_anklet, jeweled_gold_crown, jeweled_platinum_ring)
    // are reused — saved characters keep working.
    // ========================================================================

    // 25gp tier additions (DMG p.134 — common art objects, completes 10/tier)
    jeweled_wooden_carving:        { weight: 1,   size: [1, 2], baseValue: 25, icon: '🪵', description: 'Jeweled wooden carving in the shape of a beast', rarity: 'common' },
    small_painting:                { weight: 0.5, size: [2, 2], baseValue: 25, icon: '🖼️', description: 'Well-made small painting of a serene landscape', rarity: 'common' },
    fine_ivory_comb:               { weight: 0.1, size: [1, 1], baseValue: 25, icon: '🪮', description: 'Fine ivory comb with worn etchings', rarity: 'common' },
    gold_trimmed_vest:             { weight: 1,   size: [2, 2], baseValue: 25, icon: '🦺', description: 'Embroidered vest with gold trim', rarity: 'common' },
    embroidered_silk_handkerchief: { weight: 0.1, size: [1, 1], baseValue: 25, icon: '🧣', description: 'Silk handkerchief with subtle embroidery', rarity: 'common' },
    gold_decorated_incense_stick:  { weight: 0.1, size: [1, 1], baseValue: 25, icon: '🪔', description: 'Incense stick decorated with gold flake', rarity: 'common' },
    lacquered_wooden_box:          { weight: 1,   size: [2, 2], baseValue: 25, icon: '📦', description: 'Lacquered wooden box with mother-of-pearl inlay', rarity: 'common' },

    // 250gp tier additions (DMG p.134 — uncommon art objects, completes 10/tier)
    gold_ring_bloodstones:         { weight: 0.1, size: [1, 1], baseValue: 250, icon: '💍', description: 'Gold ring set with bloodstones', rarity: 'uncommon' },
    carved_ivory_statuette:        { weight: 1,   size: [1, 2], baseValue: 250, icon: '🗿', description: 'Carved ivory statuette of a saintly figure', rarity: 'uncommon' },
    large_gold_bracelet:           { weight: 0.5, size: [1, 1], baseValue: 250, icon: '📿', description: 'Large gold bracelet with delicate engravings', rarity: 'uncommon' },
    silver_necklace_pendant:       { weight: 0.1, size: [1, 1], baseValue: 250, icon: '📿', description: 'Silver necklace with a gemstone pendant', rarity: 'uncommon' },
    bronze_crown:                  { weight: 2,   size: [2, 2], baseValue: 250, icon: '👑', description: 'Heavy bronze crown of an old mountain king', rarity: 'uncommon' },
    silk_robe_gold_embroidery:     { weight: 1,   size: [2, 3], baseValue: 250, icon: '🥻', description: 'Silk robe with gold embroidery', rarity: 'uncommon' },
    large_well_made_tapestry:      { weight: 5,   size: [3, 3], baseValue: 250, icon: '🖼️', description: 'Large well-made tapestry depicting a battle', rarity: 'uncommon' },

    // 750gp tier additions (DMG p.134 — uncommon/rare art objects, all 10 new)
    silver_chalice_moonstones:     { weight: 1,   size: [1, 2], baseValue: 750, icon: '🏆', description: 'Silver chalice set with moonstones', rarity: 'rare' },
    silver_steel_longsword_jet:    { weight: 3,   size: [1, 4], baseValue: 750, icon: '⚔️', description: 'Silver-plated steel longsword with a jet jewel set in the pommel', rarity: 'rare' },
    carved_harp_exotic_wood:       { weight: 5,   size: [2, 3], baseValue: 750, icon: '🎵', description: 'Carved harp of exotic wood with ivory tuning pegs', rarity: 'rare' },
    small_gold_idol:               { weight: 1,   size: [1, 1], baseValue: 750, icon: '🗿', description: 'Small gold idol of an unknown deity', rarity: 'rare' },
    gold_dragon_comb_garnet:       { weight: 0.1, size: [1, 1], baseValue: 750, icon: '🪮', description: 'Gold dragon comb with red garnet eyes', rarity: 'rare' },
    bottle_stopper_gold_amethyst:  { weight: 0.1, size: [1, 1], baseValue: 750, icon: '🍾', description: 'Bottle stopper cork embedded with gold leaf and amethysts', rarity: 'rare' },
    silver_gold_brooch:            { weight: 0.1, size: [1, 1], baseValue: 750, icon: '🪶', description: 'Silver and gold brooch with abalone shell', rarity: 'rare' },
    obsidian_statuette_gold:       { weight: 2,   size: [1, 2], baseValue: 750, icon: '🗿', description: 'Obsidian statuette with gold fittings and inlay', rarity: 'rare' },
    painted_gold_war_mask:         { weight: 1,   size: [2, 2], baseValue: 750, icon: '🎭', description: 'Painted gold war mask of a long-dead warlord', rarity: 'rare' },

    // 2500gp tier additions (DMG p.134 — rare art objects, completes 10/tier)
    gold_chain_fire_opal:          { weight: 0.5, size: [1, 1], baseValue: 2500, icon: '🔥', description: 'Fine gold chain set with a fire opal', rarity: 'rare' },
    masterpiece_painting:          { weight: 5,   size: [3, 3], baseValue: 2500, icon: '🖼️', description: 'Old masterpiece painting in a gilded frame', rarity: 'rare' },
    silk_velvet_mantle_moonstones: { weight: 2,   size: [3, 3], baseValue: 2500, icon: '🧥', description: 'Embroidered silk and velvet mantle set with numerous moonstones', rarity: 'rare' },
    embroidered_glove_jewel:       { weight: 0.1, size: [1, 1], baseValue: 2500, icon: '🧤', description: 'Embroidered glove set with jewel chips', rarity: 'rare' },
    gold_music_box:                { weight: 1,   size: [2, 2], baseValue: 2500, icon: '📦', description: 'Gold music box that plays a haunting tune', rarity: 'rare' },
    gold_circlet_aquamarines:      { weight: 0.5, size: [1, 1], baseValue: 2500, icon: '👑', description: 'Gold circlet set with four aquamarines', rarity: 'rare' },
    eye_patch_sapphire_moonstone:  { weight: 0.1, size: [1, 1], baseValue: 2500, icon: '🩹', description: 'Eye patch with mock eye set in blue sapphire and moonstone', rarity: 'rare' },
    fire_quartz_pectoral:          { weight: 1,   size: [2, 2], baseValue: 2500, icon: '🔶', description: 'Fire-quartz pectoral set in gold and platinum filigree', rarity: 'rare' },

    // 7500gp tier additions (DMG p.134 — very rare art objects, completes 10/tier)
    gold_statuette_rubies:         { weight: 2,   size: [1, 2], baseValue: 7500, icon: '🗿', description: 'Small gold statuette set with rubies', rarity: 'very rare' },
    gold_cup_emeralds:             { weight: 1,   size: [1, 2], baseValue: 7500, icon: '🏆', description: 'Gold cup set with emeralds', rarity: 'very rare' },
    gold_jewelry_box_platinum:     { weight: 2,   size: [2, 2], baseValue: 7500, icon: '📦', description: 'Gold jewelry box with platinum filigree', rarity: 'very rare' },
    painted_gold_sarcophagus:      { weight: 30,  size: [3, 3], baseValue: 7500, icon: '⚰️', description: "Painted gold child's sarcophagus", rarity: 'very rare' },
    jade_game_board_gold_pieces:   { weight: 5,   size: [2, 3], baseValue: 7500, icon: '♟️', description: 'Jade game board with solid gold playing pieces', rarity: 'very rare' },
    bejeweled_ivory_drinking_horn: { weight: 2,   size: [1, 3], baseValue: 7500, icon: '🥃', description: 'Bejeweled ivory drinking horn with gold filigree', rarity: 'very rare' },
    gold_idol_set_amethysts:       { weight: 2,   size: [1, 2], baseValue: 7500, icon: '🗿', description: 'Gold idol with amethyst eyes set in a small altar', rarity: 'very rare' },
    crystal_orb_dragon:            { weight: 1,   size: [1, 1], baseValue: 7500, icon: '🔮', description: 'Crystal orb with a tiny preserved dragon inside', rarity: 'very rare' },
    gold_scepter_diamonds:         { weight: 2,   size: [1, 4], baseValue: 7500, icon: '🪄', description: 'Gold scepter studded with diamonds', rarity: 'very rare' },
    silver_chalice_relics:         { weight: 1,   size: [1, 2], baseValue: 7500, icon: '🏆', description: 'Ornate silver chalice containing holy relics', rarity: 'very rare' },
  },
  gems: {
    // 10gp tier - Ornamental Stones
    azurite: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🔵', description: 'Deep blue ornamental stone with copper streaks' },
    banded_agate: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '⚪', description: 'Striped brown and white stone' },
    blue_quartz: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🔷', description: 'Translucent blue crystal' },
    eye_agate: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '👁️', description: 'Agate with distinctive eye pattern' },
    hematite: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '⚫', description: 'Metallic black iron oxide stone' },
    lapis_lazuli: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🔷', description: 'Deep blue stone with gold flecks' },
    malachite: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🟢', description: 'Bright green copper carbonate stone' },
    moss_agate: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🌿', description: 'Translucent stone with moss-like inclusions' },
    obsidian: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '⚫', description: 'Volcanic glass, sharp-edged black stone' },
    rhodochrosite: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '💗', description: 'Pink stone with white bands' },
    tiger_eye: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🐅', description: 'Golden-brown stone with silky luster' },
    turquoise: { weight: 0.1, size: [1, 1], baseValue: 10, icon: '🔷', description: 'Sky-blue copper phosphate stone' },
    // 50gp tier - Semi-precious Stones  
    bloodstone: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🔴', description: 'Dark green chalcedony with red spots' },
    carnelian: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🟠', description: 'Orange-red chalcedony stone' },
    chalcedony: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🤍', description: 'White translucent quartz' },
    chrysoprase: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🟢', description: 'Apple-green chalcedony' },
    citrine: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🟡', description: 'Pale yellow-brown quartz' },
    jasper: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🟤', description: 'Blue jasper with white spots' },
    moonstone: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🌙', description: 'Translucent stone with silver-white sheen' },
    onyx: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '⚫', description: 'Black agate with white bands' },
    peridot: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '💚', description: 'Olive-green olivine crystal' },
    rock_crystal: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '⚪', description: 'Clear transparent quartz crystal' },
    sardonyx: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🟤', description: 'Banded orange and white agate' },
    smoky_quartz: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '🤎', description: 'Translucent brown quartz crystal' },
    zircon: { weight: 0.1, size: [1, 1], baseValue: 50, icon: '💎', description: 'Clear colorless crystal' },
    // 100gp tier - Semi-precious Gems
    amber: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🟠', description: 'Fossilized tree resin, golden yellow' },
    amethyst: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🟣', description: 'Deep purple quartz crystal' },
    chrysoberyl: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🟡', description: 'Golden-green beryl crystal' },
    coral: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🪸', description: 'Pink or crimson coral formation' },
    fresh_water_pearl: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🤍', description: 'Lustrous white freshwater pearl' },
    garnet: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🔴', description: 'Deep red crystalline stone' },
    jade: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🟢', description: 'Light green nephrite stone' },
    jet: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '⚫', description: 'Deep black fossilized wood' },
    spinel: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '🔴', description: 'Red crystalline stone, often mistaken for ruby' },
    tourmaline: { weight: 0.1, size: [1, 1], baseValue: 100, icon: '💚', description: 'Pink-green crystalline stone' },
    // 500gp tier - Precious Gems
    alexandrite: { weight: 0.1, size: [1, 1], baseValue: 500, icon: '💜', description: 'Color-changing chrysoberyl, dark green to eggplant' },
    aquamarine: { weight: 0.1, size: [1, 1], baseValue: 500, icon: '🔷', description: 'Pale blue-green beryl crystal' },
    black_pearl: { weight: 0.1, size: [1, 1], baseValue: 500, icon: '⚫', description: 'Lustrous black saltwater pearl' },
    blue_spinel: { weight: 0.1, size: [1, 1], baseValue: 500, icon: '🔷', description: 'Deep blue spinel crystal' },
    golden_yellow_topaz: { weight: 0.1, size: [1, 1], baseValue: 500, icon: '🟡', description: 'Brilliant golden topaz' },
    // 1000gp tier - Precious Gems
    blue_sapphire: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '🔷', description: 'Clear blue corundum of exceptional quality' },
    emerald: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '💚', description: 'Brilliant green beryl crystal' },
    fire_opal: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '🔥', description: 'Fiery orange opal with internal flame' },
    opal: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '🌈', description: 'Pale opal with rainbow fire' },
    star_ruby: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '⭐', description: 'Ruby with perfect six-rayed star' },
    star_sapphire: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '⭐', description: 'Blue sapphire with perfect six-rayed star' },
    yellow_sapphire: { weight: 0.1, size: [1, 1], baseValue: 1000, icon: '🟡', description: 'Clear yellow corundum' },
    // 5000gp tier - Legendary Gems
    black_opal: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '🖤', description: 'Dark opal with brilliant multicolored fire' },
    blue_diamond: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '💎', description: 'Clear blue diamond of perfect clarity' },
    canary_diamond: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '💎', description: 'Rich yellow diamond of perfect clarity' },
    jacinth: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '🧡', description: 'Fiery orange-red zircon of exceptional size' },
    pink_diamond: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '💎', description: 'Clear pink diamond of perfect clarity' },
    ruby: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '💎', description: 'Clear red corundum of perfect quality' },
    white_diamond: { weight: 0.1, size: [1, 1], baseValue: 5000, icon: '💎', description: 'Clear white diamond of perfect clarity' }
  },
  trade_goods: {
    // Common Trade Goods (1-5gp)
    wheat_bushel: { weight: 60, size: [2, 2], baseValue: 2, icon: '🌾', description: 'Bushel of high-quality wheat grain' },
    flour_sack: { weight: 20, size: [2, 2], baseValue: 2, icon: '🍞', description: 'Large sack of milled flour' },
    salt_pound: { weight: 1, size: [1, 1], baseValue: 5, icon: '🧂', description: 'Pound of refined salt' },
    iron_ingot: { weight: 1, size: [1, 1], baseValue: 1, icon: '⚫', description: 'Bar of raw iron metal' },
    copper_ingot: { weight: 1, size: [1, 1], baseValue: 5, icon: '🟤', description: 'Bar of pure copper' },
    tin_ingot: { weight: 1, size: [1, 1], baseValue: 5, icon: '⚪', description: 'Bar of refined tin' },
    cloth_yard: { weight: 1, size: [2, 1], baseValue: 2, icon: '🧵', description: 'Yard of fine cotton cloth' },
    leather_hide: { weight: 5, size: [2, 2], baseValue: 4, icon: '🦬', description: 'Tanned leather hide' },
    // Valuable Trade Goods (10-50gp)
    silver_ingot: { weight: 1, size: [1, 1], baseValue: 10, icon: '⚪', description: 'Bar of pure silver' },
    silk_yard: { weight: 0.1, size: [2, 1], baseValue: 10, icon: '🪆', description: 'Yard of finest silk fabric' },
    cinnamon_pound: { weight: 1, size: [1, 1], baseValue: 10, icon: '🟤', description: 'Pound of exotic cinnamon bark' },
    pepper_pound: { weight: 1, size: [1, 1], baseValue: 10, icon: '⚫', description: 'Pound of black pepper spice' },
    tobacco_pound: { weight: 1, size: [1, 1], baseValue: 20, icon: '🍃', description: 'Pound of premium tobacco leaves' },
    // Precious Trade Goods (50-500gp)  
    gold_ingot: { weight: 1, size: [1, 1], baseValue: 50, icon: '🟡', description: 'Bar of pure gold' },
    platinum_ingot: { weight: 1, size: [1, 1], baseValue: 500, icon: '⚪', description: 'Bar of rare platinum' },
    saffron_ounce: { weight: 0.1, size: [1, 1], baseValue: 150, icon: '🟡', description: 'Ounce of precious saffron spice' },
    ivory_tusk: { weight: 10, size: [1, 4], baseValue: 100, icon: '🦣', description: 'Large elephant tusk ivory' }
  },
  spell_components: {
    // Spellcasting Focuses
    component_pouch: { 
      weight: 2, 
      size: [1, 1], 
      baseValue: 25, 
      icon: '👝', 
      description: 'Contains common spell components. Provides materials without cost and can store valuable components.',
      isContainer: true,
      containerCapacity: [3, 3],
      providesBasicComponents: true,
      containerType: 'component_pouch'
    },
    arcane_focus_crystal: { weight: 1, size: [1, 1], baseValue: 10, icon: '🔮', description: 'Crystal arcane focus - replaces non-costly material components', providesFocus: true, focusType: 'arcane' },
    arcane_focus_orb: { weight: 3, size: [1, 1], baseValue: 20, icon: '🔮', description: 'Glass orb arcane focus - replaces non-costly material components', providesFocus: true, focusType: 'arcane' },
    arcane_focus_rod: { weight: 2, size: [1, 2], baseValue: 15, icon: '🪄', description: 'Rod arcane focus - replaces non-costly material components', providesFocus: true, focusType: 'arcane' },
    arcane_focus_staff: { weight: 4, size: [1, 4], baseValue: 20, icon: '🏒', description: 'Staff arcane focus - replaces non-costly material components', providesFocus: true, focusType: 'arcane' },
    arcane_focus_wand: { weight: 1, size: [1, 2], baseValue: 15, icon: '🪄', description: 'Wand arcane focus - replaces non-costly material components', providesFocus: true, focusType: 'arcane' },
    holy_symbol_amulet: { weight: 1, size: [1, 1], baseValue: 5, icon: '✝️', description: 'Holy symbol amulet - divine focus for clerics and paladins', providesFocus: true, focusType: 'divine' },
    holy_symbol_emblem: { weight: 0, size: [1, 1], baseValue: 5, icon: '✝️', description: 'Holy symbol emblem on shield or armor', providesFocus: true, focusType: 'divine' },
    druidic_focus_mistletoe: { weight: 0, size: [1, 1], baseValue: 5, icon: '🌿', description: 'Sprig of mistletoe druidic focus', providesFocus: true, focusType: 'druidic' },
    
    // Common Components (under 1gp - stored as 0.1 for simplicity)
    bat_guano: { weight: 0.01, size: [1, 1], baseValue: 0.1, icon: '💩', description: 'Component for Fireball and other fire spells' },
    sulfur: { weight: 0.01, size: [1, 1], baseValue: 0.1, icon: '🟡', description: 'Component for Fireball and other fire spells' },
    phosphorescent_moss: { weight: 0.01, size: [1, 1], baseValue: 0.1, icon: '🌿', description: 'Component for Faerie Fire and light spells' },
    iron_filings: { weight: 0.1, size: [1, 1], baseValue: 0.1, icon: '⚫', description: 'Component for Lightning Bolt and electrical spells' },
    
    // Valuable Components (1-99gp)
    incense: { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🚬', description: 'Component for divination and religious spells' },
    silver_dust: { weight: 0.01, size: [1, 1], baseValue: 10, icon: '✨', description: 'Component for protection and anti-lycanthrope spells' },
    gold_dust_25gp: { weight: 0.01, size: [1, 1], baseValue: 25, icon: '🟨', description: 'Gold dust worth 25gp - component for Nondetection' },
    ruby_dust_50gp: { weight: 0.01, size: [1, 1], baseValue: 50, icon: '🔴', description: 'Ruby dust worth 50gp - component for Continual Flame' },
    
    // Expensive Components (100+gp)
    pearl_100gp: { weight: 0.01, size: [1, 1], baseValue: 100, icon: '🤍', description: 'Pearl worth 100gp - component for Identify spell' },
    diamond_50gp: { weight: 0.01, size: [1, 1], baseValue: 50, icon: '💎', description: 'Diamond worth 50gp - component for Chromatic Orb' },
    diamond_300gp: { weight: 0.02, size: [1, 1], baseValue: 300, icon: '💎', description: 'Diamond worth 300gp - component for Revivify' },
    diamond_500gp: { weight: 0.02, size: [1, 1], baseValue: 500, icon: '💎', description: 'Diamond worth 500gp - component for Raise Dead' },
    diamond_1000gp: { weight: 0.03, size: [1, 1], baseValue: 1000, icon: '💎', description: 'Diamond worth 1000gp - component for Resurrection' },
    ruby_dust_1500gp: { weight: 0.02, size: [1, 1], baseValue: 1500, icon: '🔴', description: 'Ruby dust worth 1500gp - component for Forcecage' },

    // [S1 TRACK F]: Backfill for elemental-shop roll tables
    crystal_fire: {
      name: 'Fire Crystal',
      weight: 0.5, size: [1, 1], baseValue: 50, icon: '🔥',
      description: 'A fist-sized crystal that radiates heat. Used as a focus or component for fire-based magic.',
      rarity: 'common',
      consumable: false,
      providesFocus: true, focusType: 'arcane'
    },
    crystal_ice: {
      name: 'Ice Crystal',
      weight: 0.5, size: [1, 1], baseValue: 50, icon: '❄️',
      description: 'A frost-rimed crystal that radiates cold. Used as a focus or component for cold-based magic.',
      rarity: 'common',
      consumable: false,
      providesFocus: true, focusType: 'arcane'
    },
    crystal_lightning: {
      name: 'Storm Crystal',
      weight: 0.5, size: [1, 1], baseValue: 50, icon: '⚡',
      description: 'A crackling crystal humming with electric potential.',
      rarity: 'common',
      consumable: false,
      providesFocus: true, focusType: 'arcane'
    },
    crystal_earth: {
      name: 'Earth Crystal',
      weight: 0.5, size: [1, 1], baseValue: 50, icon: '🪨',
      description: 'A dense, gritty crystal that smells of stone.',
      rarity: 'common',
      consumable: false,
      providesFocus: true, focusType: 'arcane'
    },
    elemental_essence: {
      name: 'Elemental Essence',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '✨',
      description: 'A vial of swirling elemental energy. A ritual component for binding spells.',
      rarity: 'common',
      consumable: true
    },
    binding_circle_chalk: {
      name: 'Binding Circle Chalk',
      weight: 0.5, size: [1, 1], baseValue: 75, icon: '✏️',
      description: 'Specially-prepared chalk used to inscribe binding circles for elemental rituals.',
      rarity: 'common',
      consumable: true
    }
  },
  magical_items: {
    // Wands
    // [ENHANCED]: Added charges and rechargeType for proper recharge system
    wand_magic_missiles: {
      name: 'Wand of Magic Missiles',
      weight: 1, size: [1, 2], baseValue: 8000, icon: '🪄',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      charges: 7,
      maxCharges: 7,
      rechargeType: 'dawn', // Regains 1d6+1 charges at dawn (DMG p.211)
      spells: [{ name: 'Magic Missile', level: 1, usesPerDay: 7, currentUses: 7, dc: null }],
      requiresAttunement: false,
      description: '7 charges. Action: expend 1+ charges to cast Magic Missile at slot level 1 + (charges spent - 1), max 7. Regains 1d6+1 charges at dawn; if last charge expended roll d20, on 1 the wand crumbles into ashes and is destroyed. DMG p.211.'
    },
    wand_cure_wounds: {
      name: 'Wand of Cure Wounds',
      weight: 1, size: [1, 2], baseValue: 4000, icon: '🪄',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      charges: 3,
      maxCharges: 3,
      rechargeType: 'dawn', // Regains 1d3 charges at dawn
      spells: [{ name: 'Cure Wounds', level: 1, usesPerDay: 3, currentUses: 3, dc: null }],
      requiresAttunement: false,
      description: 'This wand has 3 charges. You can use an action to expend 1 charge to cast Cure Wounds (1st level). Regains 1d3 charges at dawn.'
    },
    // Rings
    // [ENHANCED]: Added charges and rechargeType for proper recharge system
    ring_protection: {
      name: 'Ring of Protection',
      weight: 0.1, size: [1, 1], baseValue: 3500, icon: '💍',
      rarity: 'rare',
      acBonus: 1, // Keep for backward compatibility with legacy AC path
      // [Phase 4b bucket 6 — APR 2026]: Added effects array. RAW DMG p.191:
      // "+1 AC and +1 to all saving throws while attuned and wearing the ring."
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'save:strength',     operation: 'add', value: 1 },
        { type: 'save:dexterity',    operation: 'add', value: 1 },
        { type: 'save:constitution', operation: 'add', value: 1 },
        { type: 'save:intelligence', operation: 'add', value: 1 },
        { type: 'save:wisdom',       operation: 'add', value: 1 },
        { type: 'save:charisma',     operation: 'add', value: 1 },
      ],
      requiresAttunement: true,
      equipSlot: 'ring',
      description: 'Rare. Requires attunement. While wearing this ring, you gain a +1 bonus to AC and saving throws. DMG p.191.'
    },
    // Cloaks
    // [ENHANCED]: Added charges and rechargeType for proper recharge system
    // Cloak of Elvenkind: canonical entry is `cloak_of_elvenkind` (DMG p.158);
    //  duplicate stub `cloak_elvenkind` removed 2026-05-11 audit — its non-RAW
    //  mechanics (1/dawn Pass Without Trace spell-grant + charges) were never
    //  in the SRD or DMG. Legacy display-name alias survives in
    //  src/utils/equipmentResolver.js so any historical save data with the
    //  short key still renders as "Cloak of Elvenkind". See
    //  docs/audits/items/2026-05-11-cloaks.md.
    // Staffs
    // [ENHANCED]: Added charges and rechargeType for proper recharge system
    staff_healing: {
      name: 'Staff of Healing',
      weight: 4, size: [1, 5], baseValue: 13000, icon: '🏒',
      rarity: 'rare',
      charges: 10,
      maxCharges: 10,
      rechargeType: 'dawn', // Regains 1d6+4 charges at dawn (DMG p202)
      spells: [
        { name: 'Cure Wounds', level: 1, usesPerDay: 10, currentUses: 10, dc: null },
        { name: 'Lesser Restoration', level: 2, usesPerDay: 3, currentUses: 3, dc: null },
        { name: 'Mass Cure Wounds', level: 5, usesPerDay: 1, currentUses: 1, dc: null }
      ],
      requiresAttunement: true,
      equipSlot: 'mainhand',
      description: 'Rare. Requires attunement by a bard, cleric, druid, sorcerer, warlock, or wizard. 10 charges: Cure Wounds (1 charge per spell level, up to 4th), Lesser Restoration (2 charges), Mass Cure Wounds (5 charges). Regains 1d6+4 charges at dawn; on a roll of 1 on a d20 after the last charge is expended, the staff vanishes in a flash of light, lost forever. DMG p.202.'
    },

    // (Note: potion_climbing canonical entry lives in BASE_ITEMS.consumables; duplicate
    //  stub removed 2026-05-11 audit — it was shadowed by category-resolution order in
    //  _buildItemLookup and contributed only dead data. See docs/audits/items/2026-05-11-potions.md.)
    cloak_billowing: {
      name: 'Cloak of Billowing',
      weight: 1, size: [2, 3], baseValue: 50, icon: '🧥',
      rarity: 'common',
      equipSlot: 'cloak',
      description: 'Common. No attunement required. While wearing this cloak, you can use a bonus action to make it billow dramatically. XGtE p.137.'
    },
    dread_helm: {
      name: 'Dread Helm',
      weight: 2, size: [2, 2], baseValue: 60, icon: '⛑️',
      rarity: 'common',
      equipSlot: 'head',
      description: 'Common. No attunement required. This fearsome steel helm makes your eyes glow red while you wear it. DMG p.167.'
    },

    bag_of_holding: {
      name: 'Bag of Holding',
      weight: 15, size: [2, 2], baseValue: 4000, icon: '👜',
      rarity: 'uncommon',
      requiresAttunement: false,
      // Q12 (2026-05-16): weightReduction was `100` here, but the
      // InventoryItem weight formula at App.jsx:437 expects the 0–1
      // fraction scale (`weight += contained * (1 - weightReduction)`).
      // Pre-fix, 10 lb of contents would compute as -990 lb. The
      // containers-bucket bag_of_holding had `1.0` (correct) but
      // getItemDefinition()'s bucket-order dedup hit the broken
      // magical_items entry first. Container dup deleted; this entry
      // now carries the canonical scale.
      containerSlots: [10, 10], weightReduction: 1.0, containerSize: 'extradimensional', maxWeight: 500,
      description: 'Uncommon. No attunement required. This bag has an interior space considerably larger than its outside dimensions, approximately 2 ft in diameter at the mouth and 4 ft deep. It can hold up to 500 pounds, not exceeding a volume of 64 cubic feet; the bag weighs 15 lb regardless of contents. Retrieving an item is an action. If overloaded, pierced, or torn, the bag ruptures and is destroyed (contents scatter in the Astral Plane). Placing a Bag of Holding inside an extradimensional space (Heward\'s Handy Haversack, Portable Hole, another Bag of Holding) destroys both items and opens a gate to the Astral Plane in the doing. DMG p.153.'
    },
    // [ENHANCED]: Added charges and rechargeType for proper recharge system
    boots_of_speed: {
      name: 'Boots of Speed',
      weight: 1, size: [2, 2], baseValue: 4000, icon: '🥾',
      rarity: 'rare',
      charges: 1,
      maxCharges: 1,
      rechargeType: 'dawn', // Regains use at dawn
      equipSlot: 'boots',
      requiresAttunement: true,
      // [FIX JAN 13, 2026]: Added effects for property-based detection (ARC-014)
      effects: [
        { type: 'speed', operation: 'multiply', value: 2 }
      ],
      description: 'Rare. Requires attunement. Bonus action to click the heels together: walking speed is doubled, opportunity attacks against you have disadvantage, and you can take the Dash action as a bonus action. Lasts 10 minutes; can be deactivated as a bonus action. Once activated, cannot be used again until next dawn. DMG p.155.'
    },
    // [FIX JAN 13, 2026]: Added missing magic items with proper effects (ARC-014)
    // [Phase 4b bucket 6 — APR 2026]: Migrated legacy 'feature' workaround types
    // (target: 'darkvision' / 'perception_advantage' / 'stealth_advantage') to the
    // canonical 'sense' / 'advantage' types used by races + subclasses. The legacy
    // 'feature' route was orphan — no consumer queried it via that target shape;
    // the canonical types feed SensesMovementPanel + skill calculator advantage path.
    goggles_of_night: {
      name: 'Goggles of Night',
      weight: 0.5, size: [1, 1], baseValue: 1500, icon: '🥽',
      rarity: 'uncommon',
      equipSlot: 'eyes', // [SUB-PLAN 1R-eyes-data / 2026-05-27]: was 'head'; lens items moved to dedicated Eyes slot
      requiresAttunement: false,
      effects: [
        { type: 'sense', operation: 'grant', target: 'darkvision', value: 60 }
      ],
      description: 'Uncommon. No attunement required. While wearing these dark lenses, you have darkvision out to 60 feet. DMG p.172.'
    },
    eyes_of_the_eagle: {
      name: 'Eyes of the Eagle',
      weight: 0.1, size: [1, 1], baseValue: 2500, icon: '🦅',
      rarity: 'uncommon',
      equipSlot: 'eyes', // [SUB-PLAN 1R-eyes-data / 2026-05-27]: was 'head'; lens items moved to dedicated Eyes slot
      requiresAttunement: true,
      effects: [
        { type: 'advantage', operation: 'advantage', target: 'skill:perception' }
      ],
      description: 'Uncommon. Requires attunement. These crystal lenses fit over the eyes. While wearing them, you have advantage on Wisdom (Perception) checks that rely on sight. In conditions of clear visibility, you can make out details of even extremely distant creatures and objects as small as 2 feet across. DMG p.169.'
    },
    cloak_of_elvenkind: {
      name: 'Cloak of Elvenkind',
      weight: 1, size: [2, 2], baseValue: 5000, icon: '🧥',
      rarity: 'uncommon',
      equipSlot: 'cloak',
      requiresAttunement: true,
      effects: [
        { type: 'advantage', operation: 'advantage', target: 'skill:stealth' },
        { type: 'feature', operation: 'grant', value: 'cloak_of_elvenkind_perception_disadvantage_to_see' }
      ],
      description: 'Uncommon. Requires attunement. While wearing this cloak with its hood up, Wisdom (Perception) checks made to see you have disadvantage, and you have advantage on Dexterity (Stealth) checks made to hide. Pulling the hood up or down requires an action. DMG p.158.'
    },
    boots_of_elvenkind: {
      name: 'Boots of Elvenkind',
      weight: 1, size: [2, 2], baseValue: 2500, icon: '👢',
      rarity: 'uncommon',
      equipSlot: 'boots',
      requiresAttunement: false,
      effects: [
        { type: 'advantage', operation: 'advantage', target: 'skill:stealth' }
      ],
      description: 'Uncommon. No attunement required. While wearing these boots, your steps make no sound, regardless of surface. You have advantage on Dexterity (Stealth) checks that rely on moving silently. DMG p.155.'
    },
    winged_boots: {
      name: 'Winged Boots',
      weight: 1, size: [2, 2], baseValue: 8000, icon: '🪽',
      rarity: 'uncommon',
      equipSlot: 'boots',
      requiresAttunement: true,
      charges: 4,
      maxCharges: 4,
      rechargeType: 'dawn', // Regains 2 hours of flight at dawn (DMG p.214)
      effects: [
        { type: 'feature', target: 'flySpeed', operation: 'set', value: 'walk' }
      ],
      description: 'Uncommon. Requires attunement. While wearing these boots, you have a flying speed equal to your walking speed. You can use them to fly for up to 4 hours total (in 1-minute increments). If you are flying when the boots\' last minute is used, you descend at a rate of 30 feet per round until you land. The boots regain 2 hours of flying capability per dawn. DMG p.214.'
    },
    ring_of_swimming: {
      name: 'Ring of Swimming',
      weight: 0.1, size: [1, 1], baseValue: 3000, icon: '💍',
      rarity: 'uncommon',
      equipSlot: 'ring',
      requiresAttunement: false,
      effects: [
        { type: 'feature', target: 'swimSpeed', operation: 'set', value: 40, condition: 'always' }
      ],
      description: 'Uncommon. You have a swimming speed of 40 feet while wearing this ring. DMG p.193.'
    },
    robe_of_eyes: {
      name: 'Robe of Eyes',
      weight: 1, size: [2, 3], baseValue: 30000, icon: '👁️',
      rarity: 'rare',
      equipSlot: 'armor',
      requiresAttunement: true,
      // [Phase 4b bucket 6 — APR 2026]: Migrated to canonical sense/advantage types.
      effects: [
        { type: 'sense', operation: 'grant', target: 'darkvision', value: 120 },
        { type: 'sense', operation: 'grant', target: 'truesight', value: 120 },
        { type: 'advantage', operation: 'advantage', target: 'skill:perception' },
        { type: 'feature', operation: 'grant', value: 'robe_of_eyes_no_surprise' }
      ],
      description: 'Rare. Requires attunement. This robe is adorned with eyelike patterns. While you wear it, you gain the following benefits: you have advantage on Wisdom (Perception) checks that rely on sight; you have darkvision out to a range of 120 feet; you can see invisible creatures and objects, as well as see into the Ethereal Plane, out to a range of 120 feet (the eyes on the robe can\'t be closed or averted); the eyes can\'t be circumvented, so you can\'t be surprised while wearing the robe, even when blindfolded or otherwise unable to see. The Light spell cast on the robe (or a comparable effect) causes the wearer to be blinded for 1 minute (CON save DC 11 to end early). DMG p.194.'
    },
    gauntlets_ogre_power: {
      name: 'Gauntlets of Ogre Power',
      weight: 4, size: [2, 2], baseValue: 8000, icon: '🥊',
      rarity: 'uncommon',
      equipSlot: 'hands',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      // RAW DMG p.171: Strength score becomes 19 while attuned + worn. The "no effect
      // if STR ≥ 19" caveat is enforced naturally by operation: 'set' to 19 — a set
      // to a value ≤ current STR is a no-op in effectCalculator.applyOperation.
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 19,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 19, // Keep for backward compatibility
      description: 'Uncommon. Requires attunement. Your Strength score is 19 while you wear these gauntlets. They have no effect on you if your Strength without them is 19 or higher. DMG p.171.'
    },
    headband_intellect: {
      name: 'Headband of Intellect',
      weight: 0.5, size: [1, 1], baseValue: 8000, icon: '👑',
      rarity: 'uncommon',
      equipSlot: 'head',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'int',
          operation: 'set',
          value: 19,
          condition: 'always'
        }
      ],
      statBonus: 'setIntelligence', // Keep for backward compatibility
      statValue: 19, // Keep for backward compatibility
      description: 'Uncommon. Requires attunement. Your Intelligence score is 19 while you wear this headband. It has no effect on you if your Intelligence is already 19 or higher without it. DMG p.173.'
    },

    amulet_health: {
      name: 'Amulet of Health',
      weight: 0.5, size: [1, 1], baseValue: 8000, icon: '📿',
      rarity: 'rare',
      equipSlot: 'neck',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'con',
          operation: 'set',
          value: 19,
          condition: 'always'
        }
      ],
      statBonus: 'setConstitution', // Keep for backward compatibility
      statValue: 19, // Keep for backward compatibility
      description: 'Rare. Requires attunement. Your Constitution score is 19 while you wear this amulet. It has no effect on you if your Constitution is already 19 or higher. DMG p.150.'
    },
    belt_hill_giant: {
      name: 'Belt of Hill Giant Strength',
      weight: 1, size: [2, 1], baseValue: 8000, icon: '🥋',
      rarity: 'rare',
      equipSlot: 'belt',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 21,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 21, // Keep for backward compatibility
      description: 'Rare. Requires attunement. While wearing this belt, your Strength score becomes 21. The belt has no effect on you if your Strength without it is equal to or greater than 21. DMG p.155.'
    },
    belt_stone_giant: {
      name: 'Belt of Stone Giant Strength',
      weight: 1, size: [2, 1], baseValue: 12000, icon: '🥋',
      rarity: 'very rare',
      equipSlot: 'belt',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 23,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 23, // Keep for backward compatibility
      description: 'Very rare. Requires attunement. While wearing this belt, your Strength score becomes 23. The belt has no effect on you if your Strength without it is equal to or greater than 23. DMG p.155.'
    },
    cloak_displacement: {
      name: 'Cloak of Displacement',
      weight: 1, size: [2, 3], baseValue: 12000, icon: '👘',
      rarity: 'rare',
      equipSlot: 'cloak',
      requiresAttunement: true,
      description: 'Rare. Requires attunement. While you wear this cloak, it projects an illusion that makes you appear to be standing in a place near your actual location, causing any creature to have disadvantage on attack rolls against you. If you take damage, the property ceases to function until the start of your next turn. This property is suppressed while you are incapacitated, restrained, or otherwise unable to move. DMG p.158.'
    },

    belt_frost_giant: {
      name: 'Belt of Frost Giant Strength',
      weight: 1, size: [2, 1], baseValue: 20000, icon: '🥋',
      rarity: 'very rare',
      equipSlot: 'belt',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 23,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 23, // Keep for backward compatibility
      description: 'Very rare. Requires attunement. While wearing this belt, your Strength score becomes 23. The belt has no effect on you if your Strength without it is equal to or greater than 23. DMG p.155.'
    },
    belt_fire_giant: {
      name: 'Belt of Fire Giant Strength',
      weight: 1, size: [2, 1], baseValue: 32000, icon: '🥋',
      rarity: 'very rare',
      equipSlot: 'belt',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 25,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 25, // Keep for backward compatibility
      description: 'Very rare. Requires attunement. While wearing this belt, your Strength score becomes 25. The belt has no effect on you if your Strength without it is equal to or greater than 25. DMG p.155.'
    },
    manual_bodily_health: {
      name: 'Manual of Bodily Health',
      weight: 5, size: [2, 2], baseValue: 40000, icon: '📘',
      rarity: 'very rare',
      requiresAttunement: false,
      description: 'Very rare. No attunement required. This book contains health and diet tips, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book\'s contents and practicing its guidelines, your Constitution score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century. DMG p.180.'
    },
    tome_clear_thought: {
      name: 'Tome of Clear Thought',
      weight: 5, size: [2, 2], baseValue: 40000, icon: '📗',
      rarity: 'very rare',
      requiresAttunement: false,
      description: 'Very rare. No attunement required. This book contains memorization and logic exercises, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book\'s contents and practicing its guidelines, your Intelligence score increases by 2, as does your maximum for that score. The tome then loses its magic, but regains it in a century. DMG p.209.'
    },

    belt_cloud_giant: {
      name: 'Belt of Cloud Giant Strength',
      weight: 1, size: [2, 1], baseValue: 50000, icon: '🥋',
      rarity: 'legendary',
      equipSlot: 'belt',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 27,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 27, // Keep for backward compatibility
      description: 'Legendary. Requires attunement. While wearing this belt, your Strength score becomes 27. The belt has no effect on you if your Strength without it is equal to or greater than 27. DMG p.155.'
    },
    belt_storm_giant: {
      name: 'Belt of Storm Giant Strength',
      weight: 1, size: [2, 1], baseValue: 80000, icon: '🥋',
      rarity: 'legendary',
      equipSlot: 'belt',
      requiresAttunement: true,
      // [PHASE 1.3 - NOV 14, 2025]: Added unified effects schema for EffectRegistry integration
      effects: [
        {
          type: 'ability',
          target: 'str',
          operation: 'set',
          value: 29,
          condition: 'always'
        }
      ],
      statBonus: 'setStrength', // Keep for backward compatibility
      statValue: 29, // Keep for backward compatibility
      description: 'Legendary. Requires attunement. While wearing this belt, your Strength score becomes 29. The belt has no effect on you if your Strength without it is equal to or greater than 29. DMG p.155.'
    },
    // [AUDIT 2026-05-12]: robe_archmagi stub removed — canonical definition
    //  with `name`, rarity 'legendary', and full RAW description lives at
    //  `robe_of_the_archmagi` in this same magical_items object (line ~1541
    //  in the post-stub-removal state). The stub had baseValue 75000 (off
    //  from the canonical 50000) and an abbreviated description; getItemDefinition()
    //  could resolve either id, leaving the stub as an alternate lookup with
    //  drifted data. The canonical entry is `robe_of_the_archmagi`.
    //  Legacy display-name alias survives in src/utils/equipmentResolver.js if
    //  any historical save data referenced the short key.
    //  See docs/audits/items/2026-05-12-other-wondrous-catchall.md.

    // Artifacts
    orb_dragonkind: {
      name: 'Orb of Dragonkind',
      weight: 3, size: [2, 2], baseValue: 125000, icon: '🔮',
      rarity: 'artifact',
      requiresAttunement: true,
      description: 'Artifact. Requires attunement. Five Orbs of Dragonkind were created during the Dragonfall War; each remains tied to one chromatic dragon kind. While attuned and holding an orb, you can use an action to peer into its depths and call to a dragon of its color within 40 miles. The dragon arrives within 1d4 hours and is friendly to you. The orb has 7 charges; regains 1d4+3 expended charges daily at dawn. While holding it, you can use an action to expend 1 or more charges to cast one of these spells (save DC 18): Cure Wounds (5th-level, 3 charges), Daylight (1 charge), Death Ward (3 charges), Scrying (3 charges). You can also use an action to utter the orb\'s command word and force any dragon within 300 feet to make a DC 18 Charisma saving throw; on a failure, the dragon is charmed by you for 1 hour. Carries a curse: each day the attuned wielder must make a DC 17 Charisma save; on a fail, the orb\'s sentience attempts to dominate the wielder. DMG p.225.'
    },

    // [S1 TRACK F]: Backfill for shop roll tables
    // [AUDIT 2026-05-11]: necklace_of_fireballs stub removed — canonical
    // definition with neck slot + correct beads description lives in this
    // same magical_items object at line ~1717. Pre-removal, JS object-literal
    // duplicate-key semantics meant the LATER definition won at object
    // construction, leaving this earlier stub as dead code. Removing it
    // eliminates the duplicate-key footgun.
    // [AUDIT 2026-05-12]: bowl_commanding_water_elementals stub at this
    // location removed for the same reason — the LATER definition (in this
    // same magical_items object, at ~line 2150 post-removal) wins at object
    // construction. The canonical entry now carries `rarity: 'rare'` ported
    // from this stub. See docs/audits/items/2026-05-12-other-wondrous-catchall.md.
    staff_of_fire: {
      name: 'Staff of Fire',
      weight: 4, size: [1, 4], baseValue: 12000, icon: '🔥',
      rarity: 'very rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 10, maxCharges: 10, rechargeType: 'dawn', rechargeAmount: '1d6+4',
      effects: [{ type: 'resistance', value: 'fire', operation: 'grant' }],
      spells: [
        { name: 'Burning Hands', level: 1, costPerCast: 1, dc: null },
        { name: 'Fireball', level: 3, costPerCast: 3, dc: null },
        { name: 'Wall of Fire', level: 4, costPerCast: 4, dc: null }
      ],
      description: 'Very rare. Requires attunement by a druid, sorcerer, warlock, or wizard. You have resistance to fire damage while holding the staff. 10 charges: Burning Hands (1 charge, 1st level), Fireball (3 charges, 3rd level), Wall of Fire (4 charges, 4th level). Regains 1d6+4 charges at dawn; on a roll of 1 on a d20 after the last charge is expended, the staff is consumed in a flash of fire. DMG p.202.'
    },
    staff_of_frost: {
      name: 'Staff of Frost',
      weight: 4, size: [1, 4], baseValue: 12000, icon: '❄️',
      rarity: 'very rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 10, maxCharges: 10, rechargeType: 'dawn',
      effects: [{ type: 'resistance', value: 'cold', operation: 'grant' }],
      spells: [
        { name: 'Cone of Cold', level: 5, dc: null },
        { name: 'Fog Cloud', level: 1, dc: null },
        { name: 'Ice Storm', level: 4, dc: null },
        { name: 'Wall of Ice', level: 4, dc: null }
      ],
      description: 'Very rare. Requires attunement by a druid, sorcerer, warlock, or wizard. You have resistance to cold damage while holding the staff. 10 charges: Cone of Cold (5 charges, 5th level), Fog Cloud (1 charge, 1st level), Ice Storm (4 charges, 4th level), Wall of Ice (4 charges, 4th level). Regains 1d6+4 charges at dawn; on a roll of 1 on a d20 after the last charge is expended, the staff shatters and is destroyed. DMG p.202.'
    },
    // [FIX APR 2026 — SHOP BUG #4]: Six elemental_trader items referenced from the
    // shop roll table but never defined in BASE_ITEMS, causing partial inventories
    // and silent skip warnings on generation. All real DMG / supplement items.
    wand_of_lightning_bolts: {
      name: 'Wand of Lightning Bolts',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '⚡',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      spells: [
        { name: 'Lightning Bolt', level: 3, dc: null }
      ],
      description: 'Spellcaster attunement. 7 charges. Action: expend 1+ charges to cast Lightning Bolt (DC 15) at slot level 3 + (charges spent - 1), max 7. Regains 1d6+1 charges at dawn; if last charge used roll d20, on 1 the wand crumbles to dust. DMG p.212.'
    },
    elemental_gem: {
      name: 'Elemental Gem',
      weight: 0, size: [1, 1], baseValue: 500, icon: '💎',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This gem contains a mote of elemental energy. When you use an action to break the gem, an elemental (CR 5) is summoned as if you had cast the Conjure Elemental spell, and the gem\'s magic is lost. The element depends on the gem\'s composition: blue sapphire summons an Air Elemental, yellow diamond an Earth Elemental, red corundum a Fire Elemental, and emerald a Water Elemental. The summoned elemental is friendly to you and your companions; it acts on its own initiative and obeys your spoken commands. If you don\'t issue any commands, it defends itself but takes no other actions. The elemental remains for 1 hour, until it drops to 0 HP, or until you dismiss it as an action. DMG p.167.'
    },
    ring_of_fire_elemental_command: {
      name: 'Ring of Elemental Command (Fire)',
      weight: 0, size: [1, 1], baseValue: 50000, icon: '💍',
      rarity: 'legendary',
      requiresAttunement: true,
      equipSlot: 'ring',
      effects: [
        { type: 'resistance', value: 'fire', operation: 'grant' }
      ],
      description: 'Legendary. Requires attunement. Resistance to fire damage; advantage on attacks against fire elementals; speak Ignan; cast Burning Hands (1/dawn, save DC 17); cast Fireball or Wall of Fire (1/day each). Slay 3 fire elementals to unlock additional powers. DMG p.190.'
    },
    ring_of_water_elemental_command: {
      name: 'Ring of Elemental Command (Water)',
      weight: 0, size: [1, 1], baseValue: 50000, icon: '💍',
      rarity: 'legendary',
      requiresAttunement: true,
      equipSlot: 'ring',
      effects: [
        { type: 'resistance', value: 'cold', operation: 'grant' }
      ],
      description: 'Legendary. Requires attunement. Resistance to cold damage; advantage on attacks against water elementals; speak Aquan; cast Create or Destroy Water (3rd-level, 1/dawn); cast Water Walk and Wall of Ice (1/day each). Slay 3 water elementals to unlock additional powers. DMG p.190.'
    },
    robe_of_the_archmagi: {
      name: 'Robe of the Archmagi',
      weight: 1, size: [2, 3], baseValue: 50000, icon: '🧙',
      rarity: 'legendary',
      requiresAttunement: true,
      armorType: 'unarmored',
      description: 'Worn by sorcerers, warlocks, or wizards. Provides AC 15 + Dex modifier when not wearing armor; advantage on saves against spells and magical effects; +2 to spell save DC and +2 to spell attack rolls. DMG p.193.'
    },
    efreeti_bottle: {
      name: 'Efreeti Bottle',
      weight: 1, size: [1, 2], baseValue: 5000, icon: '🍾',
      rarity: 'very rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'daily',
      description: 'Very rare. No attunement required. This painted brass bottle weighs 1 lb. Action to remove the stopper: a thick column of smoke pours out, and at the end of your turn the smoke disappears with a flash of harmless fire as an efreeti (CR 11) appears in an unoccupied space within 30 ft. The first time the bottle is opened, the DM rolls d100 to determine the efreeti\'s reaction: 1-10 the efreeti attacks you immediately, escapes after 5 minutes, and the bottle becomes magically locked for 24 hours (cannot be opened); 11-90 the efreeti must serve you for 1 hour, obeying your commands, then disappears and the bottle loses all magic; 91-100 the efreeti can cast Wish three times on your behalf, then departs, never to return, and the bottle becomes nonmagical. While the bottle\'s daily cooldown is in effect (1-10 result), the stopper cannot be removed. DMG p.167.'
    },

    // ============================================================
    // [APR 30 2026]: DMG TABLE BACKFILL — 130+ named magic items
    //   referenced by MAGIC_ITEM_TABLES (Tables A-I, XGtE, TCoE) that
    //   were not yet present in BASE_ITEMS. Each entry cites its DMG /
    //   sourcebook page for traceability. Effects arrays are populated
    //   only for items where stat calculations actively need them
    //   (e.g. Cloak of Protection +1 AC); narrative-only items get a
    //   description-only entry. The shop generator uses
    //   getItemDefinition() to look these up; the EditItemDialog
    //   handles the player-facing customization (charge counts, named
    //   damage types where the item allows player choice, etc.).
    // ============================================================

    // --- Common magic items (DMG Table A overflow + XGtE + TCoE) ---
    driftglobe: {
      name: 'Driftglobe',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🌐',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This small sphere of thick glass weighs 1 pound. If you are within 60 feet of it, you can speak its command word to cause it to emanate the Light or Daylight spell. Once used, the Daylight effect can\'t be used again until the next dawn. You can also speak a command word to cause the driftglobe to hover in the air to follow you. It hovers 5 feet off the ground, stays within 6 feet of you, and follows at the same speed you move. You can also command the globe to remain stationary, or move it up to 60 feet away from you with a different command. DMG p.166.'
    },

    // --- DMG Table B (uncommon) ---
    keoghtoms_ointment: {
      name: "Keoghtom's Ointment",
      weight: 0.5, size: [1, 1], baseValue: 200, icon: '🧴', stackable: true, maxStack: 5,
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This glass jar, 3 inches in diameter, contains 1d4+1 doses of a thick mixture that smells faintly of aloe. The jar and its contents weigh ½ pound. As an action, one dose of the ointment can be swallowed or applied to the skin. The creature that receives it regains 2d8+2 hit points, ceases to be Poisoned, and is cured of any disease. DMG p.179.'
    },
    dust_of_disappearance: {
      name: 'Dust of Disappearance',
      weight: 0.1, size: [1, 1], baseValue: 200, icon: '✨',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. Found in a small packet, this powder resembles very fine sand. There is enough of it for one use. When you use an action to throw the dust into the air, you and each creature and object within 10 feet of you become Invisible for 2d4 minutes. The duration is the same for all subjects, and the dust is consumed when its magic takes effect. If a creature affected by the dust attacks or casts a spell, the Invisibility ends for that creature. DMG p.166.'
    },
    dust_of_dryness: {
      name: 'Dust of Dryness',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '🏜️',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This small packet contains 1d6+4 pinches of dust. You can use an action to sprinkle a pinch of it over water. The dust turns a cube of water 15 feet on a side into one marble-sized pellet, which floats or rests near where the dust was sprinkled. The pellet\'s weight is negligible. Someone can use an action to smash the pellet against a hard surface, causing the pellet to shatter and release the water. Doing so ends the magic affecting it. An elemental composed mostly of water that is exposed to a pinch of the dust must make a DC 13 Constitution saving throw, taking 10d6 necrotic damage on a failed save, or half as much damage on a successful one. DMG p.167.'
    },
    dust_of_sneezing_and_choking: {
      name: 'Dust of Sneezing and Choking',
      weight: 0.1, size: [1, 1], baseValue: 200, icon: '🤧',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. Found in a small container, this powder resembles very fine sand. It appears to be Dust of Disappearance, and an Identify spell reveals it to be so. There is enough of it for one use. When you use an action to throw a handful of the dust into the air, you and each creature that needs to breathe within 30 feet of you must succeed on a DC 15 Constitution saving throw or become unable to breathe, while sneezing uncontrollably. A creature affected in this way is Incapacitated and suffocating. As long as it is conscious, a creature can repeat the saving throw at the end of each of its turns, ending the effect on it on a success. The Lesser Restoration spell can also end the effect on a creature. DMG p.167.'
    },
    philter_of_love: {
      name: 'Philter of Love',
      weight: 0.5, size: [1, 1], baseValue: 100, icon: '💘', stackable: true, maxStack: 99,
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. The next time you see a creature within 10 minutes after drinking this philter, you become Charmed by that creature for 1 hour. If the creature is of a species and gender you are normally attracted to, you regard it as your true love while you are Charmed. This potion\'s rose-hued, effervescent liquid contains one easy-to-miss bubble shaped like a heart. DMG p.184.'
    },
    alchemy_jug: {
      name: 'Alchemy Jug',
      weight: 12, size: [1, 2], baseValue: 1500, icon: '🍯',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This ceramic jug appears to be able to hold a gallon of liquid and weighs 12 pounds whether full or empty. As an action, you can speak one of three command words to cause an amount of liquid to flow from the jug, chosen from the Alchemy Jug Liquids table (acid: 8 oz/day; basic poison: 0.5 oz/day; beer: 4 gal; honey: 1 gal; mayonnaise: 2 gal; oil: 1 quart; vinegar: 2 gal; water (fresh): 8 gal; water (salt): 12 gal; wine: 1 gal). Once the jug has produced its maximum, it can\'t be used to produce more of that liquid until the next dawn. DMG p.150.'
    },
    cap_of_water_breathing: {
      name: 'Cap of Water Breathing',
      weight: 0.5, size: [1, 1], baseValue: 600, icon: '🧢',
      rarity: 'uncommon',
      equipSlot: 'head',
      effects: [{ type: 'feature', target: 'waterBreathing', operation: 'grant' }],
      description: 'Uncommon. No attunement required. While wearing this cap underwater, you can speak its command word as an action to create a bubble of air around your head. It allows you to breathe normally underwater. The bubble vanishes if you use an action to speak the command word again, if the cap is removed, or if you are no longer underwater. DMG p.156.'
    },
    cloak_of_the_manta_ray: {
      name: 'Cloak of the Manta Ray',
      weight: 1, size: [2, 3], baseValue: 750, icon: '🦈',
      rarity: 'uncommon',
      equipSlot: 'cloak',
      requiresAttunement: false,
      effects: [
        { type: 'feature', target: 'waterBreathing', operation: 'grant' },
        { type: 'feature', target: 'swimSpeed', operation: 'set', value: 60 }
      ],
      description: 'Uncommon. No attunement required. While wearing this cloak with the hood up, you can breathe underwater and have a swimming speed of 60 feet. Pulling the hood up or down requires an action. DMG p.159.'
    },
    helm_of_comprehending_languages: {
      name: 'Helm of Comprehending Languages',
      weight: 3, size: [1, 1], baseValue: 750, icon: '⛑️',
      rarity: 'uncommon',
      equipSlot: 'head',
      description: 'Uncommon. No attunement required. While wearing this helm, you can use an action to cast the Comprehend Languages spell from it at will. DMG p.173.'
    },
    immovable_rod: {
      name: 'Immovable Rod',
      weight: 2, size: [1, 2], baseValue: 5000, icon: '⚖️',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This flat iron rod has a button on one end. As an action, you can press the button, which causes the rod to become magically fixed in place. Until you or another creature presses the button, the rod doesn\'t move, even if it is defying gravity. The rod can hold up to 8,000 pounds of weight; more causes the rod to deactivate and fall. A creature can use an action to make a DC 30 Strength check, moving the fixed rod up to 10 feet on a success. DMG p.175.'
    },
    lantern_of_revealing: {
      name: 'Lantern of Revealing',
      weight: 2, size: [1, 2], baseValue: 600, icon: '🏮',
      rarity: 'uncommon',
      requiresAttunement: false,
      effects: [{ type: 'sense', target: 'invisibility', operation: 'reveal', value: 30 }],
      description: 'Uncommon. No attunement required. While lit, this hooded lantern burns for 6 hours on 1 pint of oil, shedding bright light in a 30-foot radius and dim light for an additional 30 feet. Invisible creatures and objects are visible as long as they are in the lantern\'s bright light. You can use an action to lower the hood, reducing the light to dim light in a 5-foot radius. DMG p.179.'
    },
    mariners_armor: {
      name: "Mariner's Armor",
      weight: 20, size: [2, 2], baseValue: 600, icon: '🌊',
      rarity: 'uncommon',
      armorType: 'medium', ac: 14, maxDexMod: 2,
      effects: [{ type: 'feature', target: 'swimSpeed', operation: 'set', value: 'walk' }],
      description: 'Uncommon. No attunement required. Swimming speed equals walking speed. Whenever you start your turn underwater at 0 HP, the armor causes you to rise 60 ft toward the surface. DMG p.181.'
    },
    mithral_armor: {
      name: 'Mithral Armor',
      weight: 20, size: [2, 2], baseValue: 800, icon: '🥈',
      rarity: 'uncommon',
      armorType: 'medium', ac: 14, maxDexMod: 2, minStr: 0,
      stealthDisadvantage: false,
      description: 'Uncommon. No attunement required. Medium or heavy armor reforged in mithral. If the base armor normally imposes disadvantage on Dexterity (Stealth) checks or has a Strength requirement, the mithral version doesn\'t. DMG p.182.'
    },
    robe_of_useful_items: {
      name: 'Robe of Useful Items',
      weight: 1, size: [2, 3], baseValue: 1500, icon: '🧥',
      rarity: 'uncommon',
      equipSlot: 'armor',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This robe has cloth patches of various shapes and colors covering it. While wearing the robe, you can use an action to detach one of the patches, causing it to become the object or creature it represents. Once the last patch is removed, the robe becomes an ordinary garment. The robe has two each of the following patches: dagger, bullseye lantern (filled and lit), steel mirror, 10-foot pole, hempen rope (50 feet, coiled), and sack. In addition, the robe has 4d4 other patches; the DM chooses the patches or determines them randomly (d100): bag of 100 gp; silver coffer (1×½×½ ft) worth 500 gp; iron door (hinged, 10×10 ft, with frame, locked); 10 gems worth 100 gp each; ladder (24 ft long); riding horse with saddlebags; pit (10-ft cube); 4 potions of healing; rowboat (12 ft long); spell scroll (1d6 + 1 levels, GM\'s choice); 2 mastiffs; window (2×4 ft, up to 2 ft deep); portable ram. Each patch is one-time-use and cannot be re-attached. DMG p.195.'
    },
    rope_of_climbing: {
      name: 'Rope of Climbing',
      weight: 3, size: [2, 2], baseValue: 2000, icon: '🪢',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This 60-foot-long silk rope weighs 3 lb and can hold up to 3,000 lb of weight. While holding one end of the rope, you can use an action to speak the command word; the rope animates, snaking out to a destination of your choice within 30 ft. The destination must be a point you can see. Subsequent commands cause the rope to coil, knot itself with 1-foot-spaced loops (which makes climbing easier — adv on Athletics checks), unknot itself, fasten to or unfasten from an object, or untie itself if tied. If you command the rope to knot, it has 10 knots and reduces its overall length by 10 ft. The rope has AC 20 and 20 HP; it regains 1 HP every 5 minutes as long as it has at least 1 HP. If reduced to 0 HP, the rope is destroyed. DMG p.198.'
    },
    saddle_of_the_cavalier: {
      name: 'Saddle of the Cavalier',
      weight: 25, size: [2, 2], baseValue: 750, icon: '🏇',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. While in this saddle on a mount, you have advantage on melee attack rolls against any unmounted creature that is smaller than your mount. In addition, you cannot be dismounted against your will while you are conscious, and you have advantage on any saving throw to avoid being unseated from the saddle. The saddle weighs 25 lb. (NOTE: the previous description claimed the mount cannot be charmed or frightened — that is NOT in RAW; removed.) DMG p.199.'
    },
    wand_of_magic_detection: {
      name: 'Wand of Magic Detection',
      weight: 1, size: [1, 2], baseValue: 250, icon: '🪄',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Has 3 charges. Expend 1 charge (action) to cast Detect Magic. Regains 1d3 charges at dawn. DMG p.211.'
    },
    wand_of_secrets: {
      name: 'Wand of Secrets',
      weight: 1, size: [1, 2], baseValue: 250, icon: '🪄',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Has 3 charges. Action to expend 1 charge: wand points toward nearest secret door or trap within 30 ft. Regains 1d3 charges at dawn. DMG p.211.'
    },

    // --- DMG Table C (rare) ---
    quaals_feather_token: {
      name: "Quaal's Feather Token",
      weight: 0.1, size: [1, 1], baseValue: 1000, icon: '🪶',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. A tiny object resembling a feather. Six different tokens exist (anchor, bird, fan, swan boat, tree, whip — DM determines kind randomly or by choice). Each token has one use. Anchor: action to touch the token to a boat or ship; it stops the vessel in place for 24 hours or until the token is touched as an action to release. Bird: action to throw the token up to 5 feet — it becomes a giant roc-like bird that flies you and up to 500 lb of cargo at 16 mph for up to 8 hours before vanishing. Fan: action to toss in the air, becomes a giant fan that produces a strong gust of wind (heavy obscuration, propels boat etc.). Swan boat: action to touch to a body of water; conjures a 50-ft swan boat that travels at 6 mph for 24 hours. Tree: action to drop on dry ground; grows into a 60-ft oak (5-ft diameter trunk, 40-ft canopy) — permanent. Whip: action to throw within 10 feet; becomes a +1 magic whip (15-ft reach, finesse) that attacks one creature you designate as a bonus action on each of your turns (+9 to hit, 1d6+5 force damage) for 1 hour. Once invoked, the token is destroyed. DMG p.188.'
    },
    scroll_of_protection: {
      name: 'Scroll of Protection', rarity: 'rare',
      weight: 0.1, size: [1, 1], baseValue: 1000, icon: '📜', stackable: true, maxStack: 99,
      description: "Action to read the scroll; choose one creature type from aberrations, celestials, elementals, fey, fiends, or undead. For 5 minutes, creatures of the named type can't willingly approach within 5 ft of you, and they have disadvantage on attack rolls against you while you bear the scroll. DMG p.199."
    },
    bag_of_beans: {
      name: 'Bag of Beans',
      weight: 0.5, size: [1, 1], baseValue: 1000, icon: '👝',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. Heavy cloth bag containing 3d4 dry beans. If you dump the beans out of the bag, they explode in a 10-foot radius from the bag: each creature in the area must succeed on a DC 15 Dexterity saving throw or take 5d4 fire damage (half on success). The fire ignites flammable objects in the area not worn or carried. Alternatively, you can use an action to remove and plant one or more beans in dirt or sand, then water them; each planted bean produces an effect 1 minute later from the spot where it was planted (DM rolls d100 — possible effects include geyser, treant, pyramid, monster, treasure chest, etc.; see DMG p.152 table). DMG p.152.'
    },
    bead_of_force: {
      name: 'Bead of Force',
      weight: 0.1, size: [1, 1], baseValue: 1000, icon: '⚪', stackable: true, maxStack: 6,
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. Small black sphere measuring ¾ inch in diameter and weighing an ounce. Typically 1d4+4 beads are found together. As an action, you can throw the bead up to 60 feet. On impact, the bead detonates as a burst: each creature within a 10-foot radius must succeed on a DC 15 Dexterity saving throw or take 5d4 force damage. A sphere of transparent force then encloses the area for 1 minute — all creatures that failed the save are trapped inside (the sphere has the same properties as the Wall of Force spell: indestructible by non-magical means, dispelled by Disintegrate or Wall of Force dispel). Affected creatures can use an action to attempt to push out (DC 15 Strength check); on success the sphere bursts. The sphere is then expended. DMG p.154.'
    },
    chime_of_opening: {
      name: 'Chime of Opening',
      weight: 1, size: [1, 1], baseValue: 1500, icon: '🔔',
      rarity: 'rare',
      requiresAttunement: false,
      charges: 10, maxCharges: 10, rechargeType: 'never',
      description: 'Rare. No attunement required. Hollow metal tube about 1 foot long, weighing 1 pound. The chime has 10 charges. As an action while holding it, you can strike it and direct it at an object you can see within 120 feet that can be opened (a door, lid, lock, manacle, latch, or similar) — the chime emits a clear tone, and one lock or latch on the object opens unless the sound cannot reach the object. If no locks remain, the object itself opens. The chime expends 1 charge per use. The chime regains no charges; when its tenth charge is expended, the chime cracks and becomes useless. DMG p.158.'
    },
    decanter_of_endless_water: {
      name: 'Decanter of Endless Water',
      weight: 2, size: [1, 1], baseValue: 1000, icon: '🧴',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. This stoppered flask sloshes when shaken. As an action, you can remove the stopper and speak one of three command words to cause an amount of fresh or salt water to pour out, then return the stopper to close the flask. "Stream" produces 1 gallon of water; "Fountain" produces 5 gallons of water in a 5-foot line; "Geyser" produces 30 gallons of water that gush forth in a 30-foot-long, 1-foot-wide geyser — as a bonus action while holding the decanter, you can aim it at a creature you can see within 30 feet of you which must succeed on a DC 13 Strength saving throw or take 1d4 bludgeoning damage and be knocked prone. Instead of a creature, you can target an object that isn\'t being worn or carried and that weighs no more than 200 pounds; the object is either knocked over or pushed up to 15 feet away. DMG p.161.'
    },
    eyes_of_minute_seeing: {
      name: 'Eyes of Minute Seeing',
      weight: 0.1, size: [1, 1], baseValue: 250, icon: '👁️',
      rarity: 'uncommon',
      equipSlot: 'eyes', // [SUB-PLAN 1R-eyes-data / 2026-05-27]: was 'head'; lens items moved to dedicated Eyes slot
      effects: [
        { type: 'advantage', operation: 'advantage', target: 'skill:investigation' }
      ],
      description: 'Uncommon. No attunement required. Crystal lenses fit over the eyes. While wearing them, you can see much better than normal out to a range of 1 foot. You have advantage on Intelligence (Investigation) checks that rely on sight while searching an area or studying an object within that range. DMG p.169.'
    },
    folding_boat: {
      name: 'Folding Boat',
      weight: 4, size: [1, 1], baseValue: 5000, icon: '⛵',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. Wooden box measuring 12 inches long, 6 inches wide, and 6 inches deep. Three command words are issued when the item is created. Speak the first command word as an action while holding the box: it unfolds into a rowboat 10 feet long, 4 feet wide, and 2 feet deep (oars, anchor, mast, lateen sail; holds 4 Medium creatures comfortably). Speak the second command word: it unfolds into a ship 24 feet long, 8 feet wide, and 6 feet deep (single deck + rowing benches, a steering wheel, oars and rudder, a single mast with square sail; holds 15 Medium creatures + 1 ton of cargo, requires a crew of 1 to operate). Speak the third command word while inside or touching the boat/ship: it folds back into a box. Creatures and objects inside when folded are expelled into the surrounding water. DMG p.171.'
    },
    hewards_handy_haversack: {
      name: "Heward's Handy Haversack",
      weight: 5, size: [2, 2], baseValue: 2000, icon: '🎒',
      rarity: 'rare',
      requiresAttunement: false,
      containerSlots: [6, 8], weightReduction: 100, containerSize: 'extradimensional', maxWeight: 120,
      description: 'Rare. No attunement required. Backpack with a central main pouch and 2 side pouches. Each of the 2 side pouches holds up to 20 pounds of material, not exceeding a volume of 2 cubic feet; the large central pouch holds up to 8 cubic feet or 80 pounds. The haversack always weighs 5 pounds regardless of its contents. Reach into the haversack and speak the name of any item you have placed inside; the item magically rises to the top, ready to be drawn out (action). Placing the haversack inside another extradimensional storage (Bag of Holding, Portable Hole, or another haversack) instantly destroys both items and opens a gate to the Astral Plane, located where the haversack was: any creature within 10 feet of the gate is sucked through to a random location on the Astral Plane. The gate then closes. The gate is one-way and cannot be reopened. DMG p.174.'
    },
    horseshoes_of_speed: {
      name: 'Horseshoes of Speed',
      weight: 4, size: [1, 1], baseValue: 1500, icon: '🐎',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. Set of 4 iron horseshoes. While all four shoes are attached to the hooves of a single creature, that creature\'s walking speed increases by 30 feet. The speed bonus applies in any form the creature assumes, provided the form has hooves. Attaching the shoes requires 10 minutes per shoe (1 hour for all four); removing them takes the same time. DMG p.175.'
    },
    necklace_of_fireballs: {
      name: 'Necklace of Fireballs',
      weight: 0.5, size: [1, 1], baseValue: 5000, icon: '🔥',
      rarity: 'rare',
      requiresAttunement: false,
      equipSlot: 'neck',
      description: 'Rare. No attunement required. This necklace has 1d6+3 beads. As an action, you can detach a bead and throw it up to 60 feet. The bead detonates as a 3rd-level Fireball spell (DC 15) on a 20-foot-radius sphere. You can hurl multiple beads (or even the whole necklace) as one action; when you do so, increase the level of the Fireball by 1 for each bead beyond the first. DMG p.182.'
    },
    periapt_of_health: {
      name: 'Periapt of Health',
      weight: 0.1, size: [1, 1], baseValue: 600, icon: '💎',
      rarity: 'uncommon',
      equipSlot: 'neck',
      requiresAttunement: false,
      description: 'Uncommon. No attunement required. You are immune to contracting any disease while you wear this pendant. If you are already infected with a disease, the effects of the disease are suppressed while you wear the pendant. DMG p.184.'
    },
    sending_stones: {
      name: 'Sending Stones',
      weight: 0.5, size: [1, 1], baseValue: 1500, icon: '🪨',
      rarity: 'uncommon',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Uncommon. No attunement required. Sending stones come in pairs, with each smooth stone carved to match the other so the pairing is easily recognized. While you touch one stone, you can use an action to cast the Sending spell from it. The target of the spell is the holder of the other stone. If no creature holds the other stone, you know that fact as soon as you use the stone and don\'t cast the spell. A spell cast in this manner doesn\'t require any components. Once Sending is cast through the stones, they can\'t be used again until the next dawn. If one of the stones in a pair is destroyed, the other one becomes nonmagical. DMG p.199.'
    },

    // --- DMG Table D (very rare) ---
    horseshoes_of_a_zephyr: {
      name: 'Horseshoes of a Zephyr',
      weight: 4, size: [1, 1], baseValue: 5000, icon: '💨',
      rarity: 'very rare',
      requiresAttunement: false,
      description: 'Very Rare. No attunement required. Set of 4 iron horseshoes. While all four shoes are attached to the hooves of a single creature, the creature can: (a) move normally even when unshod and over surfaces that would normally impede its movement, (b) travel at normal speed across non-solid surfaces such as water, snow, ice, mud, quicksand, or magma without sinking or being burned, (c) leaves no tracks and produces no sound from its hooves, and (d) gains the ability to move with its hooves 4 inches above the surface (does not actually touch the ground). DMG p.175.'
    },
    nolzurs_marvelous_pigments: {
      name: "Nolzur's Marvelous Pigments",
      weight: 1, size: [1, 1], baseValue: 5000, icon: '🎨',
      rarity: 'very rare',
      requiresAttunement: false,
      description: 'Very Rare. No attunement required. Typically found in 1d4 pots inside a 1-foot-square wooden box weighing 1 pound, along with a single fine brush (weighing nothing). Each pot contains enough paint to cover a 1,000-square-foot surface, allowing you to create three-dimensional images on a flat surface. The created images become real objects of nonmagical, inanimate, normal nature (the equivalent of 1,000 cubic feet of matter, such as a stone wall, a pit, or a chest). Creating the image takes 10 minutes per 1 foot of the image\'s greatest dimension. Once the image is complete, the painted item becomes a real, three-dimensional object. The pigments can\'t create magic items, creatures, or objects of value (gold, gems, etc.). DMG p.183.'
    },

    // --- DMG Table E (artifact-tier consumables) ---
    universal_solvent: {
      name: 'Universal Solvent',
      weight: 0.5, size: [1, 1], baseValue: 2500, icon: '🧪',
      rarity: 'legendary',
      requiresAttunement: false,
      description: 'Legendary. No attunement required. A tube of clear, slimy paste with a sharp alcohol smell. As an action, you can apply the paste to a surface or object — the solvent instantly dissolves any adhesive it touches, including Sovereign Glue. The tube contains enough solvent for a single application. DMG p.209.'
    },
    sovereign_glue: {
      name: 'Sovereign Glue',
      weight: 0.5, size: [1, 1], baseValue: 2500, icon: '🩹',
      rarity: 'legendary',
      requiresAttunement: false,
      description: 'Legendary. No attunement required. This pale, syrupy liquid is found in a clear glass bottle wrapped in thick leather and sealed with a heavy lead stopper. The bottle holds 1d6+1 ounces of glue when discovered; each ounce can cover 1 square foot of surface. The glue takes 1 minute to set; once cured, the bond it creates can be broken only by Universal Solvent, Oil of Etherealness, or a Wish spell. DMG p.200.'
    },

    // --- DMG Table F (uncommon wondrous items) ---
    sentinel_shield: {
      name: 'Sentinel Shield',
      weight: 6, size: [2, 2], baseValue: 250, icon: '🛡️',
      rarity: 'uncommon',
      armorType: 'shield', acBonus: 2,
      effects: [{ type: 'advantage', target: 'initiative', operation: 'advantage' }, { type: 'advantage', target: 'skill:perception', operation: 'advantage' }],
      description: 'Uncommon. No attunement required. Shield carved with an open eye. While holding it, you have advantage on initiative rolls and Wisdom (Perception) checks. DMG p.199.'
    },
    amulet_of_proof_against_detection_and_location: {
      name: 'Amulet of Proof against Detection and Location',
      weight: 0.1, size: [1, 1], baseValue: 1000, icon: '📿',
      rarity: 'uncommon',
      equipSlot: 'neck', requiresAttunement: true,
      description: 'Uncommon. Requires attunement. While wearing this amulet, you cannot be targeted by any divination magic or perceived through magical scrying sensors. DMG p.150.'
    },
    boots_of_striding_and_springing: {
      name: 'Boots of Striding and Springing',
      weight: 1, size: [2, 2], baseValue: 750, icon: '👢',
      rarity: 'uncommon',
      equipSlot: 'boots', requiresAttunement: true,
      // [SUB-PLAN 1H-H-cond Phase 1 — 2026-05-29]: Changed operation:'set' + condition:'minimum'
      // → operation:'minimum'. 'minimum' is a FLOOR operation (Math.max(base, 30)), not an
      // unconditional SET. Pre-fix: a character with 40ft base speed would have speed SET to 30.
      // Post-fix: base 25ft → 30ft (floor applied); base 40ft → 40ft (floor not applied, higher wins).
      effects: [{ type: 'speed', operation: 'minimum', value: 30 }],
      description: 'Uncommon. Requires attunement. While you wear these boots, your walking speed becomes 30 feet, unless your walking speed is higher, and your speed isn\'t reduced if you are encumbered or wearing heavy armor. In addition, you can jump three times the normal distance, though you can\'t jump farther than your remaining movement would allow. DMG p.155.'
    },
    bracers_of_archery: {
      name: 'Bracers of Archery',
      weight: 1, size: [1, 1], baseValue: 750, icon: '🏹',
      rarity: 'uncommon',
      equipSlot: 'arms', requiresAttunement: true,
      // RAW DMG p.156: proficiency with longbow + shortbow AND +2 damage on ranged
      // attacks with those weapons. Pre-fix this entry shipped with only the damage
      // effect — the proficiency grants (present in the jewelry-section variant)
      // were missing here, so a non-proficient roller of Table F's Bracers of
      // Archery wouldn't get the prof bonus the RAW grants.
      effects: [
        { type: 'proficiency', operation: 'grant', value: 'weapon:longbow', proficiencyLevel: 1 },
        { type: 'proficiency', operation: 'grant', value: 'weapon:shortbow', proficiencyLevel: 1 },
        // [SUB-PLAN 1H-H-cond Phase 1 — GAP-4 — 2026-05-29]: Reshaped from:
        //   { type:'damage', target:'longbow,shortbow', operation:'add', value:2 }
        // to a 'damageBonus' with a structured condition leaf. 'damage' with a
        // comma-separated target had no consumer (getActiveDamageBonuses queries
        // 'damageBonus', not 'damage'). 'damageBonus' with a {category,op,operands}
        // condition leaf is evaluated by _evaluateConditionBlock using
        // context.equippedWeaponBaseType (set by _buildContext). operands MUST equal
        // the item's baseType field — for weapons created from BASE_ITEMS.weapons, the
        // baseType is the BASE_ITEMS key: 'longbow' and 'shortbow'.
        { type: 'damageBonus', operation: 'add', value: 2, condition: { category: 'equippedWeaponType', op: 'hasAny', operands: ['longbow', 'shortbow'] } }
      ],
      description: 'Uncommon. Requires attunement. Proficiency with the longbow and shortbow; +2 bonus to damage rolls on ranged attacks with those weapons. DMG p.156.'
    },
    brooch_of_shielding: {
      name: 'Brooch of Shielding',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '📌',
      rarity: 'uncommon',
      equipSlot: 'neck', requiresAttunement: true,
      // [BREADCRUMB Rule 25 — Sub-plan 1I(g) extension]: The second effect
      //   `{type:'immunity', target:'magic_missile'}` uses a TYPE NAME not in
      //   the schema's effect-type union (effectRegistry.js L17). Spell-
      //   specific immunity (immunity from a SPELL by name, not from a damage
      //   type) has no v1 runtime consumer; the Brooch of Shielding's MM
      //   immunity has never fired since this row was authored. Left in place
      //   as a data breadcrumb pending the v1.x spell-immunity feature.
      //   Tracked under Sub-plan 1I(g) in docs/audits/master-queue.md.
      effects: [{ type: 'resistance', value: 'force', operation: 'grant' }, { type: 'immunity', target: 'magic_missile', operation: 'grant' }],
      description: 'Uncommon. Requires attunement. While wearing this brooch, you have resistance to force damage, and you have immunity to damage from the Magic Missile spell. DMG p.156.'
    },
    broom_of_flying: {
      name: 'Broom of Flying',
      weight: 3, size: [1, 4], baseValue: 750, icon: '🧹',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      requiresAttunement: false,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'set', value: 50 }],
      description: 'Uncommon. No attunement required. This wooden broom, which weighs 3 pounds, functions like a mundane broom until you stand astride it and speak its command word, at which point it hovers and can be ridden as a mount. The broom has a flying speed of 50 feet, can carry up to 400 pounds, and is reduced to 30 feet over 200 pounds. The broom stops hovering when you land. You can summon the broom as an action by speaking the command word as long as it is within 1 mile of you and not held by another creature. DMG p.156.'
    },
    circlet_of_blasting: {
      name: 'Circlet of Blasting',
      weight: 0.5, size: [1, 1], baseValue: 1500, icon: '👑',
      rarity: 'uncommon',
      equipSlot: 'head',
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Uncommon. No attunement required. While wearing this circlet, you can use an action to cast the Scorching Ray spell with it. When you make the spell\'s attacks, you do so with an attack bonus of +5. The circlet can\'t be used this way again until the next dawn. DMG p.158.'
    },
    cloak_of_protection: {
      name: 'Cloak of Protection',
      weight: 1, size: [2, 3], baseValue: 3500, icon: '🧥',
      rarity: 'uncommon',
      equipSlot: 'cloak', requiresAttunement: true,
      effects: [
        { type: 'ac', operation: 'add', value: 1 },
        { type: 'save:strength', operation: 'add', value: 1 },
        { type: 'save:dexterity', operation: 'add', value: 1 },
        { type: 'save:constitution', operation: 'add', value: 1 },
        { type: 'save:intelligence', operation: 'add', value: 1 },
        { type: 'save:wisdom', operation: 'add', value: 1 },
        { type: 'save:charisma', operation: 'add', value: 1 }
      ],
      description: 'Uncommon. Requires attunement. You gain a +1 bonus to AC and saving throws while you wear this cloak. DMG p.159.'
    },
    hat_of_disguise: {
      name: 'Hat of Disguise',
      weight: 0.5, size: [1, 1], baseValue: 5000, icon: '🎩',
      rarity: 'uncommon',
      equipSlot: 'head', requiresAttunement: true,
      description: 'Uncommon. Requires attunement. While wearing this hat, you can use an action to cast the Disguise Self spell from it at will. The spell ends if the hat is removed. DMG p.173.'
    },
    javelin_of_lightning: {
      name: 'Javelin of Lightning',
      weight: 2, size: [1, 4], baseValue: 1500, icon: '⚡',
      rarity: 'uncommon',
      damage: '1d6', damageType: 'piercing',
      properties: ['Thrown (30/120)'],
      description: 'Uncommon. Magic javelin (counts as magical for resistance bypass). Action: throw it and speak the command word — the javelin transforms into a 5-ft-wide, 120-ft line of lightning. Each creature in the line takes 4d6 lightning damage (DEX save DC 13 for half). The line starts from you and extends in a direction you choose. The javelin reforms at the end of the line; the property cannot be used again until next dawn. DMG p.178.'
    },
    pearl_of_power: {
      name: 'Pearl of Power',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '⚪',
      rarity: 'uncommon',
      requiresAttunement: true,
      attunementRequirement: 'spellcaster',
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Uncommon. Requires attunement by a spellcaster. While this pearl is on your person, you can use an action to speak its command word and regain one expended spell slot. If the expended slot was of 4th level or higher, the new slot is 3rd level. Once you have used the pearl, it can\'t be used again until the next dawn. DMG p.184.'
    },
    rod_of_the_pact_keeper_plus_1: {
      name: 'Rod of the Pact Keeper +1',
      weight: 2, size: [1, 2], baseValue: 750, icon: '🔱',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:warlock' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:warlock' }],
      description: 'Uncommon. Requires attunement by a warlock. +1 to warlock spell attack rolls and warlock spell save DC. Once per dawn as an action, recover one expended Pact Magic spell slot. DMG p.197.'
    },
    slippers_of_spider_climbing: {
      name: 'Slippers of Spider Climbing',
      weight: 1, size: [1, 1], baseValue: 750, icon: '🕷️',
      rarity: 'uncommon',
      equipSlot: 'boots', requiresAttunement: true,
      effects: [{ type: 'feature', target: 'climbSpeed', operation: 'set', value: 'walk' }],
      description: 'Uncommon. Requires attunement. While you wear these light shoes, you can move up, down, and across vertical surfaces and upside down along ceilings, while leaving your hands free. You have a climbing speed equal to your walking speed. However, the slippers don\'t allow you to move this way on a slippery surface, such as one covered by ice or oil. DMG p.200.'
    },
    staff_of_the_adder: {
      name: 'Staff of the Adder',
      weight: 7, size: [1, 5], baseValue: 750, icon: '🐍',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      description: 'Uncommon. Requires attunement by a cleric, druid, or warlock. Bonus action to speak command: head turns into a snake for 1 minute (revert as another bonus action; reverts automatically after 1 minute). While snake-headed, you can make a melee weapon attack with the staff that has a 10-foot reach: +6 to hit, 1d6+3 piercing on hit, and target must succeed on a DC 11 CON save or take 3d6 poison (half on success). Snake head has AC 15 and 20 hp; if reduced to 0 hp the staff is destroyed. DMG p.202.'
    },
    staff_of_the_python: {
      name: 'Staff of the Python',
      weight: 7, size: [1, 5], baseValue: 750, icon: '🐍',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      description: 'Uncommon. Requires attunement by a cleric, druid, or warlock. Action to throw the staff up to 10 ft and speak command: it becomes a Giant Constrictor Snake under your mental command (uses your initiative; acts immediately on its own turn). Action to speak command again to revert to staff form (must be within 60 ft). If the snake is reduced to 0 hp, it reverts to a staff and shatters, destroyed. DMG p.205.'
    },
    sword_of_vengeance: {
      name: 'Sword of Vengeance',
      weight: 3, size: [1, 4], baseValue: 750, icon: '⚔️',
      rarity: 'uncommon',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      requiresAttunement: true, magicalBonus: 1,
      cursed: true,
      description: 'Uncommon. Requires attunement. +1 magic sword. Cursed: attuning to the sword extends the curse to you. While cursed you are unwilling to part with the sword and keep it within reach at all times; you have disadvantage on attack rolls made with weapons other than this one; and whenever a creature damages you while you hold the sword, you must succeed on a DC 15 WIS save or be compelled to attack that creature until either it or you drops to 0 HP. DMG p.206.'
    },
    trident_of_fish_command: {
      name: 'Trident of Fish Command',
      weight: 4, size: [1, 4], baseValue: 1000, icon: '🔱',
      rarity: 'uncommon',
      damage: '1d6', damageType: 'piercing',
      properties: ['Thrown (20/60)', 'Versatile (1d8)'],
      requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Uncommon. Requires attunement. Magic trident with 3 charges. Action: expend 1 charge to cast Dominate Beast (DC 15) on a beast with an innate swim speed. Regains 1d3 charges daily at dawn. DMG p.209.'
    },
    wand_of_the_war_mage_plus_1: {
      name: 'Wand of the War Mage +1',
      weight: 1, size: [1, 2], baseValue: 750, icon: '🪄',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1 }],
      description: 'Spellcaster attunement. +1 to spell attack rolls. Ignore half cover when making spell attacks. DMG p.211.'
    },
    wand_of_web: {
      name: 'Wand of Web',
      weight: 1, size: [1, 2], baseValue: 750, icon: '🪄',
      rarity: 'uncommon',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      description: 'Spellcaster attunement. 7 charges. Action to expend 1 charge: cast Web (DC 15). Regains 1d6+1 charges at dawn. DMG p.212.'
    },
    weapon_of_warning: {
      name: 'Weapon of Warning',
      weight: 3, size: [1, 4], baseValue: 750, icon: '⚔️',
      rarity: 'uncommon',
      damage: '1d8', damageType: 'slashing',
      requiresAttunement: true,
      effects: [{ type: 'advantage', target: 'initiative', operation: 'advantage' }],
      description: 'Uncommon. Requires attunement. Magic weapon (any weapon). While holding it you have advantage on initiative rolls. You and any companions within 30 ft can\'t be surprised, except when incapacitated by something other than non-magical sleep. The weapon magically wakes you and your companions from non-magical sleep if combat breaks out. DMG p.213.'
    },
    adamantine_armor: {
      name: 'Adamantine Armor',
      weight: 40, size: [2, 3], baseValue: 1500, icon: '⛓️',
      rarity: 'uncommon',
      armorType: 'medium', ac: 14, maxDexMod: 2,
      effects: [{ type: 'feature', operation: 'grant', value: 'item_adamantine_armor_crit_immunity' }],
      description: 'Uncommon. No attunement required. Medium or heavy armor (not hide) reinforced with adamantine. While wearing it, any critical hit against you becomes a normal hit. DMG p.150.'
    },
    bag_of_tricks: {
      name: 'Bag of Tricks',
      weight: 0.5, size: [1, 1], baseValue: 750, icon: '👝',
      rarity: 'uncommon',
      requiresAttunement: false,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Uncommon. No attunement required. This ordinary-looking bag (gray, rust, or tan; the color determines the creature table) appears empty. Reaching inside reveals a small fuzzy object. As an action, you can remove the fuzzy object and throw it up to 20 feet — when it lands, it transforms into a creature you roll randomly on the bag\'s table (CR ½–2 Beast depending on bag color, friendly to you and your companions, acts on its own initiative for 10 minutes or until reduced to 0 HP / commanded to vanish). The bag can be used 3 times before requiring 1 day rest (RAW: 1d4 pulls per day; this implementation tracks 3 charges/dawn as a deterministic floor). DMG p.154.'
    },
    dimensional_shackles: {
      name: 'Dimensional Shackles',
      weight: 4, size: [1, 1], baseValue: 1500, icon: '🔗',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. You can use an action to place these shackles on an incapacitated creature. The shackles adjust to fit a creature of Small to Large size. In addition to serving as mundane manacles, the shackles prevent a creature bound by them from using any method of extradimensional movement, including teleportation or travel to a different plane of existence. They do not prevent the creature from passing through an interdimensional portal. You and any creature you designate when you use the shackles can use an action to remove them. Once every 30 days, the bound creature can make a DC 30 Strength (Athletics) check; on a success the creature breaks free and destroys the shackles. DMG p.166.'
    },
    helm_of_telepathy: {
      name: 'Helm of Telepathy',
      weight: 3, size: [1, 1], baseValue: 750, icon: '⛑️',
      rarity: 'uncommon',
      equipSlot: 'head', requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Uncommon. Requires attunement. While wearing this helm, you can use an action to cast the Detect Thoughts spell (save DC 13) from it at will. As long as you maintain concentration on the spell, you can use a bonus action to send a telepathic message to a creature you are focused on. It can reply — using a bonus action to do so — while your focus on it continues. While focusing on a creature with Detect Thoughts, you can use an action to cast the Suggestion spell (save DC 13) from the helm on that creature. Once used, the Suggestion property of the helm can\'t be used again until the next dawn. DMG p.173.'
    },
    instrument_of_the_bards_doss_lute: {
      name: 'Instrument of the Bards (Doss Lute)',
      weight: 2, size: [1, 3], baseValue: 750, icon: '🎻',
      rarity: 'uncommon',
      requiresAttunement: true,
      description: 'Bardic instrument; +2 attack/save DC for spells cast through it. Cast Animal Friendship, Protection from Evil & Good, Detect Thoughts, Sleep. DMG p.176.'
    },
    medallion_of_thoughts: {
      name: 'Medallion of Thoughts',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '📿',
      rarity: 'uncommon',
      equipSlot: 'neck', requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Uncommon. Requires attunement. The medallion has 3 charges. While wearing it, you can use an action and expend 1 charge to cast the Detect Thoughts spell (save DC 13) from it. The medallion regains 1d3 expended charges daily at dawn. DMG p.181.'
    },
    necklace_of_adaptation: {
      name: 'Necklace of Adaptation',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '📿',
      rarity: 'uncommon',
      equipSlot: 'neck', requiresAttunement: true,
      effects: [{ type: 'feature', target: 'breatheAnything', operation: 'grant' }],
      description: 'Uncommon. Requires attunement. While wearing this necklace, you can breathe normally in any environment, and you have advantage on saving throws made against harmful gases and vapors. DMG p.182.'
    },
    periapt_of_wound_closure: {
      name: 'Periapt of Wound Closure',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💎',
      rarity: 'uncommon',
      equipSlot: 'neck', requiresAttunement: true,
      description: 'Uncommon. Requires attunement. While you wear this pendant, you stabilize whenever you are dying at the start of your turn. In addition, whenever you roll a Hit Die to regain hit points, double the number of hit points it restores. DMG p.184.'
    },
    pipes_of_haunting: {
      name: 'Pipes of Haunting',
      weight: 2, size: [1, 1], baseValue: 750, icon: '🪈',
      rarity: 'uncommon',
      requiresAttunement: false,
      charges: 3, maxCharges: 3, rechargeType: 'dawn', rechargeAmount: '1d3',
      description: 'Uncommon. No attunement required. You must be proficient with wind instruments to use these pipes. They have 3 charges. You can use an action to play them and expend 1 charge to create an eerie, spellbinding tune. Each creature within 30 feet of you that hears you play must succeed on a DC 15 Wisdom saving throw or become Frightened of you for 1 minute. If you wish, all creatures in the area that aren\'t hostile toward you automatically succeed on the saving throw. A creature that fails the save can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success. A creature that succeeds on its saving throw is immune to the effect of these pipes for the next 24 hours. The pipes regain 1d3 expended charges daily at dawn. DMG p.185.'
    },
    pipes_of_the_sewers: {
      name: 'Pipes of the Sewers',
      weight: 2, size: [1, 1], baseValue: 750, icon: '🪈',
      rarity: 'uncommon',
      requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn', rechargeAmount: '1d3',
      description: 'Uncommon. Requires attunement. You must be proficient with wind instruments to use these pipes. While you are attuned to the pipes, ordinary rats and giant rats are indifferent toward you and will not attack you unless you threaten or harm them. The pipes have 3 charges. If you play the pipes as an action, you can use one of the following magical effects, regaining 1d3 expended charges daily at dawn: (a) Summon Rats (1 charge): If there are sewers within 1/2 mile of you, a swarm of rats arrives in 1d4 minutes; if no sewers are nearby, this effect is wasted. You can use the pipes\' Command Rats effect to control the swarm. (b) Command Rats (1 charge): Each ordinary rat and rat swarm that can hear the pipes within 30 feet must succeed on a DC 15 Wisdom save or be Charmed by you for 1 hour. While Charmed you can issue a telepathic command of up to 6 words. You can maintain control by continuing to play as an action. If you stop, rats remain Charmed for 1 minute then become free; while Charmed they follow your command to the best of their ability. DMG p.185.'
    },
    ring_of_jumping: {
      name: 'Ring of Jumping',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      rarity: 'uncommon',
      equipSlot: 'ring', requiresAttunement: true,
      description: 'Uncommon. Requires attunement. Bonus action: cast the Jump spell on yourself (target only self). DMG p.191.'
    },
    ring_of_mind_shielding: {
      name: 'Ring of Mind Shielding',
      weight: 0.1, size: [1, 1], baseValue: 1500, icon: '💍',
      rarity: 'uncommon',
      equipSlot: 'ring', requiresAttunement: true,
      description: 'Uncommon. Requires attunement. You are immune to magic that allows others to read your thoughts, determine truthfulness, know alignment, or detect creature type. Other creatures can communicate telepathically with you only if you allow it. You can use an action to render yourself invisible to detect thoughts and similar effects. If you die while wearing the ring, your soul may enter the ring (only one soul at a time). DMG p.192.'
    },
    ring_of_warmth: {
      name: 'Ring of Warmth',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      rarity: 'uncommon',
      equipSlot: 'ring', requiresAttunement: true,
      effects: [{ type: 'resistance', value: 'cold', operation: 'grant' }],
      description: 'Uncommon. Requires attunement. You have resistance to cold damage. Additionally, you and everything you wear and carry are unharmed by temperatures as low as -50°F. DMG p.193.'
    },
    ring_of_water_walking: {
      name: 'Ring of Water Walking',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      rarity: 'uncommon',
      equipSlot: 'ring',
      requiresAttunement: false,
      effects: [
        { type: 'feature', operation: 'grant', value: 'water_walk' }
      ],
      description: 'Uncommon. No attunement required. While wearing this ring, you can stand on and move across any liquid surface as if it were solid ground (as the Water Walk spell). DMG p.193.'
    },
    quiver_of_ehlonna: {
      name: 'Quiver of Ehlonna',
      weight: 2, size: [1, 3], baseValue: 750, icon: '🏹',
      rarity: 'uncommon',
      requiresAttunement: false,
      containerSlots: [3, 5], maxWeight: 50,
      containerSize: 'extradimensional',
      description: 'Uncommon. No attunement required. Each of this quiver\'s three compartments connects to an extradimensional space that allows the quiver to hold numerous items while never weighing more than 2 pounds. The shortest compartment can hold up to sixty arrows, bolts, or similar objects. The mid-sized compartment holds up to eighteen javelins or similar objects. The longest compartment holds up to six long objects, such as bows, quarterstaffs, or spears. You can draw any item the quiver contains as if doing so from a regular quiver or scabbard. DMG p.188.'
    },
    stone_of_good_luck: {
      name: 'Stone of Good Luck (Luckstone)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '🍀',
      rarity: 'uncommon',
      requiresAttunement: true,
      effects: [
        { type: 'save:strength', operation: 'add', value: 1 },
        { type: 'save:dexterity', operation: 'add', value: 1 },
        { type: 'save:constitution', operation: 'add', value: 1 },
        { type: 'save:intelligence', operation: 'add', value: 1 },
        { type: 'save:wisdom', operation: 'add', value: 1 },
        { type: 'save:charisma', operation: 'add', value: 1 }
      ],
      description: 'Uncommon. Requires attunement. While this polished agate is on your person, you gain a +1 bonus to ability checks and saving throws. DMG p.205.'
    },

    // --- DMG Table G (rare) ---
    figurine_of_wondrous_power: {
      name: 'Figurine of Wondrous Power',
      weight: 1, size: [1, 1], baseValue: 1500, icon: '🦁',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rarity varies by figurine (Rare for most variants; see specific entries). No attunement required. A small statuette of a beast small enough to fit in a pocket. If you use an action to speak the figurine\'s command word and throw it to a point on the ground within 60 feet, the figurine becomes a living creature. If the space the creature would occupy is occupied, the figurine doesn\'t become a creature. The creature is friendly to you and your companions. It understands your languages and obeys your spoken commands. If you issue no commands, the creature defends itself but takes no other actions. The creature exists for a duration specific to each figurine; when the duration ends, the creature reverts to its figurine form. It reverts early if it drops to 0 hp or you use an action to speak the command word; once it reverts, it can\'t be used again until a specified amount of time has passed (each variant lists its own cooldown). Variants include the Bronze Griffon, Ebony Fly, Golden Lions, Ivory Goats, Marble Elephant, Obsidian Steed, Onyx Dog, Serpentine Owl, and Silver Raven. DMG p.169.'
    },
    figurine_of_wondrous_power_golden_lions: {
      name: 'Figurine of Wondrous Power (Golden Lions)',
      weight: 1, size: [1, 1], baseValue: 1500, icon: '🦁',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. A pair of golden lion figurines, sold and used as a pair. As an action, you can use both figurines simultaneously to summon two lions (using the Lion stat block) for up to 1 hour. Once both figurines have been used, they can\'t be used again until 7 days have passed. DMG p.170.'
    },
    // [APR 30 2026]: amulet_health intentionally NOT duplicated here —
    // the canonical definition (with `effects` array setting CON to 19)
    // lives at src/data/gameData.js line ~1103 in this same magical_items
    // category. getItemDefinition() walks all categories; the jewelry-
    // category stub at line ~538 is shadowed because magical_items hits
    // first. Test reflects the canonical entry.
    armor_of_vulnerability: {
      name: 'Armor of Vulnerability',
      weight: 65, size: [3, 3], baseValue: 4000, icon: '🛡️',
      armorType: 'heavy', ac: 18, minStr: 15, stealthDisadvantage: true,
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'bludgeoning', operation: 'grant' },
        { type: 'resistance', value: 'piercing', operation: 'grant' },
        { type: 'resistance', value: 'slashing', operation: 'grant' }
      ],
      description: 'Plate armor. Resistance to one of bludgeoning/piercing/slashing (DM choice). Cursed: vulnerability to the OTHER two. DMG p.152.'
    },
    arrow_catching_shield: {
      name: 'Arrow-Catching Shield',
      weight: 6, size: [2, 2], baseValue: 4000, icon: '🛡️',
      rarity: 'rare',
      armorType: 'shield', acBonus: 2,
      requiresAttunement: true,
      effects: [{ type: 'ac', operation: 'add', value: 2, condition: 'vs_ranged' }],
      description: 'Rare. Requires attunement. While holding it, you gain a +2 bonus to AC against ranged attacks (in addition to the shield\'s normal +2 bonus to AC). When a creature within 5 ft of you is targeted by a ranged attack, you can use your reaction to become the target instead. DMG p.151.'
    },
    belt_of_dwarvenkind: {
      name: 'Belt of Dwarvenkind',
      weight: 1, size: [2, 1], baseValue: 4000, icon: '🥋',
      rarity: 'rare',
      equipSlot: 'belt', requiresAttunement: true,
      effects: [
        { type: 'ability', target: 'con', operation: 'add', value: 2 },
        { type: 'sense', target: 'darkvision', operation: 'grant', value: 60 }
      ],
      description: 'Rare. Requires attunement. While wearing this belt, you gain a +2 bonus to Constitution score (max 20), advantage on Charisma (Persuasion) checks made against dwarves, and darkvision out to 60 ft. You have advantage on saving throws against poison and resistance to poison damage. You can speak, read, and write Dwarvish. Additionally, while attuned to the belt, there is a 50% chance each day at dawn that any nonmagical hair on your face grows, if applicable, becoming 2 inches longer if it wasn\'t already; the hair stops growing immediately if you ever lose attunement. DMG p.155.'
    },
    berserker_axe: {
      name: 'Berserker Axe',
      weight: 4, size: [1, 3], baseValue: 4000, icon: '🪓',
      rarity: 'rare',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      requiresAttunement: true, magicalBonus: 1,
      cursed: true,
      description: 'Rare. Requires attunement. +1 magic axe. Cursed: while attuned you cannot be rid of the axe except via remove curse or similar magic. You have disadvantage on attack rolls with weapons other than this axe. Whenever you take damage in combat, make a DC 15 WIS save; on a failed save you go berserk and must use your action each round to attack the creature nearest to you with the axe (extra attacks move to the next nearest target). You remain berserk until you start your turn with no creatures within 60 ft you can see or hear. DMG p.155.'
    },
    boots_of_levitation: {
      name: 'Boots of Levitation',
      weight: 1, size: [2, 2], baseValue: 4000, icon: '🥾',
      rarity: 'rare',
      equipSlot: 'boots', requiresAttunement: true,
      description: 'Rare. Requires attunement. While you wear these boots, you can use an action to cast the Levitate spell on yourself at will. DMG p.155.'
    },
    bowl_commanding_water_elementals: {
      name: 'Bowl of Commanding Water Elementals',
      weight: 3, size: [2, 2], baseValue: 4000, icon: '🌊',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. While this bowl is filled with water, you can use an action to speak the bowl\'s command word and summon a water elemental, as if you had cast the conjure elemental spell. The bowl can\'t be used this way again until the next dawn. The bowl is about 1 foot in diameter and half as deep, weighs 3 pounds, and holds about 3 gallons of water. DMG p.155.'
    },
    bracers_defense: {
      name: 'Bracers of Defense',
      weight: 1, size: [1, 1], baseValue: 6000, icon: '🛡️',
      rarity: 'rare',
      equipSlot: 'arms', requiresAttunement: true,
      effects: [{
        type: 'ac',
        operation: 'add',
        value: 2,
        condition: {
          when: 'unarmored',
          check: (character, context) => context?.unarmored === true && context?.noShield === true
        }
      }],
      description: 'Rare. Requires attunement. +2 AC while wearing no armor and using no shield. DMG p.156.'
    },
    brazier_of_commanding_fire_elementals: {
      name: 'Brazier of Commanding Fire Elementals',
      weight: 5, size: [2, 2], baseValue: 4000, icon: '🔥',
      rarity: 'rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Rare. No attunement required. While a fire burns in this brass brazier, you can use an action to speak the brazier\'s command word and summon a Fire Elemental, as if you had cast the Conjure Elemental spell. The brazier cannot be used this way again until the next dawn. The brazier weighs 5 lb. DMG p.156.'
    },
    cape_of_the_mountebank: {
      name: 'Cape of the Mountebank',
      weight: 1, size: [2, 3], baseValue: 4000, icon: '🧥',
      rarity: 'rare',
      equipSlot: 'cloak',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Rare. No attunement required. While wearing this cape, you can use it to cast the Dimension Door spell on yourself as a bonus action. Once used, this property cannot be used again until the next dawn. When you disappear and again when you reappear, a cloud of smoke billows from the cape. The smoke lightly obscures the space you left and the space you arrived in, and the smoke vanishes at the end of your next turn. A strong wind disperses the smoke. DMG p.156.'
    },
    censer_of_controlling_air_elementals: {
      name: 'Censer of Controlling Air Elementals',
      weight: 1, size: [1, 1], baseValue: 4000, icon: '🌬️',
      rarity: 'rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Rare. No attunement required. While incense burns in this censer, you can use an action to speak the censer\'s command word and summon an Air Elemental, as if you had cast the Conjure Elemental spell. The censer cannot be used this way again until the next dawn. The censer weighs 1 lb. DMG p.157.'
    },
    cloak_of_the_bat: {
      name: 'Cloak of the Bat',
      weight: 1, size: [2, 3], baseValue: 4000, icon: '🦇',
      rarity: 'rare',
      equipSlot: 'cloak', requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      effects: [
        { type: 'advantage', operation: 'advantage', target: 'skill:stealth' },
        { type: 'feature', target: 'flySpeed', operation: 'set', value: 40 }
      ],
      spells: [{ name: 'Polymorph', level: 4, usesPerDay: 1, currentUses: 1, dc: null, self: true }],
      description: 'Rare. Requires attunement. While wearing this cloak you have advantage on Dexterity (Stealth) checks. In an area of dim light or darkness, you can grip the cloak\'s edges with both hands and use it to fly at 40 ft (lose the speed if you stop gripping, or leave dim light or darkness). While in dim light or darkness, you can use an action to cast Polymorph on yourself, transforming into a bat (keeping your INT/WIS/CHA). Once used, this property can\'t be used again until the next dawn. DMG p.159.'
    },
    cube_of_force: {
      name: 'Cube of Force',
      weight: 1, size: [1, 1], baseValue: 4000, icon: '🟦',
      rarity: 'rare',
      requiresAttunement: true,
      charges: 36, maxCharges: 36, rechargeType: 'dawn',
      rechargeAmount: '1d20',
      description: 'Rare. Requires attunement. This cube is about an inch across; each of its six sides has a distinct symbol carved into it. The cube has 36 charges and regains 1d20 expended charges daily at dawn. Action: press one of the cube\'s sides and expend the listed charges to create an invisible 15-ft cube of force centered on you; the field lasts up to 1 minute or until you use another action to deactivate it, change faces, or run out of charges. Side 1 (1 charge): gases, wind, fog cannot pass. Side 2 (2 charges): nonliving matter cannot pass — walls, weapons, etc. are stopped. Side 3 (3 charges): living matter cannot pass. Side 4 (4 charges): spells (and spell effects) cannot pass. Side 5 (5 charges): nothing can pass — air, gas, light, spells, weapons, creatures all blocked. Side 6: deactivates the cube. Each spell that targets the cube or originates outside it causes the cube to lose charges per the RAW spell-charge cost table (e.g. disintegrate 1d12, passwall 1d6, prismatic spray 1d20, wall of fire 1d4). When charges reach 0, the cube deactivates and cannot be used again until refreshed. DMG p.160.'
    },
    daerns_instant_fortress: {
      name: "Daern's Instant Fortress",
      weight: 1, size: [1, 1], baseValue: 4000, icon: '🏰',
      rarity: 'rare',
      requiresAttunement: false,
      description: 'Rare. No attunement required. Action: place this metal cube, no more than 1 inch across, on the ground and speak its command word — the cube rapidly grows into a fortress that remains until you use an action to speak the command word that dismisses it (only works on an empty fortress). The fortress is a 20×20×30-ft square tower of adamantine, with battlements atop it and an arrow slit in the center of each side, plus a small trapdoor on the roof that opens onto the battlements. When activated, the tower pushes any creature in its space outward into the nearest unoccupied space; any creature in the tower\'s space that cannot be pushed must succeed on a DC 15 Dexterity save or take 10d10 bludgeoning damage (half on success). The tower is firmly anchored — it can\'t be knocked over. Walls and battlements have AC 20 and 100 HP, immune to nonmagical damage; spells require a check (DC determined by GM) to damage. The tower has an arrow slit on each side; the door is held closed by the user\'s command word. The fortress lasts until commanded to revert. DMG p.161.'
    },
    dagger_of_venom: {
      name: 'Dagger of Venom',
      weight: 1, size: [1, 2], baseValue: 4000, icon: '🗡️',
      rarity: 'rare',
      damage: '1d4', damageType: 'piercing',
      properties: ['Finesse', 'Light', 'Thrown (20/60)'],
      magicalBonus: 1,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Rare. +1 dagger. Action (1/dawn) to coat the blade in poison that persists 1 minute or until next hit. The next creature hit takes an extra 2d10 poison damage and must succeed on a DC 15 CON save or be poisoned for 1 minute (save halves damage and negates poisoned). DMG p.161.'
    },
    dragon_slayer: {
      name: 'Dragon Slayer',
      weight: 3, size: [1, 4], baseValue: 4000, icon: '🐉',
      rarity: 'rare',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 1,
      description: 'Rare. +1 magic sword. On hit against a creature of the dragon type, +3d6 damage of the weapon\'s type. DMG p.166.'
    },
    elven_chain: {
      name: 'Elven Chain',
      weight: 20, size: [2, 2], baseValue: 4000, icon: '⛓️',
      rarity: 'rare',
      armorType: 'medium', ac: 13, maxDexMod: 2,
      // [Spec 1b — Phase B / #328]: Structural proficiency override. Replaces
      // the previous `item_elven_chain_proficiency_override` feature breadcrumb
      // (which had no consumer). hasArmorProficiency() reads this field before
      // falling back to armorType.
      proficiencyAs: 'light',
      description: 'Rare. No attunement required. Chain shirt of finer-than-steel links. While wearing it, you are proficient with this armor even if you lack proficiency with medium armor. DMG p.168.'
    },
    gem_of_seeing: {
      name: 'Gem of Seeing',
      weight: 0.1, size: [1, 1], baseValue: 4000, icon: '💎',
      rarity: 'rare',
      requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      rechargeAmount: '1d3',
      description: 'Rare. Requires attunement. This polished gem has 3 charges. As an action, you can speak the gem\'s command word and expend 1 charge: for the next 10 minutes, you have Truesight out to 120 ft when you peer through the gem. The gem regains 1d3 expended charges daily at dawn. DMG p.171.'
    },
    giant_slayer: {
      name: 'Giant Slayer',
      weight: 3, size: [1, 4], baseValue: 4000, icon: '🗡️',
      rarity: 'rare',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 1,
      description: 'Rare. +1 magic axe or sword. On every hit against a creature of the giant type (RAW includes ettins and trolls), +2d6 damage of the weapon\'s type AND the giant must succeed on a DC 15 STR save or fall prone. DMG p.172.'
    },
    glamoured_studded_leather: {
      name: 'Glamoured Studded Leather',
      weight: 13, size: [2, 2], baseValue: 4000, icon: '🌟',
      rarity: 'rare',
      armorType: 'light', ac: 12,
      magicalBonus: 1,
      description: 'Rare. No attunement required. While wearing this armor, you gain a +1 bonus to AC. Bonus action to speak the command word: armor assumes the appearance of normal clothing or another suit of armor (your choice). DMG p.172.'
    },

    // --- DMG Table H (very rare) ---
    amulet_of_the_planes: {
      name: 'Amulet of the Planes',
      weight: 0.1, size: [1, 1], baseValue: 13000, icon: '🌌',
      rarity: 'very rare',
      equipSlot: 'neck', requiresAttunement: true,
      description: 'Very rare. Requires attunement. While wearing this amulet, you can use an action to name a location that you are familiar with on another plane of existence. Then make a DC 15 Intelligence check. On a success, you cast the Plane Shift spell. On a failure, you and each creature and object within 15 feet of you travel to a random destination — roll a d100: on 1–60 you travel to a random plane of existence, on 61–100 you travel to a random location on the plane you named. DMG p.150.'
    },
    carpet_of_flying_small: {
      name: 'Carpet of Flying (3×5)',
      weight: 5, size: [2, 3], baseValue: 13000, icon: '🪂',
      rarity: 'very rare',
      requiresAttunement: false,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'set', value: 80 }],
      description: 'A 3 ft × 5 ft carpet. Speak its command word as an action to make it hover and fly within 30 ft. Fly speed 80 ft, carry capacity 200 lb (or 400 lb at half speed). DMG p.157.'
    },
    carpet_of_flying_medium: {
      name: 'Carpet of Flying (4×6)',
      weight: 5, size: [2, 3], baseValue: 13000, icon: '🪂',
      rarity: 'very rare',
      requiresAttunement: false,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'set', value: 60 }],
      description: 'A 4 ft × 6 ft carpet. Speak its command word as an action to make it hover and fly within 30 ft. Fly speed 60 ft, carry capacity 400 lb (or 800 lb at half speed). DMG p.157.'
    },
    carpet_of_flying_large: {
      name: 'Carpet of Flying (5×7)',
      weight: 5, size: [3, 4], baseValue: 13000, icon: '🪂',
      rarity: 'very rare',
      requiresAttunement: false,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'set', value: 40 }],
      description: 'A 5 ft × 7 ft carpet. Speak its command word as an action to make it hover and fly within 30 ft. Fly speed 40 ft, carry capacity 600 lb (or 1,200 lb at half speed). DMG p.157.'
    },
    carpet_of_flying_xlarge: {
      name: 'Carpet of Flying (6×9)',
      weight: 5, size: [3, 4], baseValue: 13000, icon: '🪂',
      rarity: 'very rare',
      requiresAttunement: false,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'set', value: 30 }],
      description: 'A 6 ft × 9 ft carpet. Speak its command word as an action to make it hover and fly within 30 ft. Fly speed 30 ft, carry capacity 800 lb (or 1,600 lb at half speed). DMG p.157.'
    },
    crystal_ball: {
      name: 'Crystal Ball',
      weight: 3, size: [1, 1], baseValue: 13000, icon: '🔮',
      rarity: 'very rare',
      requiresAttunement: true,
      description: 'Very rare. Requires attunement. The typical crystal ball, a very rare item, is about 6 inches in diameter. While touching it, you can cast the Scrying spell (save DC 17) with it. The two variants — Crystal Ball of Mind Reading and Crystal Ball of True Seeing — are Legendary. DMG p.159.'
    },
    ring_of_regeneration: {
      name: 'Ring of Regeneration',
      weight: 0.1, size: [1, 1], baseValue: 13000, icon: '💍',
      rarity: 'very rare',
      equipSlot: 'ring', requiresAttunement: true,
      description: 'Very rare. Requires attunement. While wearing this ring, you regain 1d6 hp every 10 minutes provided you have at least 1 hp. If you lose a body part, the ring regrows it (and restores associated function) over 1d6+1 days, as long as you wear the ring during that time. DMG p.192.'
    },
    // Spec 2 — Ring of Resistance × 10 damage-type variants (DMG p.191)
    ring_of_resistance_acid: {
      name: 'Ring of Resistance (Acid)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'acid', operation: 'grant' }
      ],
      description: 'You have resistance to acid damage while wearing this ring. The gemstone is a pearl, set in the ring. DMG p.191.'
    },
    ring_of_resistance_cold: {
      name: 'Ring of Resistance (Cold)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'cold', operation: 'grant' }
      ],
      description: 'You have resistance to cold damage while wearing this ring. The gemstone is a tourmaline, set in the ring. DMG p.191.'
    },
    ring_of_resistance_fire: {
      name: 'Ring of Resistance (Fire)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'fire', operation: 'grant' }
      ],
      description: 'You have resistance to fire damage while wearing this ring. The gemstone is a garnet, set in the ring. DMG p.191.'
    },
    ring_of_resistance_force: {
      name: 'Ring of Resistance (Force)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'force', operation: 'grant' }
      ],
      description: 'You have resistance to force damage while wearing this ring. The gemstone is a sapphire, set in the ring. DMG p.191.'
    },
    ring_of_resistance_lightning: {
      name: 'Ring of Resistance (Lightning)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'lightning', operation: 'grant' }
      ],
      description: 'You have resistance to lightning damage while wearing this ring. The gemstone is a citrine, set in the ring. DMG p.191.'
    },
    ring_of_resistance_necrotic: {
      name: 'Ring of Resistance (Necrotic)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'necrotic', operation: 'grant' }
      ],
      description: 'You have resistance to necrotic damage while wearing this ring. The gemstone is a jet, set in the ring. DMG p.191.'
    },
    ring_of_resistance_poison: {
      name: 'Ring of Resistance (Poison)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'poison', operation: 'grant' }
      ],
      description: 'You have resistance to poison damage while wearing this ring. The gemstone is an amethyst, set in the ring. DMG p.191.'
    },
    ring_of_resistance_psychic: {
      name: 'Ring of Resistance (Psychic)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'psychic', operation: 'grant' }
      ],
      description: 'You have resistance to psychic damage while wearing this ring. The gemstone is a jade, set in the ring. DMG p.191.'
    },
    ring_of_resistance_radiant: {
      name: 'Ring of Resistance (Radiant)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'radiant', operation: 'grant' }
      ],
      description: 'You have resistance to radiant damage while wearing this ring. The gemstone is a topaz, set in the ring. DMG p.191.'
    },
    ring_of_resistance_thunder: {
      name: 'Ring of Resistance (Thunder)',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '💍',
      equipSlot: 'ring',
      rarity: 'rare',
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'thunder', operation: 'grant' }
      ],
      description: 'You have resistance to thunder damage while wearing this ring. The gemstone is a spinel, set in the ring. DMG p.191.'
    },
    ring_of_shooting_stars: {
      name: 'Ring of Shooting Stars',
      weight: 0.1, size: [1, 1], baseValue: 13000, icon: '🌠',
      rarity: 'very rare',
      equipSlot: 'ring', requiresAttunement: true,
      charges: 6, maxCharges: 6, rechargeType: 'dusk',
      description: 'Very rare. Requires attunement at night, outdoors, under a starry sky. While wearing the ring you can cast: Faerie Fire (1 charge), Light (no charge), Ball Lightning (2 charges, four 5-ft globes of lightning, ranged spell attack +7 for 4d12 lightning each), or Shooting Stars (1–3 charges, one 5-ft luminous mote per charge that explodes for 5d4 radiant in a 15-ft radius, DEX save DC 17 for half). Regains 1d6 charges daily at dusk. DMG p.193.'
    },
    ring_of_telekinesis: {
      name: 'Ring of Telekinesis',
      weight: 0.1, size: [1, 1], baseValue: 13000, icon: '💍',
      rarity: 'very rare',
      equipSlot: 'ring', requiresAttunement: true,
      description: 'Very rare. Requires attunement. While wearing this ring, you can cast Telekinesis at will, but you can only target objects that aren\'t being worn or carried. DMG p.193.'
    },
    robe_of_scintillating_colors: {
      name: 'Robe of Scintillating Colors',
      weight: 1, size: [2, 3], baseValue: 13000, icon: '🌈',
      rarity: 'very rare',
      equipSlot: 'armor', requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      rechargeAmount: '1d3',
      description: 'Very rare. Requires attunement. The robe has 3 charges and regains 1d3 expended charges daily at dawn. Action: expend 1 charge to cause the robe to shimmer with shifting colors until the end of your next turn. During this time, the robe sheds bright light in a 30-ft radius and dim light for an additional 30 ft. Creatures that can see you have disadvantage on attack rolls against you. In addition, any creature in the bright light that can see you when the robe\'s power is activated must succeed on a DC 15 Wisdom save or become stunned until the effect ends. You can maintain the effect on subsequent turns by using an action to expend another 1 charge (you can sustain it up to 1 minute total). When the effect ends, creatures cannot be stunned by the robe again for 24 hours. DMG p.194.'
    },
    robe_of_stars: {
      name: 'Robe of Stars',
      weight: 1, size: [2, 3], baseValue: 13000, icon: '⭐',
      rarity: 'very rare',
      equipSlot: 'armor', requiresAttunement: true,
      charges: 6, maxCharges: 6, rechargeType: 'dawn',
      effects: [{ type: 'save', operation: 'add', value: 1 }],
      description: 'Very rare. Requires attunement. This black or dark blue robe is embroidered with small white or silver stars; the wearer gains a +1 bonus to saving throws while wearing it. Six stars, located on the upper-front portion of the robe, glow faintly. While wearing the robe and on the Material Plane, you can use an action to enter the Astral Plane along with everything you are wearing and carrying. You remain there until you use an action to return to the Material Plane; you reappear in the same space (or the nearest unoccupied space). Action: detach one of the robe\'s glowing stars and use it to cast Magic Missile as a 5th-level spell (5 darts). Each detached star is consumed; the robe regenerates 1d6 detached stars at dusk (variant: some printings regenerate at dawn — implementation uses dawn for consistency with rest cycle). When all 6 stars are gone, the robe cannot cast Magic Missile again until enough stars regenerate. DMG p.195.'
    },
    rod_of_absorption: {
      name: 'Rod of Absorption',
      weight: 2, size: [1, 2], baseValue: 13000, icon: '🔱',
      rarity: 'very rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      description: 'Very rare. Requires attunement. Reaction when targeted by a spell that targets only you and has no area of effect: rod absorbs the spell, canceling it and storing energy equal to its level. The rod can store up to 50 levels of energy total over its existence. If you are a spellcaster, you can spend stored levels as an action to cast a prepared/known spell of the same level. DMG p.197.'
    },
    rod_of_alertness: {
      name: 'Rod of Alertness',
      weight: 2, size: [1, 2], baseValue: 13000, icon: '👁️',
      rarity: 'very rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      effects: [
        { type: 'advantage', target: 'skill:perception', operation: 'advantage' },
        { type: 'advantage', target: 'initiative', operation: 'advantage' }
      ],
      spells: [
        { name: 'Detect Evil and Good', level: 1, usesPerDay: null },
        { name: 'Detect Magic', level: 1, usesPerDay: null },
        { name: 'Detect Poison and Disease', level: 1, usesPerDay: null },
        { name: 'See Invisibility', level: 2, usesPerDay: null }
      ],
      description: 'Very rare. Requires attunement. While holding the rod: advantage on Wisdom (Perception) checks and initiative rolls. As an action while holding it, you can cast Detect Evil and Good, Detect Magic, Detect Poison and Disease, or See Invisibility. Protective Aura (1/dawn): as an action, plant the rod in the ground; you and friendly creatures within 20 ft gain +1 AC and +1 to saving throws while within the area. Aura lasts 10 min or until the rod is removed. DMG p.197.'
    },
    rod_of_security: {
      name: 'Rod of Security',
      weight: 2, size: [1, 2], baseValue: 13000, icon: '🔐',
      rarity: 'very rare',
      equipSlot: 'mainhand',
      description: 'Very rare. No attunement required. Action: speak the command word and you plus up to 199 willing creatures within 30 ft are transported to an extraplanar paradise. Time there can last up to 200 days cumulative (and divides evenly among travelers). When time expires or the user wills it, the group returns to the unoccupied spaces nearest the original departure point. The rod cannot be used again until two days have passed. DMG p.198.'
    },
    rod_of_the_pact_keeper_plus_2: {
      name: 'Rod of the Pact Keeper +2',
      weight: 2, size: [1, 2], baseValue: 13000, icon: '🔱',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 2, condition: 'class:warlock' }, { type: 'spellDC', operation: 'add', value: 2, condition: 'class:warlock' }],
      description: 'Rare. Requires attunement by a warlock. +2 to warlock spell attack rolls and warlock spell save DC. Once per dawn as an action, recover one expended Pact Magic spell slot. DMG p.197.'
    },
    scimitar_of_speed: {
      name: 'Scimitar of Speed',
      weight: 3, size: [1, 3], baseValue: 13000, icon: '🌪️',
      rarity: 'very rare',
      damage: '1d6', damageType: 'slashing',
      properties: ['Finesse', 'Light'],
      magicalBonus: 2,
      requiresAttunement: true,
      description: 'Very rare. Requires attunement. +2 magic scimitar. Bonus action: make one melee attack with this weapon. DMG p.199.'
    },
    shield_of_missile_attraction: {
      name: 'Shield of Missile Attraction',
      weight: 6, size: [2, 2], baseValue: 13000, icon: '🛡️',
      rarity: 'rare',
      armorType: 'shield', acBonus: 2,
      requiresAttunement: true,
      cursed: true,
      effects: [{ type: 'resistance', value: 'ranged_weapon', operation: 'grant' }],
      description: 'Rare. Requires attunement. While holding it, you have resistance to damage from ranged weapon attacks. Curse: once attuned, you cannot doff voluntarily until remove curse or similar magic is cast on you. Whenever a ranged attack is made against a target within 10 ft of you, the curse causes you to become the target instead. DMG p.200.'
    },
    staff_of_charming: {
      name: 'Staff of Charming',
      weight: 4, size: [1, 5], baseValue: 13000, icon: '💕',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 10, maxCharges: 10, rechargeType: 'dawn',
      description: 'Rare. Requires attunement by a bard, cleric, druid, sorcerer, warlock, or wizard. 10 charges. Action: expend 1 charge to cast Charm Person, Command, or Comprehend Languages (DC 15). Reaction: when a charm or compulsion is cast on you, expend 1 charge and the spell is negated; you can also expend 1 charge as a reaction to negate a charm or compulsion saving throw cast on you. Can be used as a quarterstaff. Regains 1d8+2 charges at dawn; on a roll of 1 on a d20 after the last charge is expended, the staff loses its magic and becomes a non-magical quarterstaff. DMG p.201.'
    },
    staff_of_swarming_insects: {
      name: 'Staff of Swarming Insects',
      weight: 4, size: [1, 5], baseValue: 13000, icon: '🐝',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 10, maxCharges: 10, rechargeType: 'dawn',
      description: 'Rare. Requires attunement by a bard, cleric, druid, sorcerer, warlock, or wizard. 10 charges. Action: expend 1 charge to cast Giant Insect (DC 15, 4 charges) or Insect Plague (DC 15, 5 charges). Insect Cloud (1 charge): action to expend 1 charge to surround yourself with a swarm of harmless insects in a 30-ft radius. The cloud moves with you and heavily obscures the area for everyone except you; the swarm lasts 10 minutes, until you are incapacitated or die, or until you dismiss it as an action. Regains 1d6+4 charges at dawn; on a roll of 1 on a d20 after the last charge is expended, the staff crumbles to dust and is destroyed. DMG p.205.'
    },
    staff_of_the_woodlands: {
      name: 'Staff of the Woodlands',
      weight: 4, size: [1, 5], baseValue: 13000, icon: '🌳',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      magicalBonus: 2,
      charges: 10, maxCharges: 10, rechargeType: 'dawn',
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 2, condition: 'class:druid' }, { type: 'spellDC', operation: 'add', value: 2, condition: 'class:druid' }],
      description: 'Rare. Requires attunement by a druid. Magic quarterstaff that grants a +2 bonus to attack and damage rolls. While holding it, you have +2 to spell attack rolls and spell save DC. 10 charges. Action: expend charges to cast Animal Friendship (1 charge), Awaken (5), Barkskin (2), Locate Animals or Plants (2), Pass Without Trace (2), Speak with Animals (1), Speak with Plants (3), Wall of Thorns (6). Tree Form: action to plant the staff in the ground and command it to grow into a healthy tree 60 ft tall with a 5-ft trunk (or back to staff form as another action). Plant Door: while in a forest, expend 1 charge to allow your party (up to 8 people) to merge with a non-mature tree and emerge from another tree of the same type within 500 ft. Regains 1d6+4 charges at dawn; on a roll of 1 on a d20 after the last charge is expended, the staff loses its properties and becomes a non-magical quarterstaff. DMG p.206.'
    },
    staff_of_withering: {
      name: 'Staff of Withering',
      weight: 4, size: [1, 5], baseValue: 13000, icon: '💀',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Rare. Requires attunement by a cleric, druid, or warlock. Functions as a magic quarterstaff. 3 charges; regains 1d3 charges at dawn. On a successful melee attack with the staff, expend 1 charge to deal an extra 2d10 necrotic damage to the target; the target must succeed on a DC 15 CON save or have disadvantage on STR and CON checks/saving throws for 1 hour. DMG p.207.'
    },
    stone_of_controlling_earth_elementals: {
      name: 'Stone of Controlling Earth Elementals',
      weight: 5, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Rare. No attunement required. If the stone is touching the ground when you use an action to speak its command word, you summon an Earth Elemental, as if you had cast the Conjure Elemental spell. The stone cannot be used this way again until the next dawn. The stone weighs 5 lb. DMG p.205.'
    },
    sun_blade: {
      name: 'Sun Blade',
      weight: 3, size: [1, 4], baseValue: 13000, icon: '☀️',
      rarity: 'rare',
      damage: '1d8', damageType: 'radiant',
      properties: ['Finesse', 'Versatile (1d10)'],
      magicalBonus: 2,
      requiresAttunement: true,
      description: 'Rare. Requires attunement. This item appears to be a longsword hilt. While grasping the hilt, you can use a bonus action to cause a blade of pure radiance to spring into existence, or make the blade disappear. While the blade exists, this magic longsword has the Finesse property. If you are proficient with shortswords or longswords, you are proficient with the sun blade. The blade is the equivalent of any magic weapon for the purpose of overcoming resistance and immunity to nonmagical attacks. It deals radiant damage instead of slashing damage. When you hit an undead with it, that target takes an extra 1d8 radiant damage. The sword\'s luminous blade emits bright light in a 15-foot radius and dim light for an additional 15 feet. The light is sunlight. While the blade persists, you can use an action to expand or reduce the bright light\'s radius by 5 feet on each end, to a maximum of 30 feet or a minimum of 10 feet. DMG p.205.'
    },
    sword_of_life_stealing: {
      name: 'Sword of Life Stealing',
      weight: 3, size: [1, 4], baseValue: 13000, icon: '☠️',
      rarity: 'rare',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      requiresAttunement: true,
      description: 'Rare. Requires attunement. Magic sword. When you attack a creature with this weapon and roll a 20 on the attack roll, that target takes an extra 3d6 necrotic damage if it isn\'t a construct or undead. You also gain temporary hit points equal to the extra damage dealt. DMG p.206.'
    },
    sword_of_wounding: {
      name: 'Sword of Wounding',
      weight: 3, size: [1, 4], baseValue: 13000, icon: '🩸',
      rarity: 'rare',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      requiresAttunement: true,
      description: 'Rare. Requires attunement. Magic sword. On hit, target must succeed on a DC 15 CON save or gain a wound. At the start of each of the wounded target\'s turns, it takes 1d4 necrotic damage for each wound it has, and wounds stack. End of any turn, target makes a DC 15 CON save to end one wound (or a creature can use an action to make a DC 15 Medicine check to end one wound). Healing magic that restores HP ends all wounds on the target. DMG p.207.'
    },
    tentacle_rod: {
      name: 'Tentacle Rod',
      weight: 4, size: [1, 2], baseValue: 13000, icon: '🐙',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      description: 'Rare. Requires attunement. Made by drow. Action while holding the rod: make a melee attack with each of its three tentacles. Each attack has reach 15 ft, +9 to hit, and deals 1d6 bludgeoning on a hit. If you hit the SAME target with all three tentacles in one action, that target must succeed on a DC 15 CON save or have its speed halved, suffer disadvantage on Dexterity saves, and be unable to make more than one attack on its turn for 1 minute. DMG p.207.'
    },
    wand_of_binding: {
      name: 'Wand of Binding',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🪄',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      description: 'Spellcaster attunement. 7 charges. Spells (DC 17): Hold Person (2 charges), Hold Monster (5 charges). Reaction to expend 3 charges: gain advantage on a save vs paralyzed/restrained, or end the condition on self. Regains 1d6+1 charges at dawn. DMG p.211.'
    },
    wand_of_enemy_detection: {
      name: 'Wand of Enemy Detection',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🪄',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Spellcaster attunement. 3 charges. Action: expend 1 charge. For 1 minute (concentration), you know direction of nearest creature hostile to you within 60 ft (even invisible/disguised/ethereal). Regains 1d3 charges at dawn. DMG p.211.'
    },
    wand_of_fear: {
      name: 'Wand of Fear',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🪄',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      description: '7 charges. Command (1 charge): target within 30 ft, DC 15 WIS save or be commanded "flee" or "grovel" for 1 minute. Cone of Fear (2 charges): each creature in 60-ft cone makes DC 15 WIS save or is frightened of you for 1 minute. Regains 1d6+1 charges at dawn. DMG p.211.'
    },
    wand_of_fireballs: {
      name: 'Wand of Fireballs',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🔥',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      description: 'Spellcaster attunement. 7 charges. Action: expend 1+ charges to cast Fireball (DC 15) at slot level 3 + (charges spent - 1), max 7. Regains 1d6+1 charges at dawn; if last charge expended roll d20, on 1 the wand crumbles to ashes. DMG p.211.'
    },
    wand_of_paralysis: {
      name: 'Wand of Paralysis',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🪄',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      description: 'Spellcaster attunement. 7 charges. Action: expend 1 charge for a ranged spell attack at a target within 60 ft; on hit target makes DC 15 CON save or is paralyzed for 1 minute (save each turn ends). Regains 1d6+1 charges at dawn. DMG p.212.'
    },
    // [FIX MAY 2026 — Q10 wandmaker prereq]: Wand of Polymorph (DMG p.212) was
    // referenced by the wandmaker shop loot pool in App.jsx as `wand_polymorph`
    // but never defined in BASE_ITEMS. Added with canonical key `wand_of_polymorph`
    // matching the project's wand-of-* naming convention.
    wand_of_polymorph: {
      name: 'Wand of Polymorph',
      weight: 1, size: [1, 2], baseValue: 50000, icon: '🪄',
      rarity: 'very rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      attunementRequirement: 'spellcaster',
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      spells: [
        { name: 'Polymorph', level: 4, dc: null }
      ],
      description: 'Very rare. Requires attunement by a spellcaster. 7 charges. Action: expend 1 charge to cast Polymorph (save DC 15) on a target within 60 feet. Regains 1d6+1 charges at dawn; if you expend the last charge, roll a d20: on a 1, the wand crumbles into ashes and is destroyed. DMG p.212.'
    },
    wand_of_the_war_mage_plus_2: {
      name: 'Wand of the War Mage +2',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🪄',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 2 }],
      description: 'Spellcaster attunement. +2 to spell attack rolls. Ignore half cover when making spell attacks. DMG p.211.'
    },
    wand_of_wonder: {
      name: 'Wand of Wonder',
      weight: 1, size: [1, 2], baseValue: 13000, icon: '🪄',
      rarity: 'rare',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 7, maxCharges: 7, rechargeType: 'dawn',
      description: 'Spellcaster attunement. 7 charges. Action: expend 1 charge and target a creature/object/area within 120 ft. Roll d100 on Wand of Wonder table for random spell-like effect. Regains 1d6+1 charges at dawn; if last charge expended roll d20, on 1 the wand crumbles to dust. DMG p.212.'
    },
    wings_of_flying: {
      name: 'Wings of Flying',
      weight: 0.1, size: [1, 1], baseValue: 13000, icon: '🪽',
      rarity: 'rare',
      equipSlot: 'cloak', requiresAttunement: true,
      effects: [{ type: 'feature', target: 'flySpeed', operation: 'set', value: 60 }],
      description: 'Rare. Requires attunement. While wearing this cloak, you can use an action to speak its command word, which causes a pair of bat or bird wings to sprout from your back. The wings last for 1 hour or until you repeat the command word as an action. While the wings sprout, you have a flying speed of 60 feet. When the wings disappear, you can\'t use them again for 1d12 hours. DMG p.214.'
    },
    candle_of_invocation: {
      name: 'Candle of Invocation',
      weight: 0.1, size: [1, 1], baseValue: 13000, icon: '🕯️',
      rarity: 'very rare',
      requiresAttunement: true,
      attunementRequirement: 'cleric',
      description: 'Very rare. Requires attunement by a cleric. The candle has an alignment determined when it is created (matching one of the nine alignments); the candle\'s effect depends on whether the alignment matches the wielder\'s. Action to light: while it burns, the candle sheds dim light in a 30-ft radius. Any creature within that light whose alignment matches the candle\'s gains advantage on attack rolls, saving throws, and ability checks. In addition, a cleric within the candle\'s light whose alignment matches the candle\'s can cast 1st-level cleric spells they have prepared at +1 spell level (treated as cast from a 2nd-level slot, etc.). Alternatively, when you light the candle for the first time, you can cast the Gate spell with it; doing so destroys the candle. The candle burns for a total of 4 hours; you can snuff it out and relight it, and the remaining burn time persists. DMG p.156.'
    },
    cloak_of_arachnida: {
      name: 'Cloak of Arachnida',
      weight: 1, size: [2, 3], baseValue: 13000, icon: '🕸️',
      rarity: 'very rare',
      equipSlot: 'cloak', requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      effects: [
        { type: 'resistance', value: 'poison', operation: 'grant' },
        { type: 'feature', target: 'climbSpeed', operation: 'set', value: 'walk' }
      ],
      spells: [{ name: 'Web', level: 2, usesPerDay: 1, currentUses: 1, dc: 13 }],
      description: 'Very Rare. Requires attunement. Black silk garment with silvery threads. While wearing it: resistance to poison damage; climb speed equal to walking speed; can move on vertical surfaces and upside down along ceilings while leaving your hands free; can\'t be caught in webs and treat webs as difficult terrain. Action to cast Web (DC 13) — the spell\'s area is doubled. Once used, can\'t be used again until the next dawn. DMG p.158.'
    },
    dancing_sword: {
      name: 'Dancing Sword',
      weight: 3, size: [1, 4], baseValue: 13000, icon: '🗡️',
      rarity: 'very rare',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      requiresAttunement: true,
      description: 'Very rare. Requires attunement. Bonus action: toss the sword into the air and speak the command word — the sword begins to hover, flies up to 30 ft, and attacks one creature of your choice within 5 ft of it using your stats. At the start of each of your turns, the sword can attack again, up to 4 turns total. After the 4th attack, it falls to your feet or returns to your hand. DMG p.161.'
    },
    demon_armor: {
      name: 'Demon Armor',
      weight: 65, size: [3, 3], baseValue: 13000, icon: '👹',
      rarity: 'very rare',
      armorType: 'heavy', ac: 18, minStr: 15, stealthDisadvantage: true,
      requiresAttunement: true, magicalBonus: 1,
      cursed: true,
      description: 'Very rare. Requires attunement. +1 plate armor. While wearing it, your unarmed strikes deal 1d8 slashing as claws and gain +1 to attack/damage. Curse: once attuned, you cannot doff voluntarily; you have disadvantage on attacks vs demons; demons have advantage attacking you. DMG p.165.'
    },
    dwarven_plate: {
      name: 'Dwarven Plate',
      weight: 65, size: [3, 3], baseValue: 13000, icon: '🛡️',
      rarity: 'very rare',
      armorType: 'heavy', ac: 18, minStr: 15, stealthDisadvantage: true,
      effects: [{ type: 'ac', operation: 'add', value: 2 }, { type: 'feature', target: 'pushedDistanceReduction', operation: 'add', value: 10 }],
      description: 'Very rare. No attunement required. While wearing this armor, you gain a +2 bonus to AC. Additionally, when an effect moves you against your will along the ground, you can use your reaction to reduce the distance you are moved by up to 10 ft. DMG p.167.'
    },
    dwarven_thrower: {
      name: 'Dwarven Thrower',
      weight: 2, size: [1, 2], baseValue: 13000, icon: '🔨',
      rarity: 'very rare',
      damage: '1d8', damageType: 'bludgeoning',
      properties: ['Versatile (1d10)', 'Thrown (20/60)'],
      magicalBonus: 3,
      requiresAttunement: true,
      description: 'Very rare. Requires attunement by a dwarf. +3 magic warhammer. Has the Thrown property (range 20/60); when thrown it returns to your hand after the attack. On hit, +1d8 damage (or +2d8 if the target is a giant). DMG p.167.'
    },

    // --- DMG Table I (legendary) ---
    defender: {
      name: 'Defender',
      weight: 3, size: [1, 4], baseValue: 50000, icon: '🛡️',
      rarity: 'legendary',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 3,
      requiresAttunement: true,
      description: 'Legendary. Requires attunement. +3 magic sword. At the start of each of your turns, you can transfer up to all of the +3 bonus to your AC instead of attack/damage; the transferred bonus lasts until the start of your next turn. DMG p.164.'
    },
    hammer_of_thunderbolts: {
      name: 'Hammer of Thunderbolts',
      weight: 15, size: [1, 3], baseValue: 50000, icon: '🔨',
      rarity: 'legendary',
      damage: '2d6', damageType: 'bludgeoning',
      properties: ['Heavy', 'Two-Handed'],
      magicalBonus: 1,
      requiresAttunement: true,
      charges: 5, maxCharges: 5, rechargeType: 'dawn',
      description: 'Legendary. Requires attunement. +1 magic maul (2d6 bludgeoning). While wielding it, your Strength score is 30 if you also wear a belt of giant strength (any variety) and gauntlets of ogre power (both attuned). Has 5 charges. Action: throw the hammer up to 600 ft and speak the command word, expending 1 charge. The hammer becomes a thunderbolt; on a hit it deals normal damage. If the target is a giant, the giant must succeed on a DC 17 CON save or die. Every other creature within 30 ft of the target makes a DC 17 CON save or be stunned for 30 seconds. The hammer returns to your hand. Regains 1d4+1 charges at dawn. DMG p.173.'
    },
    luck_blade: {
      name: 'Luck Blade',
      weight: 3, size: [1, 4], baseValue: 50000, icon: '🍀',
      rarity: 'legendary',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 1,
      requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'never',
      effects: [{ type: 'save', operation: 'add', value: 1 }],
      description: 'Legendary. Requires attunement. +1 magic sword. While holding it, +1 to all saving throws. Luck (1/dawn): no action required — call on the sword\'s luck to reroll one attack roll, ability check, or saving throw you dislike; you must use the second roll. Wish: the sword has 1d4-1 wish charges (DM rolled, 0-3) that do NOT recover; while holding it you can use an action to expend 1 wish charge to cast the Wish spell from it. DMG p.180.'
    },
    sword_of_answering: {
      name: 'Sword of Answering',
      weight: 3, size: [1, 4], baseValue: 50000, icon: '⚔️',
      rarity: 'legendary',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 3,
      requiresAttunement: true,
      description: 'Legendary. Requires attunement by a creature of the same alignment as the sword. +3 magic longsword. While holding it, reaction to make one melee attack against a creature within 5 ft that damaged you — the attack roll has advantage, and damage dealt by this attack ignores damage resistance and damage immunity. Only nine of these swords exist (one per alignment). DMG p.206.'
    },
    holy_avenger: {
      name: 'Holy Avenger',
      weight: 3, size: [1, 4], baseValue: 50000, icon: '✝️',
      rarity: 'legendary',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 3,
      requiresAttunement: true,
      description: 'Legendary. Requires attunement by a paladin. You gain a +3 bonus to attack and damage rolls made with this magic weapon. When you hit a fiend or an undead with it, that target takes an extra 2d10 radiant damage. While you hold the drawn sword, it creates an aura in a 10-foot radius around you. You and all creatures friendly to you in the aura have advantage on saving throws against spells and other magical effects. If you have 17 or more levels in the paladin class, the radius of the aura increases to 30 feet. DMG p.174.'
    },
    ring_of_djinni_summoning: {
      name: 'Ring of Djinni Summoning',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      rarity: 'legendary',
      equipSlot: 'ring', requiresAttunement: true,
      description: 'Legendary. Requires attunement. As an action, you can summon the djinni bound to the ring, which appears in an unoccupied space within 120 feet. The djinni serves only you, follows your commands to the best of its ability for 1 hour, then disappears. Once used, the ring can\'t be used again until the next dawn. If the djinni ever dies, the ring becomes nonmagical. DMG p.190.'
    },
    // Ring of Elemental Command — 4 element variants (Spec 2 / 2026-05-15, DMG p.190)
    // Fire variant has base fire resistance. Air/Earth/Water have no base resistance
    // (resistance is granted only after slaying an elemental of the linked plane).
    // All variants: 5 charges, recharge 1d4+1 at dawn, legendary, requires attunement.
    ring_of_elemental_command_air: {
      name: 'Ring of Elemental Command (Air)',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      equipSlot: 'ring',
      rarity: 'legendary',
      requiresAttunement: true,
      charges: 5, maxCharges: 5, rechargeType: 'dawn', rechargeAmount: '1d4+1',
      spellSaveDC: 17,
      effects: [
        { type: 'advantage', target: 'save:air_elemental', operation: 'advantage' }
      ],
      spells: [
        { name: 'Dominate Monster', chargeCost: 2, target: 'air elemental only' },
        { name: 'Chain Lightning', chargeCost: 3 },
        { name: 'Gust of Wind', chargeCost: 2 },
        { name: 'Wind Wall', chargeCost: 1 }
      ],
      description: 'Linked to the Elemental Plane of Air. Base benefits: speak Auran, cast Dominate Monster on air elementals (2 charges). After slaying an air elemental, the ring upgrades to grant lightning resistance and access to Chain Lightning (3 charges), Gust of Wind (2 charges), Wind Wall (1 charge). DMG p.190.'
    },
    ring_of_elemental_command_earth: {
      name: 'Ring of Elemental Command (Earth)',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      equipSlot: 'ring',
      rarity: 'legendary',
      requiresAttunement: true,
      charges: 5, maxCharges: 5, rechargeType: 'dawn', rechargeAmount: '1d4+1',
      spellSaveDC: 17,
      effects: [
        { type: 'advantage', target: 'save:earth_elemental', operation: 'advantage' }
      ],
      spells: [
        { name: 'Dominate Monster', chargeCost: 2, target: 'earth elemental only' },
        { name: 'Stone Shape', chargeCost: 2 },
        { name: 'Stoneskin', chargeCost: 3 },
        { name: 'Wall of Stone', chargeCost: 3 }
      ],
      description: 'Linked to the Elemental Plane of Earth. Base benefits: speak Terran, cast Dominate Monster on earth elementals (2 charges). After slaying an earth elemental, the ring upgrades to grant acid resistance and access to Stone Shape (2 charges), Stoneskin (3 charges), Wall of Stone (3 charges). DMG p.190.'
    },
    ring_of_elemental_command_fire: {
      name: 'Ring of Elemental Command (Fire)',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      equipSlot: 'ring',
      rarity: 'legendary',
      requiresAttunement: true,
      charges: 5, maxCharges: 5, rechargeType: 'dawn', rechargeAmount: '1d4+1',
      spellSaveDC: 17,
      effects: [
        { type: 'resistance', value: 'fire', operation: 'grant' },
        { type: 'advantage', target: 'save:fire_elemental', operation: 'advantage' }
      ],
      spells: [
        { name: 'Dominate Monster', chargeCost: 2, target: 'fire elemental only' },
        { name: 'Burning Hands', chargeCost: 1 },
        { name: 'Fireball', chargeCost: 2 },
        { name: 'Wall of Fire', chargeCost: 3 }
      ],
      description: 'Linked to the Elemental Plane of Fire. Base benefits: resistance to fire damage, speak Ignan, cast Dominate Monster on fire elementals (2 charges). After slaying a fire elemental, the ring upgrades to grant fire immunity and access to Burning Hands (1 charge), Fireball (2 charges), Wall of Fire (3 charges). DMG p.190.'
    },
    ring_of_elemental_command_water: {
      name: 'Ring of Elemental Command (Water)',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      equipSlot: 'ring',
      rarity: 'legendary',
      requiresAttunement: true,
      charges: 5, maxCharges: 5, rechargeType: 'dawn', rechargeAmount: '1d4+1',
      spellSaveDC: 17,
      effects: [
        { type: 'advantage', target: 'save:water_elemental', operation: 'advantage' }
      ],
      spells: [
        { name: 'Dominate Monster', chargeCost: 2, target: 'water elemental only' },
        { name: 'Create or Destroy Water', chargeCost: 1 },
        { name: 'Control Water', chargeCost: 3 },
        { name: 'Ice Storm', chargeCost: 2 },
        { name: 'Wall of Ice', chargeCost: 3 }
      ],
      description: 'Linked to the Elemental Plane of Water. Base benefits: can walk on and across liquid surfaces as if they were solid ground, speak Aquan, cast Dominate Monster on water elementals (2 charges). After slaying a water elemental, the ring upgrades to grant access to Create or Destroy Water (1 charge), Control Water (3 charges), Ice Storm (2 charges), Wall of Ice (3 charges). DMG p.190.'
    },
    ring_of_three_wishes: {
      name: 'Ring of Three Wishes',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      rarity: 'legendary',
      equipSlot: 'ring',
      charges: 3, maxCharges: 3, rechargeType: 'never',
      description: 'Legendary. While wearing this ring, you can use an action to expend 1 of its 3 charges to cast the Wish spell from it. The ring becomes nonmagical when you use the last charge. The ring does not require attunement. DMG p.193.'
    },
    rod_of_lordly_might: {
      name: 'Rod of Lordly Might',
      weight: 6, size: [1, 2], baseValue: 50000, icon: '🔱',
      rarity: 'legendary',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      magicalBonus: 3,
      description: 'Legendary. Requires attunement. Functions as a +3 magic mace (1d8 bludgeoning + 3). Six buttons grant additional forms (1: flame tongue with 1d6 fire + paralysis on STR-save; 2: battleaxe; 3: spear that can extend to 6 ft for reach; 4: climbing pole that telescopes to 50 ft; 5: battering ram that knocks prone; 6: compass / hardness detector). Once each per dawn: drain life (3d6 necrotic, target STR save vs DC 17 or paralyzed; you regain hp equal to damage dealt) and terrify (target frightened on WIS save fail). DMG p.198.'
    },
    staff_of_the_magi: {
      name: 'Staff of the Magi',
      weight: 4, size: [1, 5], baseValue: 50000, icon: '🪄',
      rarity: 'legendary',
      equipSlot: 'mainhand',
      requiresAttunement: true, magicalBonus: 2,
      charges: 50, maxCharges: 50, rechargeType: 'dawn',
      // [SUB-PLAN 1H-H-cond Phase 2 — GAP-8 — 2026-05-29]: Reshaped flat save entry to
      // six per-ability entries consumed by calculateSavingThrow (which queries
      // 'save:<ability>' keys). The old { type:'save', operation:'add', value:2,
      // condition:'vs_spells' } was double-INERT: (1) _getStatKey returned 'save'
      // (no target) → never matched by any save:<ability> query; (2) condition
      // 'vs_spells' had no colon → _matchesStringCondition returned true unconditionally.
      // New shape mirrors cloak_of_protection (type:'save:<ability>') + structured
      // condition leaf ({category:'rollSourceType',op:'hasAny',operands:['vs_spells']})
      // so the +2 ONLY fires when the save context has rollSourceType='vs_spells'.
      effects: [
        { type: 'spellAttackBonus', operation: 'add', value: 2 },
        { type: 'spellDC', operation: 'add', value: 2 },
        { type: 'save:strength', operation: 'add', value: 2, condition: { category: 'rollSourceType', op: 'hasAny', operands: ['vs_spells'] } },
        { type: 'save:dexterity', operation: 'add', value: 2, condition: { category: 'rollSourceType', op: 'hasAny', operands: ['vs_spells'] } },
        { type: 'save:constitution', operation: 'add', value: 2, condition: { category: 'rollSourceType', op: 'hasAny', operands: ['vs_spells'] } },
        { type: 'save:intelligence', operation: 'add', value: 2, condition: { category: 'rollSourceType', op: 'hasAny', operands: ['vs_spells'] } },
        { type: 'save:wisdom', operation: 'add', value: 2, condition: { category: 'rollSourceType', op: 'hasAny', operands: ['vs_spells'] } },
        { type: 'save:charisma', operation: 'add', value: 2, condition: { category: 'rollSourceType', op: 'hasAny', operands: ['vs_spells'] } },
      ],
      description: 'Legendary. Requires attunement by a sorcerer, warlock, or wizard. Magic quarterstaff that grants a +2 bonus to attack and damage rolls. While holding it, you have +2 to spell attack rolls and spell save DC, and advantage on saving throws against spells. Spell Absorption (reaction): when another creature targets you with a spell, expend 1 reaction to cancel the spell and gain charges equal to the spell\'s level (if this would exceed 50, the staff explodes). 50 charges; regains 4d6+2 charges at dawn. Action: expend charges to cast Conjure Elemental (7), Dispel Magic (3), Fireball (7th-level, 7), Flaming Sphere (2), Ice Storm (4), Invisibility (2), Knock (2), Lightning Bolt (7th-level, 7), Passwall (5), Plane Shift (7), Telekinesis (5), Wall of Fire (4), or Web (2). Retributive Strike: action to break staff over knee, releasing all remaining magic in a 30-ft sphere with 16 × charges damage at center, falling off with distance (50% chance to teleport to safety). DMG p.203.'
    },
    vorpal_sword: {
      name: 'Vorpal Sword',
      weight: 3, size: [1, 4], baseValue: 50000, icon: '⚔️',
      rarity: 'legendary',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      magicalBonus: 3,
      requiresAttunement: true,
      description: 'Legendary. Requires attunement. +3 magic sword (must be a sword that deals slashing damage). Ignores resistance to slashing damage. When you attack a creature that has at least one head with this weapon and roll a 20 on the attack roll, you cut off one of the creature\'s heads. The creature dies if it can\'t survive without the lost head. DMG p.209.'
    },
    cloak_of_invisibility: {
      name: 'Cloak of Invisibility',
      weight: 1, size: [2, 3], baseValue: 50000, icon: '🧥',
      rarity: 'legendary',
      equipSlot: 'cloak', requiresAttunement: true,
      charges: 2, maxCharges: 2, rechargeType: 'dawn',
      description: 'Legendary. Requires attunement. While wearing the cloak, you can pull its hood over your head (action) to become invisible; anything you carry or wear is invisible with you. You become visible when you cease wearing the cloak or lower its hood (bonus action). Total invisibility time per cycle: up to 2 hours, split into intervals of at least 1 minute. After 2 hours, the cloak ceases to function; for every uninterrupted 12 hours unused, it regains 1 hour of use. DMG p.158.'
    },
    crystal_ball_of_mind_reading: {
      name: 'Crystal Ball of Mind Reading',
      weight: 3, size: [1, 1], baseValue: 50000, icon: '🔮',
      rarity: 'legendary',
      requiresAttunement: true,
      description: 'Crystal ball variant. Action: cast Detect Thoughts (DC 17) targeting a scrying-target. DMG p.160.'
    },
    horn_of_valhalla_silver: {
      name: 'Horn of Valhalla (Silver)',
      weight: 2, size: [1, 1], baseValue: 5000, icon: '🪕',
      rarity: 'rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'weekly',
      description: 'Rare. No attunement required. Blow the horn as an action to summon 2d4+2 berserker warrior spirits from Ysgard in unoccupied spaces within 60 ft. The Silver Horn has no prerequisite. The summoned berserkers are friendly to you and your companions, act on their own initiative, and disappear after 1 hour or when reduced to 0 hp. Once blown, the horn cannot be used again until 7 days have passed. DMG p.175.'
    },
    horn_of_valhalla_brass: {
      name: 'Horn of Valhalla (Brass)',
      weight: 2, size: [1, 1], baseValue: 5000, icon: '🪕',
      rarity: 'rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'weekly',
      description: 'Rare. No attunement required. Blow the horn as an action to summon 3d4+3 berserker warrior spirits from Ysgard in unoccupied spaces within 60 ft. The Brass Horn requires proficiency with all simple weapons to blow safely. If you lack the required proficiency, the summoned berserkers attack you instead. The summoned berserkers are friendly to you and your companions, act on their own initiative, and disappear after 1 hour or when reduced to 0 hp. Once blown, the horn cannot be used again until 7 days have passed. DMG p.175.'
    },
    horn_of_valhalla_bronze: {
      name: 'Horn of Valhalla (Bronze)',
      weight: 2, size: [1, 1], baseValue: 13000, icon: '🪕',
      rarity: 'very rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'weekly',
      description: 'Very rare. No attunement required. Blow the horn as an action to summon 4d4+4 berserker warrior spirits from Ysgard in unoccupied spaces within 60 ft. The Bronze Horn requires proficiency with all medium armor to blow safely. If you lack the required proficiency, the summoned berserkers attack you instead. The summoned berserkers are friendly to you and your companions, act on their own initiative, and disappear after 1 hour or when reduced to 0 hp. Once blown, the horn cannot be used again until 7 days have passed. DMG p.175.'
    },
    horn_of_valhalla_iron: {
      name: 'Horn of Valhalla (Iron)',
      weight: 2, size: [1, 1], baseValue: 50000, icon: '🪕',
      rarity: 'very rare',
      requiresAttunement: false,
      charges: 1, maxCharges: 1, rechargeType: 'weekly',
      description: 'Very rare. No attunement required. Silver-mounted, etched ivory and iron, this horn summons the spirits of fallen warriors from Valhalla. The horn has four versions (silver/brass/bronze/iron), each with a prerequisite: blowing without meeting the prerequisite causes the summoned berserkers to attack you instead. Iron variant requires proficiency with all martial weapons. Action: blow the horn to summon 2d4+2 berserker spirits (use the Berserker stat block, MM p.344) in unoccupied spaces within 60 ft; they are friendly to you and your companions, act on their own initiative, fight until defeated or dismissed, and fade away after 1 hour. Once blown, the horn cannot be used again for 7 days. DMG p.175.'
    },
    instrument_of_the_bards_ollamh_harp: {
      name: 'Instrument of the Bards (Ollamh Harp)',
      weight: 2, size: [2, 3], baseValue: 50000, icon: '🎼',
      rarity: 'very rare',
      requiresAttunement: true,
      description: 'Bardic instrument; +3 attack/save DC for spells cast through it. Cast Confusion, Control Weather, Fire Storm, Fly, Invisibility, Levitate, Protection from Evil, etc. DMG p.176.'
    },
    // [SUB-PLAN 1R / 2026-05-29]: equipSlot: 'ioun' added to all 14 Ioun Stone rows
    //   below so the InventoryContext.getEquipSlots dispatch routes via the canonical
    //   equipSlot field (no mainhand fallback). Per DMG p.176, Ioun stones float
    //   around the head — never wielded as a weapon. The "Equip to Main Hand" UI
    //   label bug was the visible symptom. See
    //   .claude/findings/2026-05-29-bug-A-iounStone-equipSlot-label.md
    ioun_stone_absorption: {
      name: 'Ioun Stone of Absorption',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      description: 'A pale lavender ellipsoid. While orbiting your head, you can use your reaction to cancel a spell of 4th level or lower cast by a creature you can see and targeting only you. Once the stone has canceled 20 levels of spells, it burns out and turns dull gray, losing its magic. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_agility: {
      name: 'Ioun Stone of Agility',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ability', target: 'dexterity', operation: 'add', value: 2, max: 20 }],
      description: 'A deep red sphere. While orbiting your head, your Dexterity score increases by 2, to a maximum of 20. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_awareness: {
      name: 'Ioun Stone of Awareness',
      weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
      rarity: 'rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'feature', target: 'cannotBeSurprised', operation: 'set', value: true }],
      description: 'A pale blue rhomboid. While orbiting your head, you can\'t be surprised. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_fortitude: {
      name: 'Ioun Stone of Fortitude',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ability', target: 'constitution', operation: 'add', value: 2, max: 20 }],
      description: 'A pink rhomboid. While orbiting your head, your Constitution score increases by 2, to a maximum of 20. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_greater_absorption: {
      name: 'Ioun Stone of Greater Absorption',
      weight: 0, size: [1, 1], baseValue: 50000, icon: '🪨',
      rarity: 'legendary',
      requiresAttunement: true,
      equipSlot: 'ioun',
      description: 'A marbled lavender and green ellipsoid. While orbiting your head, you can use your reaction to cancel a spell of 8th level or lower cast by a creature you can see and targeting only you. Once the stone has canceled 50 levels of spells, it burns out and turns dull gray, losing its magic. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_insight: {
      name: 'Ioun Stone of Insight',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ability', target: 'wisdom', operation: 'add', value: 2, max: 20 }],
      description: 'An incandescent blue sphere. While orbiting your head, your Wisdom score increases by 2, to a maximum of 20. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_intellect: {
      name: 'Ioun Stone of Intellect',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ability', target: 'intelligence', operation: 'add', value: 2, max: 20 }],
      description: 'A marbled scarlet and blue sphere. While orbiting your head, your Intelligence score increases by 2, to a maximum of 20. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_leadership: {
      name: 'Ioun Stone of Leadership',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ability', target: 'charisma', operation: 'add', value: 2, max: 20 }],
      description: 'A marbled pink and green sphere. While orbiting your head, your Charisma score increases by 2, to a maximum of 20. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_mastery: {
      name: 'Ioun Stone of Mastery',
      weight: 0, size: [1, 1], baseValue: 50000, icon: '🪨',
      rarity: 'legendary',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'feature', target: 'proficiencyBonus', operation: 'add', value: 1 }],
      description: 'A pale green prism. While orbiting your head, your proficiency bonus increases by 1. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_protection: {
      name: 'Ioun Stone of Protection',
      weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
      rarity: 'rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ac', operation: 'add', value: 1 }],
      description: 'A dusty rose prism. While orbiting your head, you gain a +1 bonus to AC. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_regeneration: {
      name: 'Ioun Stone of Regeneration',
      weight: 0, size: [1, 1], baseValue: 50000, icon: '🪨',
      rarity: 'legendary',
      requiresAttunement: true,
      equipSlot: 'ioun',
      description: 'A pearly white spindle. While orbiting your head, you regain 15 hit points at the end of each hour, provided that you have at least 1 hit point. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_reserve: {
      name: 'Ioun Stone of Reserve',
      weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
      rarity: 'rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      description: 'A vibrant purple prism. This stone can store spells cast into it, holding up to 3 levels worth. While orbiting your head, any creature can cast a spell of 1st through 3rd level into the stone by touching it as the spell is cast. You can use your action to cast a stored spell from the stone. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_strength: {
      name: 'Ioun Stone of Strength',
      weight: 0, size: [1, 1], baseValue: 13000, icon: '🪨',
      rarity: 'very rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'ability', target: 'strength', operation: 'add', value: 2, max: 20 }],
      description: 'A pale blue rhomboid. While orbiting your head, your Strength score increases by 2, to a maximum of 20. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    ioun_stone_sustenance: {
      name: 'Ioun Stone of Sustenance',
      weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
      rarity: 'rare',
      requiresAttunement: true,
      equipSlot: 'ioun',
      effects: [{ type: 'feature', target: 'needsNoFoodOrDrink', operation: 'set', value: true }],
      description: 'A clear spindle. While orbiting your head, you don\'t need to eat or drink. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). DMG p.176.'
    },
    iron_flask: {
      name: 'Iron Flask',
      weight: 1, size: [1, 1], baseValue: 50000, icon: '🍶',
      rarity: 'legendary',
      requiresAttunement: false,
      description: 'Legendary. No attunement required. This iron bottle has a brass stopper. Action while holding it to speak the command word, targeting one creature you can see within 60 ft. If the target is native to a plane of existence other than the one you\'re on, it must succeed on a DC 17 Wisdom save or be trapped inside the flask. If the target has been trapped by the flask before, it has advantage on the save. Once trapped, a creature remains in the flask until released; only one creature can be inside the flask at a time. A flask with a creature inside weighs 1 lb. The flask can only trap a target that is on a different plane to you, unless the target is already trapped — meaning common use is on outsiders/elementals/fey, not local denizens. Action to remove the stopper: the trapped creature emerges 5 ft away from you; once per 24-hour period after the creature emerges, you can use an action to issue a command and the creature must obey it. Trapped creatures retain their alignment, statistics, and abilities. DMG p.178.'
    },
    ring_of_spell_turning: {
      name: 'Ring of Spell Turning',
      weight: 0.1, size: [1, 1], baseValue: 50000, icon: '💍',
      rarity: 'legendary',
      equipSlot: 'ring', requiresAttunement: true,
      effects: [
        { type: 'advantage', operation: 'advantage', target: 'save_vs_single_target_spell' }
      ],
      description: 'Legendary. Requires attunement. While wearing this ring, you have advantage on saving throws against any spell that targets only you (not in an area of effect). Additionally, if you roll a 20 for the save and the spell is 7th level or lower, the spell has no effect on you and is reflected back at the caster, using the slot level, spell save DC, attack bonus, and spellcasting ability of the caster. DMG p.193.'
    },
    rod_of_resurrection: {
      name: 'Rod of Resurrection',
      weight: 4, size: [1, 2], baseValue: 50000, icon: '🔱',
      rarity: 'legendary',
      equipSlot: 'mainhand',
      requiresAttunement: true,
      charges: 5, maxCharges: 5, rechargeType: 'dawn',
      description: 'Legendary. Requires attunement by a cleric, druid, or paladin. Has 5 charges. Action while holding it: expend 1 charge to cast Heal, or 5 charges to cast Resurrection. The rod regains 1 expended charge daily at dawn. If reduced to 0 charges, roll a d20; on a 1 the rod disappears in a flash of light, lost forever. DMG p.198.'
    },
    crystal_ball_of_true_seeing: {
      name: 'Crystal Ball of True Seeing',
      weight: 3, size: [1, 1], baseValue: 50000, icon: '🔮',
      rarity: 'legendary',
      requiresAttunement: true,
      description: 'Crystal ball variant. While scrying, you have Truesight 120 ft centered on the sensor. DMG p.160.'
    },
    cubic_gate: {
      name: 'Cubic Gate',
      weight: 0.5, size: [1, 1], baseValue: 50000, icon: '🟦',
      rarity: 'legendary',
      requiresAttunement: false,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      rechargeAmount: '1d3',
      description: 'Legendary. No attunement required. This 3-inch-sided cube has 3 charges; each of its six faces is keyed to a different plane of existence (the user, when creating the cube, attunes each face to a particular plane). Action: press one face of the cube and expend 1 charge to cast the Plane Shift spell, transporting yourself and up to 8 willing creatures within 30 ft to the plane keyed to that face. Alternatively, press one face twice as an action and expend 2 charges to cast the Gate spell, opening a portal to the plane keyed to that face. The cube regains 1d3 expended charges daily at dawn. DMG p.161.'
    },
    deck_of_many_things: {
      name: 'Deck of Many Things',
      weight: 0.5, size: [1, 1], baseValue: 50000, icon: '🃏',
      rarity: 'legendary',
      requiresAttunement: false,
      description: 'Legendary. No attunement required. A deck of cards usually found stored in a box or pouch. Most decks have only 13 cards, but some include 22; the rarer 22-card decks contain all the 13-card draws plus the Balance, Comet, Donjon, Euryale, Fool, Idiot, Throne, and Vizier. Before drawing, you must declare how many cards you will draw (max 13). Then draw the declared number randomly; each card affects the drawer with a permanent fortune or curse — Balance, Comet, Donjon, Euryale, Fates, Flames, Fool, Gem, Idiot, Jester, Key, Knight, Moon, Rogue, Ruin, Skull, Star, Sun, Talons, Throne, Vizier, The Void. If a draw exceeds the chosen number, the deck stops; effects resolve in draw order. Once a card is drawn it vanishes from the deck (except Fool and Jester, which return); when the last card is drawn the deck reshuffles. DMG p.162.'
    },
    efreeti_chain: {
      name: 'Efreeti Chain',
      weight: 60, size: [3, 3], baseValue: 50000, icon: '🔥',
      rarity: 'legendary',
      armorType: 'heavy', ac: 16, maxDexMod: 0, minStr: 13, stealthDisadvantage: true,
      requiresAttunement: true,
      // [Sub-plan 1I(g) 2026-05-26]: was `{type:'immunity', target:'fire', operation:'grant'}` —
      //   `type:'immunity'` is not in the schema's effect-type union; canonical convention is
      //   `type:'resistance' + operation:'immunity' + value:<damageType>` (see srdSubclassFeatures.js
      //   L1036 Cleric Forge Saint of Forge and Fire). Pre-fix this legendary item's fire immunity
      //   silently failed at runtime — no reader consumes `type:'immunity'`. Fixed shape now flows
      //   through effectCalculator.getDamageImmunities.
      effects: [{ type: 'resistance', operation: 'immunity', value: 'fire' }],
      description: 'Legendary. Requires attunement. Chain mail interlaced with black iron. While wearing it, you understand and can speak Primordial, and you take no damage from fire (immunity). DMG p.167.'
    },
    armor_of_invulnerability: {
      name: 'Armor of Invulnerability',
      weight: 65, size: [3, 3], baseValue: 50000, icon: '🛡️',
      rarity: 'legendary',
      armorType: 'heavy', ac: 18, minStr: 15, stealthDisadvantage: true,
      requiresAttunement: true,
      effects: [
        { type: 'resistance', value: 'nonmagical', operation: 'grant' }
      ],
      description: 'Legendary. Requires attunement. Plate armor. While wearing it, you have resistance to nonmagical damage. Once per day, action to become invulnerable to all damage for 10 minutes (or until you doff the armor). DMG p.152.'
    },
    sphere_of_annihilation: {
      name: 'Sphere of Annihilation',
      weight: 0, size: [2, 2], baseValue: 50000, icon: '⚫',
      rarity: 'legendary',
      requiresAttunement: false,
      description: 'Legendary. No attunement required. This 2-foot-diameter black sphere is a hole in the multiverse, hovering in space and stabilized by a magical field surrounding it. The sphere obliterates all matter it passes through and all matter that passes through it, with the following exceptions: a wish spell can prevent the sphere from obliterating an object or creature; an artifact is unaffected. Anything passing through the sphere takes 4d10 force damage (no save). The sphere is stationary unless someone controls it. You can use an action to make a DC 25 Intelligence (Arcana) check while within 60 feet of the sphere; on a success, you mentally control the sphere on your turn (5 ft/turn) until the end of your next turn. If two creatures contest control, the higher result wins; if the sphere contacts a Heward\'s Handy Haversack, Bag of Holding, or Portable Hole, the items are destroyed and a gate to the Astral Plane opens. DMG p.201.'
    },

    // --- XGtE common magic items ---
    bead_of_nourishment: {
      name: 'Bead of Nourishment',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '🟤', stackable: true, maxStack: 99,
      rarity: 'common',
      requiresAttunement: false,
      description: 'Common. No attunement required. This flavorless, gelatinous bead dissolves on your tongue and provides as much nourishment as 1 day of rations. XGtE p.136.'
    },
    bead_of_refreshment: {
      name: 'Bead of Refreshment',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '🔵', stackable: true, maxStack: 99,
      rarity: 'common',
      requiresAttunement: false,
      description: 'Common. No attunement required. As an action, you can place this bead in a container that holds up to 1 gallon of liquid; the bead dissolves and flavors the liquid as if it were a fruity beverage. The liquid sustains you as much as water does. XGtE p.136.'
    },
    boots_of_false_tracks: {
      name: 'Boots of False Tracks',
      weight: 1, size: [2, 2], baseValue: 100, icon: '👢',
      rarity: 'common',
      equipSlot: 'boots',
      requiresAttunement: false,
      description: 'Common. No attunement required. While wearing these boots, you can use a bonus action to choose a creature type other than your own that has feet. While you continue to wear the boots, they leave tracks identical to those of the chosen creature. XGtE p.136.'
    },
    candle_of_the_deep: {
      name: 'Candle of the Deep',
      weight: 0, size: [1, 1], baseValue: 100, icon: '🕯️', stackable: true, maxStack: 99,
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. The flame of this candle is not extinguished when immersed in water. It gives off light and heat like a normal candle. XGtE p.136."
    },
    cast_off_armor: {
      name: 'Cast-Off Armor',
      weight: 20, size: [2, 2], baseValue: 100, icon: '🛡️',
      rarity: 'common',
      armorType: 'medium', ac: 14, maxDexMod: 2,
      description: 'Common. No attunement required. As an action, you can speak the armor\'s command word to cause the armor to immediately doff itself, falling off your body. XGtE p.136.'
    },
    cloak_of_many_fashions: {
      name: 'Cloak of Many Fashions',
      weight: 1, size: [2, 3], baseValue: 100, icon: '🧥',
      rarity: 'common',
      equipSlot: 'cloak',
      requiresAttunement: false,
      description: 'Common. No attunement required. Bonus action: change the cloak\'s color, style, and apparent fabric. The cloak\'s weight does not change. XGtE p.137.'
    },
    clockwork_amulet: {
      name: 'Clockwork Amulet',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '⚙️',
      rarity: 'common',
      equipSlot: 'neck',
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      description: 'Common. No attunement required. This copper amulet has a tiny clockwork core. While wearing the amulet, you can forgo rolling the d20 for an attack roll you make to gain a 10 on the die. Once used, this property can\'t be used again until the next dawn. XGtE p.137.'
    },
    clothes_of_mending: {
      name: 'Clothes of Mending',
      weight: 3, size: [2, 2], baseValue: 100, icon: '👕',
      rarity: 'common',
      requiresAttunement: false,
      description: 'Common. No attunement required. This elegant outfit of traveler\'s clothes magically mends itself to counteract daily wear and tear. Pulling a thread sown into the hem causes the garment to reshape itself to fit a Small or Medium creature; reaching into the hem reverses the change. XGtE p.137.'
    },
    dark_shard_amulet: {
      name: 'Dark Shard Amulet',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '🖤',
      rarity: 'common',
      equipSlot: 'neck',
      requiresAttunement: true,
      description: 'Common. Requires attunement by a warlock. While wearing this amulet, you can use it as a spellcasting focus for your warlock spells. In addition, you can try to cast a cantrip that you don\'t know. The cantrip must be on the warlock spell list, and you must make a DC 10 Intelligence (Arcana) check. If the check succeeds, you cast the spell. If the check fails, so does the spell, and the action used to cast the spell is wasted. In either case, you can\'t use this property again until you finish a long rest. XGtE p.137.'
    },
    ear_horn_of_hearing: {
      name: 'Ear Horn of Hearing',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🦻',
      rarity: 'common',
      requiresAttunement: false,
      description: 'Common. No attunement required. While held up to your ear, this trumpet-shaped horn suppresses the effects of the deafened condition on you, allowing you to hear normally. XGtE p.137.'
    },
    enduring_spellbook: {
      name: 'Enduring Spellbook',
      weight: 3, size: [1, 2], baseValue: 100, icon: '📖',
      rarity: 'common',
      requiresAttunement: false,
      description: 'Common. No attunement required. This spellbook, along with anything written on its pages, can\'t be damaged by fire or immersion in water. In addition, the spellbook doesn\'t deteriorate with age. XGtE p.137.'
    },
    ersatz_eye: {
      name: 'Ersatz Eye',
      weight: 0, size: [1, 1], baseValue: 100, icon: '👁️',
      rarity: 'common',
      requiresAttunement: true,
      description: 'Common. Requires attunement. This artificial eye replaces a real one that was lost or removed. While the ersatz eye is embedded in your eye socket, it can\'t be removed by anyone other than you, and you can see through the tiny orb as though it were a normal eye. XGtE p.137.'
    },
    hat_of_vermin: {
      name: 'Hat of Vermin',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🎩',
      rarity: 'common',
      equipSlot: 'head',
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Common. No attunement required. This hat has 3 charges. While holding the hat, you can use an action to expend 1 of its charges and speak a word of activation; 1d4 rats (or, at the GM\'s option, bats, centipedes, crabs, frogs, ravens, scorpions, or spiders) appear in an unoccupied space within 30 feet of you. The vermin act on their own initiative, are friendly to you and your companions, and obey your spoken commands. They remain for 1 hour, until they or you die, or until you dismiss them as an action. The hat regains all expended charges daily at dawn. XGtE p.137.'
    },
    hat_of_wizardry: {
      name: 'Hat of Wizardry',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🧙',
      rarity: 'common',
      equipSlot: 'head',
      requiresAttunement: true,
      description: 'Common. Requires attunement by a wizard. This antiquated, cone-shaped hat is adorned with gold crescent moons and stars. While you are wearing it, you gain the following benefits: you can use the hat as a spellcasting focus for your wizard spells; you can try to cast a cantrip that you don\'t know — the cantrip must be on the wizard spell list, and you must make a DC 10 Intelligence (Arcana) check, after which you can\'t use this property again until you finish a long rest. XGtE p.137.'
    },
    hewards_handy_spice_pouch: {
      name: "Heward's Handy Spice Pouch",
      weight: 1, size: [1, 1], baseValue: 100, icon: '🌶️',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. This belt pouch appears empty and has 10 charges. While holding the pouch, you can use an action to expend 1 of its charges, speak the name of one nonmagical food seasoning (such as salt, pepper, saffron, or cilantro), and remove a packet containing 1 ounce of the desired seasoning from the pouch. A packet loses its magic if removed from the pouch. The pouch regains 1d6 + 4 expended charges daily at dawn. XGtE p.137."
    },
    horn_of_silent_alarm: {
      name: 'Horn of Silent Alarm',
      weight: 0.5, size: [1, 1], baseValue: 100, icon: '📯',
      rarity: 'common',
      requiresAttunement: false,
      charges: 4, maxCharges: 4, rechargeType: 'dawn',
      description: 'Common. No attunement required. This Tiny horn has 4 charges. When you use an action to blow it, one creature of your choice can hear the horn\'s blare, provided the creature is within 600 feet of the horn and not deafened. No other creature hears sound coming from the horn. The horn regains 1d4 expended charges daily at dawn. XGtE p.137.'
    },
    instrument_of_illusions: {
      name: 'Instrument of Illusions',
      weight: 2, size: [1, 3], baseValue: 100, icon: '🎺',
      rarity: 'common',
      requiresAttunement: true,
      description: 'Common. Requires attunement. While you are playing this musical instrument, you can create harmless, illusory visual effects within a 5-foot radius of yourself. The effects end when you stop playing. When you play, you choose the type of effect; the illusions are too minor to have significant effects on creatures. XGtE p.137.'
    },
    instrument_of_scribing: {
      name: 'Instrument of Scribing',
      weight: 2, size: [1, 3], baseValue: 100, icon: '✍️',
      rarity: 'common',
      requiresAttunement: false,
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: "Common. No attunement required. This musical instrument has 3 charges. As long as you have proficiency with the instrument, you can play it while taking the Use an Object action to expend 1 charge from it and write a magical message on a non-creature object or surface of your choice within 30 feet. The message can be up to six words long and is written in a language you know. If you are a bard, you can scribe in musical notes. The message is visible only to you and others you designate; it lasts 24 hours or until erased with a Mage Hand or wiping action. The instrument regains 1d3 expended charges daily at dawn. XGtE p.138."
    },
    lock_of_trickery: {
      name: 'Lock of Trickery',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🔒',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. This lock appears to be an ordinary lock (of the type described in chapter 5 of the Player's Handbook) and comes with a single key. The tumblers in this lock magically adjust to thwart burglars. Using thieves' tools to pick the lock requires a successful DC 15 Dexterity check made with proficiency in such tools. XGtE p.138."
    },
    moon_touched_sword: {
      name: 'Moon-Touched Sword',
      weight: 3, size: [1, 4], baseValue: 100, icon: '🌙',
      rarity: 'common',
      damage: '1d8', damageType: 'slashing',
      properties: ['Versatile (1d10)'],
      description: 'Common. Magic sword (counts as magical for resistance bypass). In darkness, the unsheathed blade sheds bright light in a 15-ft radius and dim light for an additional 15 ft. XGtE p.138.'
    },
    mystery_key: {
      name: 'Mystery Key',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '🗝️',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. A question mark is worked into the head of this key. If you find a lock you have never tried to open with this key, the GM determines whether the key opens it. If it does, the key becomes ordinary and loses its magic. XGtE p.138."
    },
    orb_of_direction: {
      name: 'Orb of Direction',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🧭',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. While holding this orb, you can use an action to determine which way is north. This property functions only on the Material Plane. XGtE p.138."
    },
    orb_of_time: {
      name: 'Orb of Time',
      weight: 1, size: [1, 1], baseValue: 100, icon: '⏰',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. While holding this orb, you can use an action to determine whether it is morning, noon, afternoon, evening, midnight, or some other time. This property functions only on the Material Plane. XGtE p.138."
    },
    perfume_of_bewitching: {
      name: 'Perfume of Bewitching',
      weight: 0.1, size: [1, 1], baseValue: 100, icon: '🌸', stackable: true, maxStack: 5,
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. This tiny vial contains magic perfume, enough for one use. You can use an action to apply the perfume to yourself, and its effect lasts 1 hour. For the duration, you have advantage on all Charisma checks directed at humanoids of challenge rating 1 or lower. Those subjected to the perfume's effect are not aware that they have been influenced by magic. XGtE p.138."
    },
    pipe_of_smoke_monsters: {
      name: 'Pipe of Smoke Monsters',
      weight: 1, size: [1, 1], baseValue: 100, icon: '🪈',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. While smoking this pipe, you can use an action to exhale a puff of smoke that takes the form of a single creature, such as a dragon, a flumph, or a froghemoth. The form must be small enough to fit in a 1-foot cube and loses its shape after a few seconds, becoming an ordinary puff of smoke. XGtE p.138."
    },
    pole_of_angling: {
      name: 'Pole of Angling',
      weight: 8, size: [1, 4], baseValue: 100, icon: '🎣',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. While holding this 10-foot pole, you can speak a command word and cause a hook, a line, and a reel to appear at one end. The hook, line, and reel disappear when you speak a different command word. The reel contains 100 feet of fishing line and grants the pole a +3 bonus to opposed checks made to reel in a creature or an object caught on the line. XGtE p.138."
    },
    rope_of_mending: {
      name: 'Rope of Mending',
      weight: 3, size: [2, 2], baseValue: 100, icon: '🪢',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. You can cut this 50-foot coil of hempen rope into any number of smaller pieces, and then use an action to speak a command word and cause the pieces to knit back together. The pieces must be in contact with each other and not currently in use. A rope of mending is forever lost if not all of its pieces are rejoined. XGtE p.138."
    },

    // --- TCoE common/uncommon magic items ---
    illuminators_tattoo: {
      name: "Illuminator's Tattoo",
      weight: 0, size: [1, 1], baseValue: 100, icon: '🎨',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. Produced by a special needle, this magic tattoo features designs that emphasize one of your features (your eyes, your hand, etc.). The needle is consumed when the tattoo is applied. Tattoo Attunement. Pressing the needle to your skin allows you to attune to the tattoo. As long as the tattoo remains on your skin, you can use a bonus action to make text appear on a non-creature surface within 30 feet of you that you can see; the text is a language you know, can be up to one minute of script, and the writing fades after 24 hours. TCoE p.122."
    },
    masquerade_tattoo: {
      name: 'Masquerade Tattoo',
      weight: 0, size: [1, 1], baseValue: 100, icon: '🎭',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. Produced by a special needle, this magic tattoo features ornate designs. The needle is consumed when the tattoo is applied. Tattoo Attunement. As long as the tattoo remains on your skin, you can use a bonus action to alter the tattoo's appearance, allowing the marking to take any other visible form. As an action, you can also alter the tattoo's appearance to either match a tattoo or other marking on a creature you've seen within the past hour. TCoE p.122."
    },
    spellwrought_tattoo_cantrip: {
      name: 'Spellwrought Tattoo (Cantrip)',
      weight: 0, size: [1, 1], baseValue: 100, icon: '✏️',
      rarity: 'common',
      requiresAttunement: false,
      description: "Common. No attunement required. Produced by a special needle, this magic tattoo features designs that emphasize one spell. The needle is consumed when the tattoo is applied. As an action, you can touch the tattoo and cast the spell stored within it, requiring no spellcasting focus and no components other than verbal. The tattoo fades from your skin when its spell is cast or after 1 year, whichever comes first. The cantrip can be from any class's spell list. TCoE p.123."
    },
    spellwrought_tattoo_3rd_level: {
      name: 'Spellwrought Tattoo (3rd Level)',
      weight: 0, size: [1, 1], baseValue: 500, icon: '✏️',
      rarity: 'uncommon',
      requiresAttunement: false,
      description: "Uncommon. No attunement required. Produced by a special needle, this magic tattoo features designs that emphasize one 3rd-level spell. The needle is consumed when the tattoo is applied. As an action, you can touch the tattoo and cast the spell stored within it, using your spellcasting ability and requiring no spellcasting focus and no components other than verbal. The tattoo fades from your skin when its spell is cast or after 1 year, whichever comes first. The spell is cast at 3rd level. TCoE p.123."
    },
    all_purpose_tool_plus_1: {
      name: 'All-Purpose Tool +1',
      weight: 2, size: [1, 1], baseValue: 750, icon: '🔧',
      rarity: 'uncommon',
      magicalBonus: 1,
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1 }, { type: 'spellDC', operation: 'add', value: 1 }],
      spells: [{ name: 'Prestidigitation', level: 0 }],
      description: 'Uncommon. Requires attunement by a spellcaster. While holding this tool, you gain a +1 bonus to spell attack rolls and to the saving throw DCs of your spells. You can use it as a spellcasting focus, and as a Magic action you can magically transform it into any kind of artisan\'s tool of your choice. While holding the tool, you can cast Prestidigitation. TCoE p.123.'
    },
    amulet_of_the_devout_plus_1: {
      name: 'Amulet of the Devout +1',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '✝️',
      rarity: 'uncommon',
      magicalBonus: 1,
      equipSlot: 'neck', requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:cleric,paladin' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:cleric,paladin' }],
      description: 'Rare. Requires attunement by a cleric or paladin. While holding this holy symbol, you gain a +1 bonus to spell attack rolls and the saving throw DCs of your spells. The amulet has 1 charge. While holding it, you can take a Magic action to expend the charge and use your Channel Divinity, without expending one of that feature\'s uses. The amulet regains all expended charges at dawn. TCoE p.123.'
    },
    arcane_grimoire_plus_1: {
      name: 'Arcane Grimoire +1',
      weight: 3, size: [1, 2], baseValue: 750, icon: '📕',
      rarity: 'uncommon',
      magicalBonus: 1,
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:wizard' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:wizard' }],
      description: 'Uncommon. Requires attunement by a wizard. While holding the grimoire, you gain a +1 bonus to spell attack rolls and to the saving throw DCs of your wizard spells. You can use the grimoire as a spellcasting focus for your wizard spells. When you prepare your wizard spells, you can prepare one additional wizard spell of 1st or 2nd level. TCoE p.124.'
    },
    bloodwell_vial_plus_1: {
      name: 'Bloodwell Vial +1',
      weight: 0.5, size: [1, 1], baseValue: 750, icon: '🧪',
      rarity: 'uncommon',
      magicalBonus: 1,
      requiresAttunement: true,
      charges: 1, maxCharges: 1, rechargeType: 'dawn',
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:sorcerer' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:sorcerer' }],
      description: 'Uncommon. Requires attunement by a sorcerer. While holding the vial, you gain a +1 bonus to spell attack rolls and to the saving throw DCs of your spells. You can use the vial as a spellcasting focus for your sorcerer spells. The vial has 1 charge. When you roll initiative, you can use a reaction to expend the charge and regain 1 expended Sorcery Point. The vial regains all expended charges daily at dawn. TCoE p.124.'
    },
    devotees_censer_plus_1: {
      name: "Devotee's Censer +1",
      weight: 1, size: [1, 1], baseValue: 750, icon: '🕯️',
      rarity: 'uncommon',
      magicalBonus: 1,
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:cleric' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:cleric' }],
      description: 'Uncommon. Requires attunement by a cleric. While holding the censer, you gain a +1 bonus to spell attack rolls and to the saving throw DCs of your cleric spells. You can use the censer as a spellcasting focus for your cleric spells. When you cast a spell that restores hit points while holding the censer, each creature healed by the spell regains additional hit points equal to 1d4 + 1. TCoE p.124.'
    },
    helm_of_awareness: {
      name: 'Helm of Awareness',
      weight: 3, size: [1, 1], baseValue: 750, icon: '⛑️',
      rarity: 'rare',
      equipSlot: 'head', requiresAttunement: true,
      effects: [{ type: 'advantage', target: 'initiative', operation: 'advantage' }],
      description: 'Rare. Requires attunement. While wearing this helm, you have advantage on initiative rolls. While the helm is on your person, you and any of your allies within 30 feet of you can\'t be surprised, except when incapacitated by something other than non-magical sleep. TCoE p.125.'
    },
    rhythm_makers_drum_plus_1: {
      name: "Rhythm-Maker's Drum +1",
      weight: 3, size: [1, 2], baseValue: 750, icon: '🥁',
      rarity: 'uncommon',
      magicalBonus: 1,
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:bard' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:bard' }],
      description: "Uncommon. Requires attunement by a bard. While holding the drum, you gain a +1 bonus to spell attack rolls and to the saving throw DCs of your bard spells. You can use the drum as a spellcasting focus for your bard spells. When a creature uses a Bardic Inspiration die granted by you and the roll is an even number, the creature can roll a d6 and add the number rolled to the Bardic Inspiration die's roll, immediately after the die is rolled. TCoE p.125."
    },
    moon_sickle_plus_1: {
      name: 'Moon Sickle +1',
      weight: 2, size: [1, 2], baseValue: 750, icon: '🌙',
      rarity: 'rare',
      damage: '1d4', damageType: 'slashing',
      properties: ['Light'],
      magicalBonus: 1,
      requiresAttunement: true,
      effects: [{ type: 'spellAttackBonus', operation: 'add', value: 1, condition: 'class:druid,ranger' }, { type: 'spellDC', operation: 'add', value: 1, condition: 'class:druid,ranger' }],
      description: 'Rare. Requires attunement by a druid or ranger. +1 magic sickle that also functions as a druidic focus. +1 to spell attack rolls and spell save DC. Healing Light: when you cast a spell that restores hit points while holding the sickle, roll 1d4 — the target regains additional HP equal to the result. TCoE p.125.'
    },
    natures_mantle: {
      name: "Nature's Mantle",
      weight: 1, size: [2, 3], baseValue: 750, icon: '🍃',
      equipSlot: 'cloak', requiresAttunement: true,
      rarity: 'uncommon',
      description: 'Uncommon. Requires attunement by a druid or ranger. While wearing this cloak — fashioned from natural materials such as leaves, vines, and moss — you can take the Hide action as a bonus action on each of your turns, even when you are observed, provided you are in a nonurban natural environment (including underground). TCoE p.126.'
    },
    guardian_emblem: {
      name: 'Guardian Emblem',
      weight: 0.1, size: [1, 1], baseValue: 750, icon: '🛡️',
      equipSlot: 'neck', requiresAttunement: true,
      rarity: 'uncommon',
      charges: 3, maxCharges: 3, rechargeType: 'dawn',
      description: 'Uncommon. Requires attunement. This emblem has 3 charges. When you fail a saving throw, you can use your reaction to expend 1 charge to reroll the saving throw, and you must use the new roll. The emblem regains 1d3 expended charges daily at dawn (partial recharge). TCoE p.126.'
    },
    lubas_tarokka_of_souls: {
      name: "Luba's Tarokka of Souls",
      weight: 1, size: [1, 1], baseValue: 750, icon: '🃏',
      requiresAttunement: true,
      rarity: 'uncommon',
      description: "Uncommon. Requires attunement by a spellcaster. This deck of 54 Tarokka cards holds the captured spirits of long-dead spellcasters. Action: shuffle the deck and draw a card at random; the card grants a one-shot spell or effect determined by the DM-rolled card table. Once a card's spirit has been used, it can't be used again until the deck is shuffled with the lost spirits restored (DM's discretion). TCoE p.126."
    },
    prosthetic_limb: {
      name: 'Prosthetic Limb',
      weight: 0, size: [1, 1], baseValue: 100, icon: '🦾',
      rarity: 'common',
      requiresAttunement: true,
      description: "Common. Requires attunement. This finely crafted artificial limb replaces a missing one — a hand, an arm, a foot, a leg, or a similar body part. While the prosthetic is attached, it functions identically to the part it replaces. You can detach or reattach it as an action, and it can't be removed against your will. It detaches if you die. Attuning to the limb takes 1 hour (not the usual short rest). TCoE p.123."
    }
  },

  // ==========================================================================
  // [APR 30 2026]: Trinkets — PHB p.159 (also reprinted DMG p.164).
  // 100 d100 entries; pure flavor items. Each row has weight ~0.1 lb,
  // 1×1 grid, baseValue 1 gp (PHB doesn't price trinkets so we use 1 gp
  // as a sentinel low-value), icon 🪬 (amulet/trinket emoji),
  // rarity 'common'. The trinkets_phb roll table in
  // src/data/treasureRollTables.js maps every d100 row to one of these IDs.
  // ==========================================================================
  trinkets: {
    trinket_mummified_goblin_hand:        { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🖐️', description: 'A mummified goblin hand', rarity: 'common' },
    trinket_glowing_crystal:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💎', description: 'A piece of crystal that faintly glows in the moonlight', rarity: 'common' },
    trinket_gold_coin_distant_realm:      { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪙', description: 'A gold coin minted in an unknown land', rarity: 'common' },
    trinket_diary_unknown_language:       { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📓', description: "A diary written in a language you don't know", rarity: 'common' },
    trinket_brass_ring_no_remove:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💍', description: 'A brass ring that never tarnishes', rarity: 'common' },
    trinket_old_chess_piece:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '♟️', description: 'An old chess piece made from glass', rarity: 'common' },
    trinket_pair_of_dice_skull:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🎲', description: 'A pair of knucklebone dice with a skull on each face', rarity: 'common' },
    trinket_small_idol_chaos:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🗿', description: 'A small idol depicting a nightmarish creature', rarity: 'common' },
    trinket_rope_necklace_thirteen_knots: { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪢', description: 'A rope necklace with a tiny rock with a hole in the middle', rarity: 'common' },
    trinket_lock_of_giant_hair:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪮', description: "A lock of hair from a hill giant's head", rarity: 'common' },
    trinket_brass_orb_chiming:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔔', description: 'A small brass orb that chimes when shaken', rarity: 'common' },
    trinket_cushion_perfumed:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🛏️', description: 'A small purple velvet cushion', rarity: 'common' },
    trinket_signet_ring_unknown:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💍', description: 'A signet ring with an unknown coat of arms', rarity: 'common' },
    trinket_deck_of_cards_missing:        { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🃏', description: 'A deck of cards with one card missing', rarity: 'common' },
    trinket_skull_no_jaw:                 { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💀', description: 'A small skull without a jawbone', rarity: 'common' },
    trinket_carved_bone_rat:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐀', description: 'A carved bone in the shape of a rat', rarity: 'common' },
    trinket_silver_dragon_locket:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📿', description: 'A silver locket containing a dragon scale', rarity: 'common' },
    trinket_old_book_lock:                { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📕', description: 'An old book with a lock you cannot open', rarity: 'common' },
    trinket_ivory_mug_dwarf:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🍺', description: 'An ivory mug carved with a dwarven face', rarity: 'common' },
    trinket_pipe_smoke_rings:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🚬', description: 'A pipe that blows smoke rings on its own', rarity: 'common' },
    trinket_glass_orb_starlight:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔮', description: 'A glass orb that captures starlight', rarity: 'common' },
    trinket_metal_disk_glyph:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '⚙️', description: 'A metal disk inscribed with an unknown glyph', rarity: 'common' },
    trinket_pirate_eyepatch:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🏴‍☠️', description: 'An eyepatch said to belong to a pirate king', rarity: 'common' },
    trinket_smooth_river_stone:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪨', description: 'A smooth river stone with a face carved in it', rarity: 'common' },
    trinket_three_pressed_flowers:        { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌸', description: 'Three pressed flowers in a wooden box', rarity: 'common' },
    trinket_glass_dragon_eye:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '👁️', description: 'A glass dragon eye', rarity: 'common' },
    trinket_bronze_pyramid:               { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔺', description: 'A bronze pyramid covered in runes', rarity: 'common' },
    trinket_porcelain_wolf_statue:        { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐺', description: 'A porcelain figurine of a howling wolf', rarity: 'common' },
    trinket_glass_jar_brain:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🧠', description: 'A glass jar containing a preserved brain', rarity: 'common' },
    trinket_silver_thimble:               { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪡', description: 'A silver thimble with arcane runes', rarity: 'common' },
    trinket_crystal_lens_aging:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔍', description: 'A crystal lens that ages anything seen through it', rarity: 'common' },
    trinket_iron_key_no_lock:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🗝️', description: 'A small iron key with no matching lock', rarity: 'common' },
    trinket_painted_pebbles:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪨', description: 'A bag of painted pebbles', rarity: 'common' },
    trinket_unicorn_horn_dust:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '✨', description: 'A small vial of dust said to be from a unicorn horn', rarity: 'common' },
    trinket_bone_whistle_summon:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦴', description: 'A bone whistle that calls a familiar bird', rarity: 'common' },
    trinket_owlbear_feather:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪶', description: 'A feather from an owlbear', rarity: 'common' },
    trinket_baby_tooth_orc:               { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦷', description: "An orc's baby tooth on a leather thong", rarity: 'common' },
    trinket_book_riddles:                 { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📖', description: 'A small book of riddles', rarity: 'common' },
    trinket_amber_insect:                 { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🟠', description: 'A piece of amber with an insect inside', rarity: 'common' },
    trinket_doll_scared_face:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪆', description: "A child's doll with a perpetually scared expression", rarity: 'common' },
    trinket_pinecone_evergreen:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌲', description: 'A pinecone from an evergreen forest', rarity: 'common' },
    trinket_dwarven_tankard_carved:       { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🍺', description: 'A dwarven tankard carved with mountain scenes', rarity: 'common' },
    trinket_button_changes_color:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔘', description: 'A brass button that changes color in moonlight', rarity: 'common' },
    trinket_hand_mirror_show_voids:       { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪞', description: 'A hand mirror that occasionally shows other places', rarity: 'common' },
    trinket_jeweled_anklet:               { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💎', description: 'A jeweled anklet with no clasp', rarity: 'common' },
    trinket_brass_compass_no_north:       { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🧭', description: 'A brass compass that never points north', rarity: 'common' },
    trinket_old_diary_smudged:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📓', description: 'An old diary with smudged pages', rarity: 'common' },
    trinket_chunk_lava_warm:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌋', description: "A chunk of black lava that's always warm", rarity: 'common' },
    trinket_kobold_skull_jeweled:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💀', description: 'A kobold skull with jeweled eyes', rarity: 'common' },
    trinket_swan_feather_quill:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪶', description: 'A swan feather quill that never needs ink', rarity: 'common' },
    trinket_glass_paperweight_storm:      { weight: 0.1, size: [1, 1], baseValue: 1, icon: '⛈️', description: 'A glass paperweight with a tiny storm inside', rarity: 'common' },
    trinket_carved_jade_frog:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐸', description: 'A carved jade frog', rarity: 'common' },
    trinket_silk_pouch_acorns:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌰', description: 'A silk pouch containing dried acorns', rarity: 'common' },
    trinket_rusted_gauntlet_warm:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🛡️', description: "A rusted gauntlet that's always warm to the touch", rarity: 'common' },
    trinket_obsidian_arrowhead:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🏹', description: 'An obsidian arrowhead from an ancient battlefield', rarity: 'common' },
    trinket_invitation_party_dead:        { weight: 0.1, size: [1, 1], baseValue: 1, icon: '✉️', description: 'An invitation to a party held by a long-dead noble', rarity: 'common' },
    trinket_lump_clay_morphs:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🟫', description: 'A lump of clay that morphs when no one watches', rarity: 'common' },
    trinket_clockwork_mouse:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐭', description: 'A clockwork mouse that runs on its own', rarity: 'common' },
    trinket_wooden_dragon_ball:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐉', description: 'A wooden ball carved with a dragon', rarity: 'common' },
    trinket_chip_porcelain_doll:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪆', description: 'A chip from a porcelain doll', rarity: 'common' },
    trinket_seed_unknown_plant:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌱', description: 'A seed from an unknown plant', rarity: 'common' },
    trinket_silver_bell_quiet:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔔', description: 'A silver bell that makes no sound', rarity: 'common' },
    trinket_ivory_pawn_warmth:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '♟️', description: 'An ivory chess pawn that is always warm', rarity: 'common' },
    trinket_painted_egg_shell:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🥚', description: 'A painted egg shell from a magical bird', rarity: 'common' },
    trinket_braided_hair_unknown:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪮', description: 'A braid of hair from an unknown person', rarity: 'common' },
    trinket_dried_leaf_silver:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🍃', description: 'A dried leaf with silver veins', rarity: 'common' },
    trinket_book_burial_rites:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '⚰️', description: 'A small book of burial rites', rarity: 'common' },
    trinket_marble_eye_blue:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔵', description: 'A blue marble that looks like an eye', rarity: 'common' },
    trinket_compass_points_home:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🧭', description: 'A compass that points to your home', rarity: 'common' },
    trinket_brass_token_drowned:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪙', description: 'A brass token engraved with a drowned face', rarity: 'common' },
    trinket_quill_self_writes:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🪶', description: 'A quill that writes by itself when you sleep', rarity: 'common' },
    trinket_polished_skull_keychain:      { weight: 0.1, size: [1, 1], baseValue: 1, icon: '💀', description: 'A small polished skull on a keychain', rarity: 'common' },
    trinket_carved_wooden_falcon:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦅', description: 'A carved wooden falcon', rarity: 'common' },
    trinket_paper_charm_eternal:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📜', description: 'A paper charm that never tears or burns', rarity: 'common' },
    trinket_silver_thread_strong:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🧵', description: 'A spool of silver thread that never breaks', rarity: 'common' },
    trinket_book_dreams:                  { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📕', description: 'A book of dreams written by a stranger', rarity: 'common' },
    trinket_gold_filigree_lace:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🧣', description: 'A gold-filigree lace handkerchief', rarity: 'common' },
    trinket_yellow_stone_warmth:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🟡', description: 'A yellow stone that radiates faint warmth', rarity: 'common' },
    trinket_iron_pendant_sigil:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📿', description: 'An iron pendant with a strange sigil', rarity: 'common' },
    trinket_silver_pin_thorns:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌹', description: 'A silver pin shaped like thorns', rarity: 'common' },
    trinket_clay_jar_perfume:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🏺', description: 'A clay jar of perfume from a forgotten land', rarity: 'common' },
    trinket_carved_walking_stick:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦯', description: 'A carved walking stick with a wolf head', rarity: 'common' },
    trinket_glass_eye_blinks:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '👁️', description: 'A glass eye that occasionally blinks', rarity: 'common' },
    trinket_kelp_braided:                 { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌿', description: 'A braided strand of kelp from a deep-sea diver', rarity: 'common' },
    trinket_mock_diary_humor:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📒', description: "A book that's actually a comic written in elven", rarity: 'common' },
    trinket_old_pewter_locket:            { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📿', description: 'An old pewter locket with no portrait inside', rarity: 'common' },
    trinket_iron_arrowhead_blood:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🏹', description: 'An iron arrowhead stained with old blood', rarity: 'common' },
    trinket_petrified_mouse_paw:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐭', description: 'A petrified mouse paw on a string', rarity: 'common' },
    trinket_glass_egg_swirling:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🥚', description: 'A glass egg with swirling colors inside', rarity: 'common' },
    trinket_porcelain_chest_lock:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📦', description: 'A porcelain chest with a tiny golden lock', rarity: 'common' },
    trinket_iron_band_skin:               { weight: 0.1, size: [1, 1], baseValue: 1, icon: '⚙️', description: "An iron band that won't come off your wrist", rarity: 'common' },
    trinket_book_shadow_eyes:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '📖', description: 'A book whose pages contain shadow-eye patterns', rarity: 'common' },
    trinket_horn_curling_smoke:           { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🎺', description: 'A small carved horn that wisps smoke when blown', rarity: 'common' },
    trinket_seashell_voices:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🐚', description: 'A seashell that whispers your name', rarity: 'common' },
    trinket_carved_giraffe_horn:          { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦒', description: 'A carved horn from a fey giraffe', rarity: 'common' },
    trinket_bronze_lion_paw:              { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦁', description: 'A bronze lion paw without its lion', rarity: 'common' },
    trinket_clockwork_finger_brass:       { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🦾', description: 'A clockwork brass finger that twitches', rarity: 'common' },
    trinket_seed_pod_dust:                { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🌰', description: 'A dried seed pod that releases golden dust when shaken', rarity: 'common' },
    trinket_wooden_die_runic:             { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🎲', description: 'A wooden die with runes for faces', rarity: 'common' },
    trinket_curled_quill_phoenix:         { weight: 0.1, size: [1, 1], baseValue: 1, icon: '🔥', description: 'A curled quill said to have come from a phoenix', rarity: 'common' },
  },

  containers: {
    // Mundane containers
    pouch: { weight: 1, size: [1, 1], baseValue: 0.5, icon: '👝', containerSlots: [2, 2], weightReduction: 0, containerSize: 'tiny', maxWeight: 6 },
    belt_pouch: { weight: 0.5, size: [1, 1], baseValue: 0.5, icon: '👛', containerSlots: [2, 2], weightReduction: 0, containerSize: 'tiny', maxWeight: 6 },
    sack: { weight: 0.5, size: [2, 2], baseValue: 0.01, icon: '💰', containerSlots: [4, 4], weightReduction: 0, containerSize: 'small', maxWeight: 30 },
    backpack: { weight: 5, size: [3, 3], baseValue: 2, icon: '🎒', containerSlots: [6, 8], weightReduction: 0, containerSize: 'large', maxWeight: 30 },
    barrel: { weight: 70, size: [3, 3], baseValue: 2, icon: '🛢️', containerSlots: [6, 6], weightReduction: 0, containerSize: 'huge', maxWeight: 400 },
    basket: { weight: 2, size: [2, 2], baseValue: 0.4, icon: '🧺', containerSlots: [4, 4], weightReduction: 0, containerSize: 'medium', maxWeight: 40 },
    bottle: { weight: 2, size: [1, 1], baseValue: 2, icon: '🍾', containerSlots: [1, 1], weightReduction: 0, containerSize: 'tiny', maxWeight: 1.5 },
    bucket: { weight: 2, size: [2, 2], baseValue: 0.05, icon: '🪣', containerSlots: [3, 3], weightReduction: 0, containerSize: 'small', maxWeight: 20 },
    case_map: { weight: 1, size: [1, 2], baseValue: 1, icon: '📜', containerSlots: [2, 3], weightReduction: 0, containerSize: 'small', maxWeight: 10 },
    case_crossbow_bolt: { weight: 1, size: [1, 2], baseValue: 1, icon: '🏹', containerSlots: [2, 3], weightReduction: 0, containerSize: 'small', maxWeight: 10 },
    chest: { weight: 25, size: [3, 2], baseValue: 5, icon: '📦', containerSlots: [8, 10], weightReduction: 0, containerSize: 'huge', maxWeight: 300 },
    quiver: { weight: 1, size: [1, 2], baseValue: 1, icon: '🏹', containerSlots: [3, 3], weightReduction: 0, containerSize: 'small', maxWeight: 5, description: 'Holds arrows or bolts' },
    purse: { weight: 0.5, size: [1, 1], baseValue: 0.5, icon: '👛', containerSlots: [2, 2], weightReduction: 0, containerSize: 'tiny', maxWeight: 6, description: 'Small purse for coins' },

    // Q12 (2026-05-16): containers.bag_of_holding removed — canonical lives
    //   in magical_items bucket (line ~1253). The container copy had the
    //   correct weightReduction scale (1.0 = 100%) but a stale name (no
    //   `name` field), and getItemDefinition()'s bucket-order dedup was
    //   hitting magical_items first anyway. The magical_items entry's
    //   weightReduction has been corrected from 100 → 1.0 to match the
    //   canonical 0–1 scale used by InventoryItem at App.jsx:437.
    handy_haversack: {
      weight: 5, 
      size: [2, 3], 
      baseValue: 2000, 
      icon: '🎒', 
      containerSlots: [8, 8], 
      weightReduction: 0.95, // 95% weight reduction
      containerSize: 'extradimensional', 
      maxWeight: 120,
      description: 'This backpack has a central pouch and two side pouches. Retrieving an item is a bonus action.',
      rarity: 'rare',
      requiresAttunement: false,
      extradimensional: true
    },
    portable_hole: { 
      weight: 0, 
      size: [1, 1], 
      baseValue: 8000, 
      icon: '⚫', 
      containerSlots: [20, 20], 
      weightReduction: 1.0,
      containerSize: 'extradimensional', 
      maxWeight: 10000,
      description: 'When unfolded, a portable hole is 6 feet in diameter and 10 feet deep.',
      rarity: 'rare',
      requiresAttunement: false,
      extradimensional: true
    },
    bag_of_devouring: { 
      weight: 15, 
      size: [2, 2], 
      baseValue: 4000, 
      icon: '👹', 
      containerSlots: [8, 8], 
      weightReduction: 1.0,
      containerSize: 'extradimensional', 
      maxWeight: 500,
      description: 'This bag is actually a feeding orifice for a gigantic extradimensional creature. Animate objects are devoured!',
      rarity: 'very rare',
      requiresAttunement: false,
      extradimensional: true,
      cursed: true
    }
  }
};

// ========================================
// ITEM LOOKUP HELPER
// ========================================
//
// [P1.2+P1.3 fix - Apr 29, 2026]: Single canonical lookup for BASE_ITEMS.
// Multiple shop-generation paths in App.jsx open-coded the same loop:
//
//   for (const category of Object.keys(BASE_ITEMS)) {
//     if (BASE_ITEMS[category][itemName]) { ... }
//   }
//
// Centralizing the lookup means BOTH:
//   - Future changes to BASE_ITEMS shape (e.g., grouping subcategories)
//     can be absorbed in one helper instead of N call sites.
//   - Misses get a single console.warn site instead of one per consumer.
//
// Returns { category, entry } on hit, or null on miss. Returns null
// safely for null/undefined/empty input. Walks BASE_ITEMS depth-first
// (currently only one level deep — categories are flat — but the
// helper is recursive in case future content adds nested groups).
//
// Memoization keeps lookups O(1) after first walk; cache is invalidated
// only on full-page reload (BASE_ITEMS is module-scope const).

let _itemLookupCache = null;
function _buildItemLookup() {
  const cache = new Map();
  function walk(node) {
    if (!node || typeof node !== 'object') return;
    for (const [key, value] of Object.entries(node)) {
      if (value && typeof value === 'object') {
        // Heuristic: an item entry has at least one of these scalar fields.
        // A category container is a plain object whose values are entries.
        const isEntry =
          typeof value.baseValue === 'number' ||
          typeof value.weight === 'number' ||
          typeof value.damage === 'string' ||
          typeof value.icon === 'string';
        if (isEntry) {
          if (!cache.has(key)) cache.set(key, { entry: value });
        } else {
          walk(value);
        }
      }
    }
  }
  // Track category for each top-level entry — that's the shape consumers expect.
  for (const [category, contents] of Object.entries(BASE_ITEMS)) {
    if (contents && typeof contents === 'object') {
      for (const [itemId, entry] of Object.entries(contents)) {
        if (entry && typeof entry === 'object') {
          if (!cache.has(itemId)) {
            cache.set(itemId, { category, entry });
          }
        }
      }
    }
  }
  // Then walk recursively for any nested subcategories (none today, but
  // the helper handles future restructures gracefully).
  walk(BASE_ITEMS);
  return cache;
}

export function getItemDefinition(itemId) {
  if (!itemId || typeof itemId !== 'string') return null;
  if (!_itemLookupCache) _itemLookupCache = _buildItemLookup();
  return _itemLookupCache.get(itemId) || null;
}

export const STARTER_PACKS = {
  'dungeoneer': {
    name: "Dungeoneer's Pack",
    cost: 12,
    items: [
      { type: 'backpack', category: 'containers', isMain: true },
      { type: 'crowbar', category: 'items', inContainer: true },
      { type: 'hammer', category: 'items', inContainer: true },
      { type: 'piton', category: 'items', quantity: 10, inContainer: true },
      { type: 'torch', category: 'items', quantity: 10, inContainer: true },
      { type: 'tinderbox', category: 'items', inContainer: true },
      { type: 'rations', category: 'food', quantity: 10, inContainer: true }, // Q12 (2026-05-16): moved from 'items' to 'food' bucket after dup-key cleanup
      { type: 'waterskin', category: 'items', inContainer: true },
      { type: 'rope_hempen_50ft', category: 'items', inContainer: true } // [PHASE 10 - NOV 20, 2025]: Fixed to use 50ft version (D&D 5e PHB accurate)
    ]
  },
  'explorer': {
    name: "Explorer's Pack",
    cost: 10,
    items: [
      { type: 'backpack', category: 'containers', isMain: true },
      { type: 'bedroll', category: 'items', inContainer: true },
      { type: 'mess_kit', category: 'items', inContainer: true },
      { type: 'tinderbox', category: 'items', inContainer: true },
      { type: 'torch', category: 'items', quantity: 10, inContainer: true },
      { type: 'rations', category: 'food', quantity: 10, inContainer: true }, // Q12 (2026-05-16): moved from 'items' to 'food' bucket after dup-key cleanup
      { type: 'waterskin', category: 'items', inContainer: true },
      { type: 'rope_hempen_50ft', category: 'items', inContainer: true } // [PHASE 10 - NOV 20, 2025]: Fixed to use 50ft version (D&D 5e PHB accurate)
    ]
  },
  'scholar': {
    name: "Scholar's Pack",
    cost: 40,
    items: [
      { type: 'backpack', category: 'containers', isMain: true },
      { type: 'book', category: 'items', inContainer: true },
      { type: 'ink', category: 'items', inContainer: true },
      { type: 'ink_pen', category: 'items', inContainer: true },
      { type: 'parchment', category: 'items', quantity: 10, inContainer: true },
      { type: 'pouch', category: 'containers', inContainer: false }
    ]
  },
  'priest': {
    name: "Priest's Pack",
    cost: 19,
    items: [
      { type: 'backpack', category: 'containers', isMain: true },
      { type: 'blanket', category: 'items', inContainer: true },
      { type: 'candle', category: 'items', quantity: 10, inContainer: true },
      { type: 'tinderbox', category: 'items', inContainer: true },
      { type: 'holy_symbol', category: 'items', inContainer: true },
      { type: 'rations', category: 'food', quantity: 2, inContainer: true }, // Q12 (2026-05-16)
      { type: 'waterskin', category: 'items', inContainer: true }
    ]
  },
  'burglar': {
    name: "Burglar's Pack",
    cost: 16,
    items: [
      { type: 'backpack', category: 'containers', isMain: true },
      { type: 'ball_bearings', category: 'items', inContainer: true },
      { type: 'bell', category: 'items', inContainer: true },
      { type: 'candle', category: 'items', quantity: 5, inContainer: true },
      { type: 'crowbar', category: 'items', inContainer: true },
      { type: 'hammer', category: 'items', inContainer: true },
      { type: 'piton', category: 'items', quantity: 10, inContainer: true },
      { type: 'lantern_hooded', category: 'items', inContainer: true },
      { type: 'oil_flask', category: 'items', quantity: 2, inContainer: true },
      { type: 'rations', category: 'food', quantity: 5, inContainer: true }, // Q12 (2026-05-16)
      { type: 'tinderbox', category: 'items', inContainer: true },
      { type: 'waterskin', category: 'items', inContainer: true },
      { type: 'rope_hempen_50ft', category: 'items', inContainer: true } // [PHASE 10 - NOV 20, 2025]: Fixed to use 50ft version (D&D 5e PHB accurate)
    ]
  },
  'diplomat': {
    name: "Diplomat's Pack",
    cost: 39,
    items: [
      { type: 'chest', category: 'containers', isMain: true },
      { type: 'case_map', category: 'containers', inContainer: true },
      { type: 'clothes_fine', category: 'items', inContainer: true },
      { type: 'ink', category: 'items', inContainer: true },
      { type: 'ink_pen', category: 'items', inContainer: true },
      { type: 'lamp', category: 'items', inContainer: true },
      { type: 'oil_flask', category: 'items', quantity: 2, inContainer: true },
      { type: 'paper', category: 'items', quantity: 5, inContainer: true },
      { type: 'perfume', category: 'items', inContainer: true },
      { type: 'sealing_wax', category: 'items', inContainer: true },
      { type: 'soap', category: 'items', inContainer: true }
    ]
  },
  'entertainer': {
    name: "Entertainer's Pack",
    cost: 40,
    items: [
      { type: 'backpack', category: 'containers', isMain: true },
      { type: 'bedroll', category: 'items', inContainer: true },
      { type: 'clothes_costume', category: 'items', quantity: 2, inContainer: true },
      { type: 'candle', category: 'items', quantity: 5, inContainer: true },
      { type: 'rations', category: 'food', quantity: 5, inContainer: true }, // Q12 (2026-05-16)
      { type: 'waterskin', category: 'items', inContainer: true },
      { type: 'disguise_kit', category: 'tools', inContainer: true }
    ]
  }
};